
/**
CREATIVE CODING
---
Kill server : CTRL + C
Start server : npm run start
Start secure server : npm run start-https
Final build : npm run build
---
To generate new certificate for https connection with external device run :
#sh
mkcert 0.0.0.0 localhost 127.0.0.1 yourLocalIP ::1
mv 0.0.0.0+4-key.pem certificate.key
mv 0.0.0.0+4.pem certificate.cert
**/ // import Playground from "@onemorestudio/playgroundjs";
var $d6dfe69d5b5dbd82$exports = {};
$d6dfe69d5b5dbd82$exports = /******/ function(modules) {
    /******/ // The module cache
    /******/ var installedModules = {};
    /******/ /******/ // The require function
    /******/ function __webpack_require__(moduleId) {
        /******/ /******/ // Check if module is in cache
        /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
        /******/ // Create a new module (and put it into the cache)
        /******/ var module1 = installedModules[moduleId] = {
            /******/ i: moduleId,
            /******/ l: false,
            /******/ exports: {}
        };
        /******/ /******/ // Execute the module function
        /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
        /******/ /******/ // Flag the module as loaded
        /******/ module1.l = true;
        /******/ /******/ // Return the exports of the module
        /******/ return module1.exports;
    /******/ }
    /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
    /******/ __webpack_require__.m = modules;
    /******/ /******/ // expose the module cache
    /******/ __webpack_require__.c = installedModules;
    /******/ /******/ // define getter function for harmony exports
    /******/ __webpack_require__.d = function(exports, name, getter) {
        /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
            /******/ configurable: false,
            /******/ enumerable: true,
            /******/ get: getter
        });
    /******/ };
    /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/ __webpack_require__.n = function(module1) {
        /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
            return module1["default"];
        } : /******/ function getModuleExports() {
            return module1;
        };
        /******/ __webpack_require__.d(getter, "a", getter);
        /******/ return getter;
    /******/ };
    /******/ /******/ // Object.prototype.hasOwnProperty.call
    /******/ __webpack_require__.o = function(object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/ /******/ // __webpack_public_path__
    /******/ __webpack_require__.p = "";
    /******/ /******/ // Load entry module and return exports
    /******/ return __webpack_require__(__webpack_require__.s = 1);
/******/ }([
    /* 0 */ /***/ function(module1, exports, __webpack_require__) {
        "use strict";
        var DEVICE_TYPES = {
            MOBILE: "mobile",
            TABLET: "tablet",
            SMART_TV: "smarttv",
            CONSOLE: "console",
            WEARABLE: "wearable",
            BROWSER: undefined
        };
        var BROWSER_TYPES = {
            CHROME: "Chrome",
            FIREFOX: "Firefox",
            OPERA: "Opera",
            YANDEX: "Yandex",
            SAFARI: "Safari",
            INTERNET_EXPLORER: "Internet Explorer",
            EDGE: "Edge",
            CHROMIUM: "Chromium",
            IE: "IE",
            MOBILE_SAFARI: "Mobile Safari",
            EDGE_CHROMIUM: "Edge Chromium"
        };
        var OS_TYPES = {
            IOS: "iOS",
            ANDROID: "Android",
            WINDOWS_PHONE: "Windows Phone",
            WINDOWS: "Windows",
            MAC_OS: "Mac OS"
        };
        var defaultData = {
            isMobile: false,
            isTablet: false,
            isBrowser: false,
            isSmartTV: false,
            isConsole: false,
            isWearable: false
        };
        module1.exports = {
            BROWSER_TYPES: BROWSER_TYPES,
            DEVICE_TYPES: DEVICE_TYPES,
            OS_TYPES: OS_TYPES,
            defaultData: defaultData
        };
    /***/ },
    /* 1 */ /***/ function(module1, exports, __webpack_require__) {
        "use strict";
        var UAParser = __webpack_require__(2);
        var _require = __webpack_require__(0), BROWSER_TYPES = _require.BROWSER_TYPES, OS_TYPES = _require.OS_TYPES, DEVICE_TYPES = _require.DEVICE_TYPES;
        var _require2 = __webpack_require__(4), checkType = _require2.checkType, broPayload = _require2.broPayload, mobilePayload = _require2.mobilePayload, wearPayload = _require2.wearPayload, consolePayload = _require2.consolePayload, stvPayload = _require2.stvPayload, getNavigatorInstance = _require2.getNavigatorInstance, isIOS13Check = _require2.isIOS13Check;
        var UA = new UAParser();
        var browser = UA.getBrowser();
        var device = UA.getDevice();
        var engine = UA.getEngine();
        var os = UA.getOS();
        var ua = UA.getUA();
        var CHROME = BROWSER_TYPES.CHROME, CHROMIUM = BROWSER_TYPES.CHROMIUM, IE = BROWSER_TYPES.IE, INTERNET_EXPLORER = BROWSER_TYPES.INTERNET_EXPLORER, OPERA = BROWSER_TYPES.OPERA, FIREFOX = BROWSER_TYPES.FIREFOX, SAFARI = BROWSER_TYPES.SAFARI, EDGE = BROWSER_TYPES.EDGE, YANDEX = BROWSER_TYPES.YANDEX, MOBILE_SAFARI = BROWSER_TYPES.MOBILE_SAFARI;
        var MOBILE = DEVICE_TYPES.MOBILE, TABLET = DEVICE_TYPES.TABLET, SMART_TV = DEVICE_TYPES.SMART_TV, BROWSER = DEVICE_TYPES.BROWSER, WEARABLE = DEVICE_TYPES.WEARABLE, CONSOLE = DEVICE_TYPES.CONSOLE;
        var ANDROID = OS_TYPES.ANDROID, WINDOWS_PHONE = OS_TYPES.WINDOWS_PHONE, IOS = OS_TYPES.IOS, WINDOWS = OS_TYPES.WINDOWS, MAC_OS = OS_TYPES.MAC_OS;
        var isMobileType = function isMobileType() {
            return device.type === MOBILE;
        };
        var isTabletType = function isTabletType() {
            return device.type === TABLET;
        };
        var isMobileAndTabletType = function isMobileAndTabletType() {
            switch(device.type){
                case MOBILE:
                case TABLET:
                    return true;
                default:
                    return false;
            }
        };
        var isEdgeChromiumType = function isEdgeChromiumType() {
            if (os.name === OS_TYPES.WINDOWS && os.version === "10") return typeof ua === "string" && ua.indexOf("Edg/") !== -1;
            return false;
        };
        var isSmartTVType = function isSmartTVType() {
            return device.type === SMART_TV;
        };
        var isBrowserType = function isBrowserType() {
            return device.type === BROWSER;
        };
        var isWearableType = function isWearableType() {
            return device.type === WEARABLE;
        };
        var isConsoleType = function isConsoleType() {
            return device.type === CONSOLE;
        };
        var isAndroidType = function isAndroidType() {
            return os.name === ANDROID;
        };
        var isWindowsType = function isWindowsType() {
            return os.name === WINDOWS;
        };
        var isMacOsType = function isMacOsType() {
            return os.name === MAC_OS;
        };
        var isWinPhoneType = function isWinPhoneType() {
            return os.name === WINDOWS_PHONE;
        };
        var isIOSType = function isIOSType() {
            return os.name === IOS;
        };
        var isChromeType = function isChromeType() {
            return browser.name === CHROME;
        };
        var isFirefoxType = function isFirefoxType() {
            return browser.name === FIREFOX;
        };
        var isChromiumType = function isChromiumType() {
            return browser.name === CHROMIUM;
        };
        var isEdgeType = function isEdgeType() {
            return browser.name === EDGE;
        };
        var isYandexType = function isYandexType() {
            return browser.name === YANDEX;
        };
        var isSafariType = function isSafariType() {
            return browser.name === SAFARI || browser.name === MOBILE_SAFARI;
        };
        var isMobileSafariType = function isMobileSafariType() {
            return browser.name === MOBILE_SAFARI;
        };
        var isOperaType = function isOperaType() {
            return browser.name === OPERA;
        };
        var isIEType = function isIEType() {
            return browser.name === INTERNET_EXPLORER || browser.name === IE;
        };
        var isElectronType = function isElectronType() {
            var nav = getNavigatorInstance();
            var ua = nav && nav.userAgent.toLowerCase();
            return typeof ua === "string" ? /electron/.test(ua) : false;
        };
        var getIOS13 = function getIOS13() {
            var nav = getNavigatorInstance();
            return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === "MacIntel" && nav.maxTouchPoints > 1) && !window.MSStream;
        };
        var getIPad13 = function getIPad13() {
            return isIOS13Check("iPad");
        };
        var getIphone13 = function getIphone13() {
            return isIOS13Check("iPhone");
        };
        var getIPod13 = function getIPod13() {
            return isIOS13Check("iPod");
        };
        var getBrowserFullVersion = function getBrowserFullVersion() {
            return browser.major;
        };
        var getBrowserVersion = function getBrowserVersion() {
            return browser.version;
        };
        var getOsVersion = function getOsVersion() {
            return os.version ? os.version : "none";
        };
        var getOsName = function getOsName() {
            return os.name ? os.name : "none";
        };
        var getBrowserName = function getBrowserName() {
            return browser.name;
        };
        var getMobileVendor = function getMobileVendor() {
            return device.vendor ? device.vendor : "none";
        };
        var getMobileModel = function getMobileModel() {
            return device.model ? device.model : "none";
        };
        var getEngineName = function getEngineName() {
            return engine.name;
        };
        var getEngineVersion = function getEngineVersion() {
            return engine.version;
        };
        var getUseragent = function getUseragent() {
            return ua;
        };
        var getDeviceType = function getDeviceType() {
            return device.type;
        };
        var isSmartTV = isSmartTVType();
        var isConsole = isConsoleType();
        var isWearable = isWearableType();
        var isMobileSafari = isMobileSafariType() || getIPad13();
        var isChromium = isChromiumType();
        var isMobile = isMobileAndTabletType() || getIPad13();
        var isMobileOnly = isMobileType();
        var isTablet = isTabletType() || getIPad13();
        var isBrowser = isBrowserType();
        var isAndroid = isAndroidType();
        var isWinPhone = isWinPhoneType();
        var isIOS = isIOSType() || getIPad13();
        var isChrome = isChromeType();
        var isFirefox = isFirefoxType();
        var isSafari = isSafariType();
        var isOpera = isOperaType();
        var isIE = isIEType();
        var osVersion = getOsVersion();
        var osName = getOsName();
        var fullBrowserVersion = getBrowserFullVersion();
        var browserVersion = getBrowserVersion();
        var browserName = getBrowserName();
        var mobileVendor = getMobileVendor();
        var mobileModel = getMobileModel();
        var engineName = getEngineName();
        var engineVersion = getEngineVersion();
        var getUA = getUseragent();
        var isEdge = isEdgeType() || isEdgeChromiumType();
        var isYandex = isYandexType();
        var deviceType = getDeviceType();
        var isIOS13 = getIOS13();
        var isIPad13 = getIPad13();
        var isIPhone13 = getIphone13();
        var isIPod13 = getIPod13();
        var isElectron = isElectronType();
        var isEdgeChromium = isEdgeChromiumType();
        var isLegacyEdge = isEdgeType();
        var isWindows = isWindowsType();
        var isMacOs = isMacOsType();
        var type = checkType(device.type);
        function deviceDetect() {
            var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable;
            if (isBrowser) return broPayload(isBrowser, browser, engine, os, ua);
            if (isSmartTV) return stvPayload(isSmartTV, engine, os, ua);
            if (isConsole) return consolePayload(isConsole, engine, os, ua);
            if (isMobile) return mobilePayload(type, device, os, ua);
            if (isTablet) return mobilePayload(type, device, os, ua);
            if (isWearable) return wearPayload(isWearable, engine, os, ua);
        }
        module1.exports = {
            deviceDetect: deviceDetect,
            isSmartTV: isSmartTV,
            isConsole: isConsole,
            isWearable: isWearable,
            isMobileSafari: isMobileSafari,
            isChromium: isChromium,
            isMobile: isMobile,
            isMobileOnly: isMobileOnly,
            isTablet: isTablet,
            isBrowser: isBrowser,
            isAndroid: isAndroid,
            isWinPhone: isWinPhone,
            isIOS: isIOS,
            isChrome: isChrome,
            isFirefox: isFirefox,
            isSafari: isSafari,
            isOpera: isOpera,
            isIE: isIE,
            osVersion: osVersion,
            osName: osName,
            fullBrowserVersion: fullBrowserVersion,
            browserVersion: browserVersion,
            browserName: browserName,
            mobileVendor: mobileVendor,
            mobileModel: mobileModel,
            engineName: engineName,
            engineVersion: engineVersion,
            getUA: getUA,
            isEdge: isEdge,
            isYandex: isYandex,
            deviceType: deviceType,
            isIOS13: isIOS13,
            isIPad13: isIPad13,
            isIPhone13: isIPhone13,
            isIPod13: isIPod13,
            isElectron: isElectron,
            isEdgeChromium: isEdgeChromium,
            isLegacyEdge: isLegacyEdge,
            isWindows: isWindows,
            isMacOs: isMacOs
        };
    /***/ },
    /* 2 */ /***/ function(module1, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_RESULT__; /*!
 * UAParser.js v0.7.18
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 or MIT
 */ 
        (function(window1, undefined1) {
            "use strict";
            var LIBVERSION = "0.7.18", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded";
            var util = {
                extend: function(regexes, extensions) {
                    var margedRegexes = {};
                    for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) margedRegexes[i] = extensions[i].concat(regexes[i]);
                    else margedRegexes[i] = regexes[i];
                    return margedRegexes;
                },
                has: function(str1, str2) {
                    if (typeof str1 === "string") return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
                    else return false;
                },
                lowerize: function(str) {
                    return str.toLowerCase();
                },
                major: function(version) {
                    return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, "").split(".")[0] : undefined1;
                },
                trim: function(str) {
                    return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
                }
            };
            var mapper = {
                rgx: function(ua, arrays) {
                    var i = 0, j, k, p, q, matches, match;
                    while(i < arrays.length && !matches){
                        var regex = arrays[i], props = arrays[i + 1];
                        j = k = 0;
                        while(j < regex.length && !matches){
                            matches = regex[j++].exec(ua);
                            if (!!matches) for(p = 0; p < props.length; p++){
                                match = matches[++k];
                                q = props[p];
                                if (typeof q === OBJ_TYPE && q.length > 0) {
                                    if (q.length == 2) {
                                        if (typeof q[1] == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                                        else this[q[0]] = q[1];
                                    } else if (q.length == 3) {
                                        if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined1;
                                        else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined1;
                                    } else if (q.length == 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined1;
                                } else this[q] = match ? match : undefined1;
                            }
                        }
                        i += 2;
                    }
                },
                str: function(str, map) {
                    for(var i in map){
                        if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                            if (util.has(map[i][j], str)) return i === UNKNOWN ? undefined1 : i;
                        }
                        else if (util.has(map[i], str)) return i === UNKNOWN ? undefined1 : i;
                    }
                    return str;
                }
            };
            var maps = {
                browser: {
                    oldsafari: {
                        version: {
                            "1.0": "/8",
                            1.2: "/1",
                            1.3: "/3",
                            "2.0": "/412",
                            "2.0.2": "/416",
                            "2.0.3": "/417",
                            "2.0.4": "/419",
                            "?": "/"
                        }
                    }
                },
                device: {
                    amazon: {
                        model: {
                            "Fire Phone": [
                                "SD",
                                "KF"
                            ]
                        }
                    },
                    sprint: {
                        model: {
                            "Evo Shift 4G": "7373KT"
                        },
                        vendor: {
                            HTC: "APA",
                            Sprint: "Sprint"
                        }
                    }
                },
                os: {
                    windows: {
                        version: {
                            ME: "4.90",
                            "NT 3.11": "NT3.51",
                            "NT 4.0": "NT4.0",
                            2000: "NT 5.0",
                            XP: [
                                "NT 5.1",
                                "NT 5.2"
                            ],
                            Vista: "NT 6.0",
                            7: "NT 6.1",
                            8: "NT 6.2",
                            8.1: "NT 6.3",
                            10: [
                                "NT 6.4",
                                "NT 10.0"
                            ],
                            RT: "ARM"
                        }
                    }
                }
            };
            var regexes = {
                browser: [
                    [
                        /(opera\smini)\/([\w\.-]+)/i,
                        /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,
                        /(opera).+version\/([\w\.]+)/i,
                        /(opera)[\/\s]+([\w\.]+)/i
                    ],
                    [
                        NAME,
                        VERSION
                    ],
                    [
                        /(opios)[\/\s]+([\w\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            "Opera Mini"
                        ],
                        VERSION
                    ],
                    [
                        /\s(opr)\/([\w\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            "Opera"
                        ],
                        VERSION
                    ],
                    [
                        /(kindle)\/([\w\.]+)/i,
                        /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
                        /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
                        /(?:ms|\()(ie)\s([\w\.]+)/i,
                        /(rekonq)\/([\w\.]*)/i,
                        /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark)\/([\w\.-]+)/i
                    ],
                    [
                        NAME,
                        VERSION
                    ],
                    [
                        /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i
                    ],
                    [
                        [
                            NAME,
                            "IE"
                        ],
                        VERSION
                    ],
                    [
                        /(edge|edgios|edgea)\/((\d+)?[\w\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            "Edge"
                        ],
                        VERSION
                    ],
                    [
                        /(yabrowser)\/([\w\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            "Yandex"
                        ],
                        VERSION
                    ],
                    [
                        /(puffin)\/([\w\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            "Puffin"
                        ],
                        VERSION
                    ],
                    [
                        /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            "UCBrowser"
                        ],
                        VERSION
                    ],
                    [
                        /(comodo_dragon)\/([\w\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            /_/g,
                            " "
                        ],
                        VERSION
                    ],
                    [
                        /(micromessenger)\/([\w\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            "WeChat"
                        ],
                        VERSION
                    ],
                    [
                        /(qqbrowserlite)\/([\w\.]+)/i
                    ],
                    [
                        NAME,
                        VERSION
                    ],
                    [
                        /(QQ)\/([\d\.]+)/i
                    ],
                    [
                        NAME,
                        VERSION
                    ],
                    [
                        /m?(qqbrowser)[\/\s]?([\w\.]+)/i
                    ],
                    [
                        NAME,
                        VERSION
                    ],
                    [
                        /(BIDUBrowser)[\/\s]?([\w\.]+)/i
                    ],
                    [
                        NAME,
                        VERSION
                    ],
                    [
                        /(2345Explorer)[\/\s]?([\w\.]+)/i
                    ],
                    [
                        NAME,
                        VERSION
                    ],
                    [
                        /(MetaSr)[\/\s]?([\w\.]+)/i
                    ],
                    [
                        NAME
                    ],
                    [
                        /(LBBROWSER)/i
                    ],
                    [
                        NAME
                    ],
                    [
                        /xiaomi\/miuibrowser\/([\w\.]+)/i
                    ],
                    [
                        VERSION,
                        [
                            NAME,
                            "MIUI Browser"
                        ]
                    ],
                    [
                        /;fbav\/([\w\.]+);/i
                    ],
                    [
                        VERSION,
                        [
                            NAME,
                            "Facebook"
                        ]
                    ],
                    [
                        /headlesschrome(?:\/([\w\.]+)|\s)/i
                    ],
                    [
                        VERSION,
                        [
                            NAME,
                            "Chrome Headless"
                        ]
                    ],
                    [
                        /\swv\).+(chrome)\/([\w\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            /(.+)/,
                            "$1 WebView"
                        ],
                        VERSION
                    ],
                    [
                        /((?:oculus|samsung)browser)\/([\w\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            /(.+(?:g|us))(.+)/,
                            "$1 $2"
                        ],
                        VERSION
                    ],
                    [
                        /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i
                    ],
                    [
                        VERSION,
                        [
                            NAME,
                            "Android Browser"
                        ]
                    ],
                    [
                        /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
                    ],
                    [
                        NAME,
                        VERSION
                    ],
                    [
                        /(dolfin)\/([\w\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            "Dolphin"
                        ],
                        VERSION
                    ],
                    [
                        /((?:android.+)crmo|crios)\/([\w\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            "Chrome"
                        ],
                        VERSION
                    ],
                    [
                        /(coast)\/([\w\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            "Opera Coast"
                        ],
                        VERSION
                    ],
                    [
                        /fxios\/([\w\.-]+)/i
                    ],
                    [
                        VERSION,
                        [
                            NAME,
                            "Firefox"
                        ]
                    ],
                    [
                        /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i
                    ],
                    [
                        VERSION,
                        [
                            NAME,
                            "Mobile Safari"
                        ]
                    ],
                    [
                        /version\/([\w\.]+).+?(mobile\s?safari|safari)/i
                    ],
                    [
                        VERSION,
                        NAME
                    ],
                    [
                        /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            "GSA"
                        ],
                        VERSION
                    ],
                    [
                        /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i
                    ],
                    [
                        NAME,
                        [
                            VERSION,
                            mapper.str,
                            maps.browser.oldsafari.version
                        ]
                    ],
                    [
                        /(konqueror)\/([\w\.]+)/i,
                        /(webkit|khtml)\/([\w\.]+)/i
                    ],
                    [
                        NAME,
                        VERSION
                    ],
                    [
                        /(navigator|netscape)\/([\w\.-]+)/i
                    ],
                    [
                        [
                            NAME,
                            "Netscape"
                        ],
                        VERSION
                    ],
                    [
                        /(swiftfox)/i,
                        /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                        /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,
                        /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,
                        /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                        /(links)\s\(([\w\.]+)/i,
                        /(gobrowser)\/?([\w\.]*)/i,
                        /(ice\s?browser)\/v?([\w\._]+)/i,
                        /(mosaic)[\/\s]([\w\.]+)/i
                    ],
                    [
                        NAME,
                        VERSION
                    ]
                ],
                cpu: [
                    [
                        /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i
                    ],
                    [
                        [
                            ARCHITECTURE,
                            "amd64"
                        ]
                    ],
                    [
                        /(ia32(?=;))/i
                    ],
                    [
                        [
                            ARCHITECTURE,
                            util.lowerize
                        ]
                    ],
                    [
                        /((?:i[346]|x)86)[;\)]/i
                    ],
                    [
                        [
                            ARCHITECTURE,
                            "ia32"
                        ]
                    ],
                    [
                        /windows\s(ce|mobile);\sppc;/i
                    ],
                    [
                        [
                            ARCHITECTURE,
                            "arm"
                        ]
                    ],
                    [
                        /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i
                    ],
                    [
                        [
                            ARCHITECTURE,
                            /ower/,
                            "",
                            util.lowerize
                        ]
                    ],
                    [
                        /(sun4\w)[;\)]/i
                    ],
                    [
                        [
                            ARCHITECTURE,
                            "sparc"
                        ]
                    ],
                    [
                        /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                    ],
                    [
                        [
                            ARCHITECTURE,
                            util.lowerize
                        ]
                    ]
                ],
                device: [
                    [
                        /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i
                    ],
                    [
                        MODEL,
                        VENDOR,
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /applecoremedia\/[\w\.]+ \((ipad)/
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Apple"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /(apple\s{0,1}tv)/i
                    ],
                    [
                        [
                            MODEL,
                            "Apple TV"
                        ],
                        [
                            VENDOR,
                            "Apple"
                        ]
                    ],
                    [
                        /(archos)\s(gamepad2?)/i,
                        /(hp).+(touchpad)/i,
                        /(hp).+(tablet)/i,
                        /(kindle)\/([\w\.]+)/i,
                        /\s(nook)[\w\s]+build\/(\w+)/i,
                        /(dell)\s(strea[kpr\s\d]*[\dko])/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /(kf[A-z]+)\sbuild\/.+silk\//i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Amazon"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i
                    ],
                    [
                        [
                            MODEL,
                            mapper.str,
                            maps.device.amazon.model
                        ],
                        [
                            VENDOR,
                            "Amazon"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /\((ip[honed|\s\w*]+);.+(apple)/i
                    ],
                    [
                        MODEL,
                        VENDOR,
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /\((ip[honed|\s\w*]+);/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Apple"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /(blackberry)[\s-]?(\w+)/i,
                        /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
                        /(hp)\s([\w\s]+\w)/i,
                        /(asus)-?(\w+)/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /\(bb10;\s(\w+)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "BlackBerry"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Asus"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /(sony)\s(tablet\s[ps])\sbuild\//i,
                        /(sony)?(?:sgp.+)\sbuild\//i
                    ],
                    [
                        [
                            VENDOR,
                            "Sony"
                        ],
                        [
                            MODEL,
                            "Xperia Tablet"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Sony"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /\s(ouya)\s/i,
                        /(nintendo)\s([wids3u]+)/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            CONSOLE
                        ]
                    ],
                    [
                        /android.+;\s(shield)\sbuild/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Nvidia"
                        ],
                        [
                            TYPE,
                            CONSOLE
                        ]
                    ],
                    [
                        /(playstation\s[34portablevi]+)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Sony"
                        ],
                        [
                            TYPE,
                            CONSOLE
                        ]
                    ],
                    [
                        /(sprint\s(\w+))/i
                    ],
                    [
                        [
                            VENDOR,
                            mapper.str,
                            maps.device.sprint.vendor
                        ],
                        [
                            MODEL,
                            mapper.str,
                            maps.device.sprint.model
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,
                        /(zte)-(\w*)/i,
                        /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
                    ],
                    [
                        VENDOR,
                        [
                            MODEL,
                            /_/g,
                            " "
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /(nexus\s9)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "HTC"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /d\/huawei([\w\s-]+)[;\)]/i,
                        /(nexus\s6p)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Huawei"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /(microsoft);\s(lumia[\s\w]+)/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /[\s\(;](xbox(?:\sone)?)[\s\);]/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Microsoft"
                        ],
                        [
                            TYPE,
                            CONSOLE
                        ]
                    ],
                    [
                        /(kin\.[onetw]{3})/i
                    ],
                    [
                        [
                            MODEL,
                            /\./g,
                            " "
                        ],
                        [
                            VENDOR,
                            "Microsoft"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
                        /mot[\s-]?(\w*)/i,
                        /(XT\d{3,4}) build\//i,
                        /(nexus\s6)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Motorola"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Motorola"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i
                    ],
                    [
                        [
                            VENDOR,
                            util.trim
                        ],
                        [
                            MODEL,
                            util.trim
                        ],
                        [
                            TYPE,
                            SMARTTV
                        ]
                    ],
                    [
                        /hbbtv.+maple;(\d+)/i
                    ],
                    [
                        [
                            MODEL,
                            /^/,
                            "SmartTV"
                        ],
                        [
                            VENDOR,
                            "Samsung"
                        ],
                        [
                            TYPE,
                            SMARTTV
                        ]
                    ],
                    [
                        /\(dtv[\);].+(aquos)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Sharp"
                        ],
                        [
                            TYPE,
                            SMARTTV
                        ]
                    ],
                    [
                        /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
                        /((SM-T\w+))/i
                    ],
                    [
                        [
                            VENDOR,
                            "Samsung"
                        ],
                        MODEL,
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /smart-tv.+(samsung)/i
                    ],
                    [
                        VENDOR,
                        [
                            TYPE,
                            SMARTTV
                        ],
                        MODEL
                    ],
                    [
                        /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
                        /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,
                        /sec-((sgh\w+))/i
                    ],
                    [
                        [
                            VENDOR,
                            "Samsung"
                        ],
                        MODEL,
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /sie-(\w*)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Siemens"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /(maemo|nokia).*(n900|lumia\s\d+)/i,
                        /(nokia)[\s_-]?([\w-]*)/i
                    ],
                    [
                        [
                            VENDOR,
                            "Nokia"
                        ],
                        MODEL,
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /android\s3\.[\s\w;-]{10}(a\d{3})/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Acer"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+([vl]k\-?\d{3})\s+build/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "LG"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i
                    ],
                    [
                        [
                            VENDOR,
                            "LG"
                        ],
                        MODEL,
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /(lg) netcast\.tv/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            SMARTTV
                        ]
                    ],
                    [
                        /(nexus\s[45])/i,
                        /lg[e;\s\/-]+(\w*)/i,
                        /android.+lg(\-?[\d\w]+)\s+build/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "LG"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /android.+(ideatab[a-z0-9\-\s]+)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Lenovo"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /linux;.+((jolla));/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /((pebble))app\/[\d\.]+\s/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            WEARABLE
                        ]
                    ],
                    [
                        /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /crkey/i
                    ],
                    [
                        [
                            MODEL,
                            "Chromecast"
                        ],
                        [
                            VENDOR,
                            "Google"
                        ]
                    ],
                    [
                        /android.+;\s(glass)\s\d/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Google"
                        ],
                        [
                            TYPE,
                            WEARABLE
                        ]
                    ],
                    [
                        /android.+;\s(pixel c)\s/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Google"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+;\s(pixel xl|pixel)\s/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Google"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /android.+;\s(\w+)\s+build\/hm\1/i,
                        /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,
                        /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,
                        /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i
                    ],
                    [
                        [
                            MODEL,
                            /_/g,
                            " "
                        ],
                        [
                            VENDOR,
                            "Xiaomi"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i
                    ],
                    [
                        [
                            MODEL,
                            /_/g,
                            " "
                        ],
                        [
                            VENDOR,
                            "Xiaomi"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+;\s(m[1-5]\snote)\sbuild/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Meizu"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+a000(1)\s+build/i,
                        /android.+oneplus\s(a\d{4})\s+build/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "OnePlus"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "RCA"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Dell"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Verizon"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i
                    ],
                    [
                        [
                            VENDOR,
                            "Barnes & Noble"
                        ],
                        MODEL,
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "NuVision"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+;\s(k88)\sbuild/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "ZTE"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Swiss"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /android.+[;\/]\s*(zur\d{3})\s+build/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Swiss"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Zeki"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /(android).+[;\/]\s+([YR]\d{2})\s+build/i,
                        /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i
                    ],
                    [
                        [
                            VENDOR,
                            "Dragon Touch"
                        ],
                        MODEL,
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Insignia"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "NextBook"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
                    ],
                    [
                        [
                            VENDOR,
                            "Voice"
                        ],
                        MODEL,
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i
                    ],
                    [
                        [
                            VENDOR,
                            "LvTel"
                        ],
                        MODEL,
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Envizen"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "MachSpeed"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+[;\/]\s*TU_(1491)\s+build/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Rotor"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+(KS(.+))\s+build/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Amazon"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /\s(tablet|tab)[;\/]/i,
                        /\s(mobile)(?:[;\/]|\ssafari)/i
                    ],
                    [
                        [
                            TYPE,
                            util.lowerize
                        ],
                        VENDOR,
                        MODEL
                    ],
                    [
                        /(android[\w\.\s\-]{0,9});.+build/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Generic"
                        ]
                    ]
                ],
                engine: [
                    [
                        /windows.+\sedge\/([\w\.]+)/i
                    ],
                    [
                        VERSION,
                        [
                            NAME,
                            "EdgeHTML"
                        ]
                    ],
                    [
                        /(presto)\/([\w\.]+)/i,
                        /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,
                        /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,
                        /(icab)[\/\s]([23]\.[\d\.]+)/i
                    ],
                    [
                        NAME,
                        VERSION
                    ],
                    [
                        /rv\:([\w\.]{1,9}).+(gecko)/i
                    ],
                    [
                        VERSION,
                        NAME
                    ]
                ],
                os: [
                    [
                        /microsoft\s(windows)\s(vista|xp)/i
                    ],
                    [
                        NAME,
                        VERSION
                    ],
                    [
                        /(windows)\snt\s6\.2;\s(arm)/i,
                        /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,
                        /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
                    ],
                    [
                        NAME,
                        [
                            VERSION,
                            mapper.str,
                            maps.os.windows.version
                        ]
                    ],
                    [
                        /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            "Windows"
                        ],
                        [
                            VERSION,
                            mapper.str,
                            maps.os.windows.version
                        ]
                    ],
                    [
                        /\((bb)(10);/i
                    ],
                    [
                        [
                            NAME,
                            "BlackBerry"
                        ],
                        VERSION
                    ],
                    [
                        /(blackberry)\w*\/?([\w\.]*)/i,
                        /(tizen)[\/\s]([\w\.]+)/i,
                        /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i,
                        /linux;.+(sailfish);/i
                    ],
                    [
                        NAME,
                        VERSION
                    ],
                    [
                        /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i
                    ],
                    [
                        [
                            NAME,
                            "Symbian"
                        ],
                        VERSION
                    ],
                    [
                        /\((series40);/i
                    ],
                    [
                        NAME
                    ],
                    [
                        /mozilla.+\(mobile;.+gecko.+firefox/i
                    ],
                    [
                        [
                            NAME,
                            "Firefox OS"
                        ],
                        VERSION
                    ],
                    [
                        /(nintendo|playstation)\s([wids34portablevu]+)/i,
                        /(mint)[\/\s\(]?(\w*)/i,
                        /(mageia|vectorlinux)[;\s]/i,
                        /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
                        /(hurd|linux)\s?([\w\.]*)/i,
                        /(gnu)\s?([\w\.]*)/i
                    ],
                    [
                        NAME,
                        VERSION
                    ],
                    [
                        /(cros)\s[\w]+\s([\w\.]+\w)/i
                    ],
                    [
                        [
                            NAME,
                            "Chromium OS"
                        ],
                        VERSION
                    ],
                    [
                        /(sunos)\s?([\w\.\d]*)/i
                    ],
                    [
                        [
                            NAME,
                            "Solaris"
                        ],
                        VERSION
                    ],
                    [
                        /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i
                    ],
                    [
                        NAME,
                        VERSION
                    ],
                    [
                        /(haiku)\s(\w+)/i
                    ],
                    [
                        NAME,
                        VERSION
                    ],
                    [
                        /cfnetwork\/.+darwin/i,
                        /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i
                    ],
                    [
                        [
                            VERSION,
                            /_/g,
                            "."
                        ],
                        [
                            NAME,
                            "iOS"
                        ]
                    ],
                    [
                        /(mac\sos\sx)\s?([\w\s\.]*)/i,
                        /(macintosh|mac(?=_powerpc)\s)/i
                    ],
                    [
                        [
                            NAME,
                            "Mac OS"
                        ],
                        [
                            VERSION,
                            /_/g,
                            "."
                        ]
                    ],
                    [
                        /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,
                        /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,
                        /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,
                        /(unix)\s?([\w\.]*)/i
                    ],
                    [
                        NAME,
                        VERSION
                    ]
                ]
            };
            var UAParser = function(uastring, extensions) {
                if (typeof uastring === "object") {
                    extensions = uastring;
                    uastring = undefined1;
                }
                if (!(this instanceof UAParser)) return new UAParser(uastring, extensions).getResult();
                var ua = uastring || (window1 && window1.navigator && window1.navigator.userAgent ? window1.navigator.userAgent : EMPTY);
                var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
                this.getBrowser = function() {
                    var browser = {
                        name: undefined1,
                        version: undefined1
                    };
                    mapper.rgx.call(browser, ua, rgxmap.browser);
                    browser.major = util.major(browser.version);
                    return browser;
                };
                this.getCPU = function() {
                    var cpu = {
                        architecture: undefined1
                    };
                    mapper.rgx.call(cpu, ua, rgxmap.cpu);
                    return cpu;
                };
                this.getDevice = function() {
                    var device = {
                        vendor: undefined1,
                        model: undefined1,
                        type: undefined1
                    };
                    mapper.rgx.call(device, ua, rgxmap.device);
                    return device;
                };
                this.getEngine = function() {
                    var engine = {
                        name: undefined1,
                        version: undefined1
                    };
                    mapper.rgx.call(engine, ua, rgxmap.engine);
                    return engine;
                };
                this.getOS = function() {
                    var os = {
                        name: undefined1,
                        version: undefined1
                    };
                    mapper.rgx.call(os, ua, rgxmap.os);
                    return os;
                };
                this.getResult = function() {
                    return {
                        ua: this.getUA(),
                        browser: this.getBrowser(),
                        engine: this.getEngine(),
                        os: this.getOS(),
                        device: this.getDevice(),
                        cpu: this.getCPU()
                    };
                };
                this.getUA = function() {
                    return ua;
                };
                this.setUA = function(uastring) {
                    ua = uastring;
                    return this;
                };
                return this;
            };
            UAParser.VERSION = LIBVERSION;
            UAParser.BROWSER = {
                NAME: NAME,
                MAJOR: MAJOR,
                VERSION: VERSION
            };
            UAParser.CPU = {
                ARCHITECTURE: ARCHITECTURE
            };
            UAParser.DEVICE = {
                MODEL: MODEL,
                VENDOR: VENDOR,
                TYPE: TYPE,
                CONSOLE: CONSOLE,
                MOBILE: MOBILE,
                SMARTTV: SMARTTV,
                TABLET: TABLET,
                WEARABLE: WEARABLE,
                EMBEDDED: EMBEDDED
            };
            UAParser.ENGINE = {
                NAME: NAME,
                VERSION: VERSION
            };
            UAParser.OS = {
                NAME: NAME,
                VERSION: VERSION
            };
            if (typeof exports !== UNDEF_TYPE) {
                if (typeof module1 !== UNDEF_TYPE && module1.exports) exports = module1.exports = UAParser;
                exports.UAParser = UAParser;
            } else {
                if ("function" === FUNC_TYPE && __webpack_require__(3)) __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                    return UAParser;
                }).call(exports, __webpack_require__, exports, module1), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined1 && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__);
                else if (window1) window1.UAParser = UAParser;
            }
            var $ = window1 && (window1.jQuery || window1.Zepto);
            if (typeof $ !== UNDEF_TYPE) {
                var parser = new UAParser;
                $.ua = parser.getResult();
                $.ua.get = function() {
                    return parser.getUA();
                };
                $.ua.set = function(uastring) {
                    parser.setUA(uastring);
                    var result = parser.getResult();
                    for(var prop in result)$.ua[prop] = result[prop];
                };
            }
        })(typeof window === "object" ? window : this);
    /***/ },
    /* 3 */ /***/ function(module1, exports) {
        /* WEBPACK VAR INJECTION */ (function(__webpack_amd_options__) {
            module1.exports = __webpack_amd_options__;
        /* WEBPACK VAR INJECTION */ }).call(exports, {});
    /***/ },
    /* 4 */ /***/ function(module1, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        var _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        var _require = __webpack_require__(0), DEVICE_TYPES = _require.DEVICE_TYPES, defaultData = _require.defaultData;
        var checkType = function checkType(type) {
            switch(type){
                case DEVICE_TYPES.MOBILE:
                    return {
                        isMobile: true
                    };
                case DEVICE_TYPES.TABLET:
                    return {
                        isTablet: true
                    };
                case DEVICE_TYPES.SMART_TV:
                    return {
                        isSmartTV: true
                    };
                case DEVICE_TYPES.CONSOLE:
                    return {
                        isConsole: true
                    };
                case DEVICE_TYPES.WEARABLE:
                    return {
                        isWearable: true
                    };
                case DEVICE_TYPES.BROWSER:
                    return {
                        isBrowser: true
                    };
                default:
                    return defaultData;
            }
        };
        var broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
            return {
                isBrowser: isBrowser,
                browserMajorVersion: browser.major,
                browserFullVersion: browser.version,
                browserName: browser.name,
                engineName: engine.name || false,
                engineVersion: engine.version,
                osName: os.name,
                osVersion: os.version,
                userAgent: ua
            };
        };
        var mobilePayload = function mobilePayload(type, device, os, ua) {
            return _extends({}, type, {
                vendor: device.vendor,
                model: device.model,
                os: os.name,
                osVersion: os.version,
                ua: ua
            });
        };
        var stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
            return {
                isSmartTV: isSmartTV,
                engineName: engine.name,
                engineVersion: engine.version,
                osName: os.name,
                osVersion: os.version,
                userAgent: ua
            };
        };
        var consolePayload = function consolePayload(isConsole, engine, os, ua) {
            return {
                isConsole: isConsole,
                engineName: engine.name,
                engineVersion: engine.version,
                osName: os.name,
                osVersion: os.version,
                userAgent: ua
            };
        };
        var wearPayload = function wearPayload(isWearable, engine, os, ua) {
            return {
                isWearable: isWearable,
                engineName: engine.name,
                engineVersion: engine.version,
                osName: os.name,
                osVersion: os.version,
                userAgent: ua
            };
        };
        var getNavigatorInstance = exports.getNavigatorInstance = function getNavigatorInstance() {
            if (typeof window !== "undefined") {
                if (window.navigator || navigator) return window.navigator || navigator;
            }
            return false;
        };
        var isIOS13Check = exports.isIOS13Check = function isIOS13Check(type) {
            var nav = getNavigatorInstance();
            return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === "MacIntel" && nav.maxTouchPoints > 1 && !window.MSStream);
        };
        module1.exports = {
            checkType: checkType,
            broPayload: broPayload,
            mobilePayload: mobilePayload,
            stvPayload: stvPayload,
            consolePayload: consolePayload,
            wearPayload: wearPayload,
            getNavigatorInstance: getNavigatorInstance,
            isIOS13Check: isIOS13Check
        };
    /***/ }
]);


// Core
// attribute params
// {
//     data - typed array eg UInt16Array for indices, Float32Array
//     size - int default 1
//     instanced - default null. Pass divisor amount
//     type - gl enum default gl.UNSIGNED_SHORT for 'index', gl.FLOAT for others
//     normalized - boolean default false
//     buffer - gl buffer, if buffer exists, don't need to provide data - although needs position data for bounds calculation
//     stride - default 0 - for when passing in buffer
//     offset - default 0 - for when passing in buffer
//     count - default null - for when passing in buffer
//     min - array - for when passing in buffer
//     max - array - for when passing in buffer
// }
// TODO: fit in transform feedback
const $fdb9d1061c642aaf$var$EPSILON = 0.000001;
function $fdb9d1061c642aaf$export$f24224f1c91d8156(a) {
    let x = a[0];
    let y = a[1];
    let z = a[2];
    return Math.sqrt(x * x + y * y + z * z);
}
function $fdb9d1061c642aaf$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $fdb9d1061c642aaf$export$adaa4cf7ef1b65be(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $fdb9d1061c642aaf$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function $fdb9d1061c642aaf$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function $fdb9d1061c642aaf$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}
function $fdb9d1061c642aaf$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}
function $fdb9d1061c642aaf$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function $fdb9d1061c642aaf$export$9f17032d917177de(a, b) {
    let x = b[0] - a[0];
    let y = b[1] - a[1];
    let z = b[2] - a[2];
    return Math.sqrt(x * x + y * y + z * z);
}
function $fdb9d1061c642aaf$export$88e6ebb4fe54f538(a, b) {
    let x = b[0] - a[0];
    let y = b[1] - a[1];
    let z = b[2] - a[2];
    return x * x + y * y + z * z;
}
function $fdb9d1061c642aaf$export$ab44e1323ffc8376(a) {
    let x = a[0];
    let y = a[1];
    let z = a[2];
    return x * x + y * y + z * z;
}
function $fdb9d1061c642aaf$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}
function $fdb9d1061c642aaf$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}
function $fdb9d1061c642aaf$export$a3295358bff77e(out, a) {
    let x = a[0];
    let y = a[1];
    let z = a[2];
    let len = x * x + y * y + z * z;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
    return out;
}
function $fdb9d1061c642aaf$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $fdb9d1061c642aaf$export$bb646b20bb93d339(out, a, b) {
    let ax = a[0], ay = a[1], az = a[2];
    let bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function $fdb9d1061c642aaf$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    let ax = a[0];
    let ay = a[1];
    let az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}
function $fdb9d1061c642aaf$export$5ffbd13800309d59(out, a, m) {
    let x = a[0], y = a[1], z = a[2];
    let w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
function $fdb9d1061c642aaf$export$58ce737ad0c12bc2(out, a, m) {
    let x = a[0], y = a[1], z = a[2];
    let w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z) / w;
    return out;
}
function $fdb9d1061c642aaf$export$f0bfa0a0024626ee(out, a, m) {
    let x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
function $fdb9d1061c642aaf$export$c32adef9e939ce85(out, a, q) {
    // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
    let x = a[0], y = a[1], z = a[2];
    let qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    let uvx = qy * z - qz * y;
    let uvy = qz * x - qx * z;
    let uvz = qx * y - qy * x;
    let uuvx = qy * uvz - qz * uvy;
    let uuvy = qz * uvx - qx * uvz;
    let uuvz = qx * uvy - qy * uvx;
    let w2 = qw * 2;
    uvx *= w2;
    uvy *= w2;
    uvz *= w2;
    uuvx *= 2;
    uuvy *= 2;
    uuvz *= 2;
    out[0] = x + uvx + uuvx;
    out[1] = y + uvy + uuvy;
    out[2] = z + uvz + uuvz;
    return out;
}
const $fdb9d1061c642aaf$export$944b09d2ad10b378 = function() {
    const tempA = [
        0,
        0,
        0
    ];
    const tempB = [
        0,
        0,
        0
    ];
    return function(a, b) {
        $fdb9d1061c642aaf$export$784d13d8ee351f07(tempA, a);
        $fdb9d1061c642aaf$export$784d13d8ee351f07(tempB, b);
        $fdb9d1061c642aaf$export$a3295358bff77e(tempA, tempA);
        $fdb9d1061c642aaf$export$a3295358bff77e(tempB, tempB);
        let cosine = $fdb9d1061c642aaf$export$94132a0e348806d4(tempA, tempB);
        if (cosine > 1.0) return 0;
        else if (cosine < -1) return Math.PI;
        else return Math.acos(cosine);
    };
}();
function $fdb9d1061c642aaf$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}


class $77acc528c45f5d37$export$838423f3adec30fa extends Array {
    constructor(x = 0, y = x, z = x){
        super(x, y, z);
        return this;
    }
    get x() {
        return this[0];
    }
    get y() {
        return this[1];
    }
    get z() {
        return this[2];
    }
    set x(v) {
        this[0] = v;
    }
    set y(v) {
        this[1] = v;
    }
    set z(v) {
        this[2] = v;
    }
    set(x, y = x, z = x) {
        if (x.length) return this.copy(x);
        $fdb9d1061c642aaf$export$adaa4cf7ef1b65be(this, x, y, z);
        return this;
    }
    copy(v) {
        $fdb9d1061c642aaf$export$784d13d8ee351f07(this, v);
        return this;
    }
    add(va, vb) {
        if (vb) $fdb9d1061c642aaf$export$e16d8520af44a096(this, va, vb);
        else $fdb9d1061c642aaf$export$e16d8520af44a096(this, this, va);
        return this;
    }
    sub(va, vb) {
        if (vb) $fdb9d1061c642aaf$export$4e2d2ead65e5f7e3(this, va, vb);
        else $fdb9d1061c642aaf$export$4e2d2ead65e5f7e3(this, this, va);
        return this;
    }
    multiply(v) {
        if (v.length) $fdb9d1061c642aaf$export$2060d2db72cce88f(this, this, v);
        else $fdb9d1061c642aaf$export$dcdf75081b88279d(this, this, v);
        return this;
    }
    divide(v) {
        if (v.length) $fdb9d1061c642aaf$export$cd007d971a5a2143(this, this, v);
        else $fdb9d1061c642aaf$export$dcdf75081b88279d(this, this, 1 / v);
        return this;
    }
    inverse(v = this) {
        $fdb9d1061c642aaf$export$70ae2c07e401031b(this, v);
        return this;
    }
    // Can't use 'length' as Array.prototype uses it
    len() {
        return $fdb9d1061c642aaf$export$f24224f1c91d8156(this);
    }
    distance(v) {
        if (v) return $fdb9d1061c642aaf$export$9f17032d917177de(this, v);
        else return $fdb9d1061c642aaf$export$f24224f1c91d8156(this);
    }
    squaredLen() {
        return $fdb9d1061c642aaf$export$ab44e1323ffc8376(this);
    }
    squaredDistance(v) {
        if (v) return $fdb9d1061c642aaf$export$88e6ebb4fe54f538(this, v);
        else return $fdb9d1061c642aaf$export$ab44e1323ffc8376(this);
    }
    negate(v = this) {
        $fdb9d1061c642aaf$export$aef51622e549b8b0(this, v);
        return this;
    }
    cross(va, vb) {
        if (vb) $fdb9d1061c642aaf$export$bb646b20bb93d339(this, va, vb);
        else $fdb9d1061c642aaf$export$bb646b20bb93d339(this, this, va);
        return this;
    }
    scale(v) {
        $fdb9d1061c642aaf$export$dcdf75081b88279d(this, this, v);
        return this;
    }
    normalize() {
        $fdb9d1061c642aaf$export$a3295358bff77e(this, this);
        return this;
    }
    dot(v) {
        return $fdb9d1061c642aaf$export$94132a0e348806d4(this, v);
    }
    equals(v) {
        return $fdb9d1061c642aaf$export$f2599a5cf1109d8(this, v);
    }
    applyMatrix3(mat3) {
        $fdb9d1061c642aaf$export$f0bfa0a0024626ee(this, this, mat3);
        return this;
    }
    applyMatrix4(mat4) {
        $fdb9d1061c642aaf$export$5ffbd13800309d59(this, this, mat4);
        return this;
    }
    scaleRotateMatrix4(mat4) {
        $fdb9d1061c642aaf$export$58ce737ad0c12bc2(this, this, mat4);
        return this;
    }
    applyQuaternion(q) {
        $fdb9d1061c642aaf$export$c32adef9e939ce85(this, this, q);
        return this;
    }
    angle(v) {
        return $fdb9d1061c642aaf$export$944b09d2ad10b378(this, v);
    }
    lerp(v, t) {
        $fdb9d1061c642aaf$export$3a89f8d6f6bf6c9f(this, this, v, t);
        return this;
    }
    clone() {
        return new $77acc528c45f5d37$export$838423f3adec30fa(this[0], this[1], this[2]);
    }
    fromArray(a, o = 0) {
        this[0] = a[o];
        this[1] = a[o + 1];
        this[2] = a[o + 2];
        return this;
    }
    toArray(a = [], o = 0) {
        a[o] = this[0];
        a[o + 1] = this[1];
        a[o + 2] = this[2];
        return a;
    }
    transformDirection(mat4) {
        const x = this[0];
        const y = this[1];
        const z = this[2];
        this[0] = mat4[0] * x + mat4[4] * y + mat4[8] * z;
        this[1] = mat4[1] * x + mat4[5] * y + mat4[9] * z;
        this[2] = mat4[2] * x + mat4[6] * y + mat4[10] * z;
        return this.normalize();
    }
}


const $38f0c9db74b3b35f$var$tempVec3 = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
let $38f0c9db74b3b35f$var$ID = 1;
let $38f0c9db74b3b35f$var$ATTR_ID = 1;
// To stop inifinite warnings
let $38f0c9db74b3b35f$var$isBoundsWarned = false;
class $38f0c9db74b3b35f$export$2db6c17465f94a2 {
    constructor(gl, attributes = {}){
        gl.canvas;
        this.gl = gl;
        this.attributes = attributes;
        this.id = $38f0c9db74b3b35f$var$ID++;
        // Store one VAO per program attribute locations order
        this.VAOs = {};
        this.drawRange = {
            start: 0,
            count: 0
        };
        this.instancedCount = 0;
        // Unbind current VAO so that new buffers don't get added to active mesh
        this.gl.renderer.bindVertexArray(null);
        this.gl.renderer.currentGeometry = null;
        // Alias for state store to avoid redundant calls for global state
        this.glState = this.gl.renderer.state;
        // create the buffers
        for(let key in attributes)this.addAttribute(key, attributes[key]);
    }
    addAttribute(key, attr) {
        this.attributes[key] = attr;
        // Set options
        attr.id = $38f0c9db74b3b35f$var$ATTR_ID++; // TODO: currently unused, remove?
        attr.size = attr.size || 1;
        attr.type = attr.type || (attr.data.constructor === Float32Array ? this.gl.FLOAT : attr.data.constructor === Uint16Array ? this.gl.UNSIGNED_SHORT : this.gl.UNSIGNED_INT); // Uint32Array
        attr.target = key === "index" ? this.gl.ELEMENT_ARRAY_BUFFER : this.gl.ARRAY_BUFFER;
        attr.normalized = attr.normalized || false;
        attr.stride = attr.stride || 0;
        attr.offset = attr.offset || 0;
        attr.count = attr.count || (attr.stride ? attr.data.byteLength / attr.stride : attr.data.length / attr.size);
        attr.divisor = attr.instanced || 0;
        attr.needsUpdate = false;
        attr.usage = attr.usage || this.gl.STATIC_DRAW;
        if (!attr.buffer) // Push data to buffer
        this.updateAttribute(attr);
        // Update geometry counts. If indexed, ignore regular attributes
        if (attr.divisor) {
            this.isInstanced = true;
            if (this.instancedCount && this.instancedCount !== attr.count * attr.divisor) return this.instancedCount = Math.min(this.instancedCount, attr.count * attr.divisor);
            this.instancedCount = attr.count * attr.divisor;
        } else if (key === "index") this.drawRange.count = attr.count;
        else if (!this.attributes.index) this.drawRange.count = Math.max(this.drawRange.count, attr.count);
    }
    updateAttribute(attr) {
        const isNewBuffer = !attr.buffer;
        if (isNewBuffer) attr.buffer = this.gl.createBuffer();
        if (this.glState.boundBuffer !== attr.buffer) {
            this.gl.bindBuffer(attr.target, attr.buffer);
            this.glState.boundBuffer = attr.buffer;
        }
        if (isNewBuffer) this.gl.bufferData(attr.target, attr.data, attr.usage);
        else this.gl.bufferSubData(attr.target, 0, attr.data);
        attr.needsUpdate = false;
    }
    setIndex(value) {
        this.addAttribute("index", value);
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    setInstancedCount(value) {
        this.instancedCount = value;
    }
    createVAO(program) {
        this.VAOs[program.attributeOrder] = this.gl.renderer.createVertexArray();
        this.gl.renderer.bindVertexArray(this.VAOs[program.attributeOrder]);
        this.bindAttributes(program);
    }
    bindAttributes(program) {
        // Link all attributes to program using gl.vertexAttribPointer
        program.attributeLocations.forEach((location, { name: name, type: type })=>{
            // If geometry missing a required shader attribute
            if (!this.attributes[name]) return;
            const attr = this.attributes[name];
            this.gl.bindBuffer(attr.target, attr.buffer);
            this.glState.boundBuffer = attr.buffer;
            // For matrix attributes, buffer needs to be defined per column
            let numLoc = 1;
            if (type === 35674) numLoc = 2; // mat2
            if (type === 35675) numLoc = 3; // mat3
            if (type === 35676) numLoc = 4; // mat4
            const size = attr.size / numLoc;
            const stride = numLoc === 1 ? 0 : numLoc * numLoc * 4;
            const offset = numLoc === 1 ? 0 : numLoc * 4;
            for(let i = 0; i < numLoc; i++){
                this.gl.vertexAttribPointer(location + i, size, attr.type, attr.normalized, attr.stride + stride, attr.offset + i * offset);
                this.gl.enableVertexAttribArray(location + i);
                // For instanced attributes, divisor needs to be set.
                // For firefox, need to set back to 0 if non-instanced drawn after instanced. Else won't render
                this.gl.renderer.vertexAttribDivisor(location + i, attr.divisor);
            }
        });
        // Bind indices if geometry indexed
        if (this.attributes.index) this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, this.attributes.index.buffer);
    }
    draw({ program: program, mode: mode = this.gl.TRIANGLES }) {
        if (this.gl.renderer.currentGeometry !== `${this.id}_${program.attributeOrder}`) {
            if (!this.VAOs[program.attributeOrder]) this.createVAO(program);
            this.gl.renderer.bindVertexArray(this.VAOs[program.attributeOrder]);
            this.gl.renderer.currentGeometry = `${this.id}_${program.attributeOrder}`;
        }
        // Check if any attributes need updating
        program.attributeLocations.forEach((location, { name: name })=>{
            const attr = this.attributes[name];
            if (attr.needsUpdate) this.updateAttribute(attr);
        });
        // For drawElements, offset needs to be multiple of type size
        let indexBytesPerElement = 2;
        if (this.attributes.index?.type === this.gl.UNSIGNED_INT) indexBytesPerElement = 4;
        if (this.isInstanced) {
            if (this.attributes.index) this.gl.renderer.drawElementsInstanced(mode, this.drawRange.count, this.attributes.index.type, this.attributes.index.offset + this.drawRange.start * indexBytesPerElement, this.instancedCount);
            else this.gl.renderer.drawArraysInstanced(mode, this.drawRange.start, this.drawRange.count, this.instancedCount);
        } else if (this.attributes.index) this.gl.drawElements(mode, this.drawRange.count, this.attributes.index.type, this.attributes.index.offset + this.drawRange.start * indexBytesPerElement);
        else this.gl.drawArrays(mode, this.drawRange.start, this.drawRange.count);
    }
    getPosition() {
        // Use position buffer, or min/max if available
        const attr = this.attributes.position;
        // if (attr.min) return [...attr.min, ...attr.max];
        if (attr.data) return attr;
        if ($38f0c9db74b3b35f$var$isBoundsWarned) return;
        return $38f0c9db74b3b35f$var$isBoundsWarned = true;
    }
    computeBoundingBox(attr) {
        if (!attr) attr = this.getPosition();
        const array = attr.data;
        // Data loaded shouldn't haave stride, only buffers
        // const stride = attr.stride ? attr.stride / array.BYTES_PER_ELEMENT : attr.size;
        const stride = attr.size;
        if (!this.bounds) this.bounds = {
            min: new (0, $77acc528c45f5d37$export$838423f3adec30fa)(),
            max: new (0, $77acc528c45f5d37$export$838423f3adec30fa)(),
            center: new (0, $77acc528c45f5d37$export$838423f3adec30fa)(),
            scale: new (0, $77acc528c45f5d37$export$838423f3adec30fa)(),
            radius: Infinity
        };
        const min = this.bounds.min;
        const max = this.bounds.max;
        const center = this.bounds.center;
        const scale = this.bounds.scale;
        min.set(Infinity);
        max.set(-Infinity);
        // TODO: check size of position (eg triangle with Vec2)
        for(let i = 0, l = array.length; i < l; i += stride){
            const x = array[i];
            const y = array[i + 1];
            const z = array[i + 2];
            min.x = Math.min(x, min.x);
            min.y = Math.min(y, min.y);
            min.z = Math.min(z, min.z);
            max.x = Math.max(x, max.x);
            max.y = Math.max(y, max.y);
            max.z = Math.max(z, max.z);
        }
        scale.sub(max, min);
        center.add(min, max).divide(2);
    }
    computeBoundingSphere(attr) {
        if (!attr) attr = this.getPosition();
        const array = attr.data;
        // Data loaded shouldn't haave stride, only buffers
        // const stride = attr.stride ? attr.stride / array.BYTES_PER_ELEMENT : attr.size;
        const stride = attr.size;
        if (!this.bounds) this.computeBoundingBox(attr);
        let maxRadiusSq = 0;
        for(let i = 0, l = array.length; i < l; i += stride){
            $38f0c9db74b3b35f$var$tempVec3.fromArray(array, i);
            maxRadiusSq = Math.max(maxRadiusSq, this.bounds.center.squaredDistance($38f0c9db74b3b35f$var$tempVec3));
        }
        this.bounds.radius = Math.sqrt(maxRadiusSq);
    }
    remove() {
        for(let key in this.VAOs){
            this.gl.renderer.deleteVertexArray(this.VAOs[key]);
            delete this.VAOs[key];
        }
        for(let key in this.attributes){
            this.gl.deleteBuffer(this.attributes[key].buffer);
            delete this.attributes[key];
        }
    }
}


// TODO: upload empty texture if null ? maybe not
// TODO: upload identity matrix if null ?
// TODO: sampler Cube
let $5d5fa8f7218537a7$var$ID = 1;
// cache of typed arrays used to flatten uniform arrays
const $5d5fa8f7218537a7$var$arrayCacheF32 = {};
class $5d5fa8f7218537a7$export$b6c59b989905b650 {
    constructor(gl, { vertex: vertex, fragment: fragment, uniforms: uniforms = {}, transparent: transparent = false, cullFace: cullFace = gl.BACK, frontFace: frontFace = gl.CCW, depthTest: depthTest = true, depthWrite: depthWrite = true, depthFunc: depthFunc = gl.LESS } = {}){
        gl.canvas;
        this.gl = gl;
        this.uniforms = uniforms;
        this.id = $5d5fa8f7218537a7$var$ID++;
        vertex;
        fragment;
        // Store program state
        this.transparent = transparent;
        this.cullFace = cullFace;
        this.frontFace = frontFace;
        this.depthTest = depthTest;
        this.depthWrite = depthWrite;
        this.depthFunc = depthFunc;
        this.blendFunc = {};
        this.blendEquation = {};
        // set default blendFunc if transparent flagged
        if (this.transparent && !this.blendFunc.src) {
            if (this.gl.renderer.premultipliedAlpha) this.setBlendFunc(this.gl.ONE, this.gl.ONE_MINUS_SRC_ALPHA);
            else this.setBlendFunc(this.gl.SRC_ALPHA, this.gl.ONE_MINUS_SRC_ALPHA);
        }
        // compile vertex shader and log errors
        const vertexShader = gl.createShader(gl.VERTEX_SHADER);
        gl.shaderSource(vertexShader, vertex);
        gl.compileShader(vertexShader);
        gl.getShaderInfoLog(vertexShader);
        // compile fragment shader and log errors
        const fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
        gl.shaderSource(fragmentShader, fragment);
        gl.compileShader(fragmentShader);
        gl.getShaderInfoLog(fragmentShader);
        // compile program and log errors
        this.program = gl.createProgram();
        gl.attachShader(this.program, vertexShader);
        gl.attachShader(this.program, fragmentShader);
        gl.linkProgram(this.program);
        if (!gl.getProgramParameter(this.program, gl.LINK_STATUS)) return void 0;
        // Remove shader once linked
        gl.deleteShader(vertexShader);
        gl.deleteShader(fragmentShader);
        // Get active uniform locations
        this.uniformLocations = new Map();
        let numUniforms = gl.getProgramParameter(this.program, gl.ACTIVE_UNIFORMS);
        for(let uIndex = 0; uIndex < numUniforms; uIndex++){
            let uniform = gl.getActiveUniform(this.program, uIndex);
            this.uniformLocations.set(uniform, gl.getUniformLocation(this.program, uniform.name));
            // split uniforms' names to separate array and struct declarations
            const split = uniform.name.match(/(\w+)/g);
            uniform.uniformName = split[0];
            uniform.nameComponents = split.slice(1);
        }
        // Get active attribute locations
        this.attributeLocations = new Map();
        const locations = [];
        const numAttribs = gl.getProgramParameter(this.program, gl.ACTIVE_ATTRIBUTES);
        for(let aIndex = 0; aIndex < numAttribs; aIndex++){
            const attribute = gl.getActiveAttrib(this.program, aIndex);
            const location = gl.getAttribLocation(this.program, attribute.name);
            // Ignore special built-in inputs. eg gl_VertexID, gl_InstanceID
            if (location === -1) continue;
            locations[location] = attribute.name;
            this.attributeLocations.set(attribute, location);
        }
        this.attributeOrder = locations.join("");
    }
    setBlendFunc(src, dst, srcAlpha, dstAlpha) {
        this.blendFunc.src = src;
        this.blendFunc.dst = dst;
        this.blendFunc.srcAlpha = srcAlpha;
        this.blendFunc.dstAlpha = dstAlpha;
        if (src) this.transparent = true;
    }
    setBlendEquation(modeRGB, modeAlpha) {
        this.blendEquation.modeRGB = modeRGB;
        this.blendEquation.modeAlpha = modeAlpha;
    }
    applyState() {
        if (this.depthTest) this.gl.renderer.enable(this.gl.DEPTH_TEST);
        else this.gl.renderer.disable(this.gl.DEPTH_TEST);
        if (this.cullFace) this.gl.renderer.enable(this.gl.CULL_FACE);
        else this.gl.renderer.disable(this.gl.CULL_FACE);
        if (this.blendFunc.src) this.gl.renderer.enable(this.gl.BLEND);
        else this.gl.renderer.disable(this.gl.BLEND);
        if (this.cullFace) this.gl.renderer.setCullFace(this.cullFace);
        this.gl.renderer.setFrontFace(this.frontFace);
        this.gl.renderer.setDepthMask(this.depthWrite);
        this.gl.renderer.setDepthFunc(this.depthFunc);
        if (this.blendFunc.src) this.gl.renderer.setBlendFunc(this.blendFunc.src, this.blendFunc.dst, this.blendFunc.srcAlpha, this.blendFunc.dstAlpha);
        this.gl.renderer.setBlendEquation(this.blendEquation.modeRGB, this.blendEquation.modeAlpha);
    }
    use({ flipFaces: flipFaces = false } = {}) {
        let textureUnit = -1;
        const programActive = this.gl.renderer.state.currentProgram === this.id;
        // Avoid gl call if program already in use
        if (!programActive) {
            this.gl.useProgram(this.program);
            this.gl.renderer.state.currentProgram = this.id;
        }
        // Set only the active uniforms found in the shader
        this.uniformLocations.forEach((location, activeUniform)=>{
            let uniform = this.uniforms[activeUniform.uniformName];
            for (const component of activeUniform.nameComponents){
                if (!uniform) break;
                if (component in uniform) uniform = uniform[component];
                else if (Array.isArray(uniform.value)) break;
                else {
                    uniform = undefined;
                    break;
                }
            }
            if (!uniform) return $5d5fa8f7218537a7$var$warn(`Active uniform ${activeUniform.name} has not been supplied`);
            if (uniform && uniform.value === undefined) return $5d5fa8f7218537a7$var$warn(`${activeUniform.name} uniform is missing a value parameter`);
            if (uniform.value.texture) {
                textureUnit = textureUnit + 1;
                // Check if texture needs to be updated
                uniform.value.update(textureUnit);
                return $5d5fa8f7218537a7$var$setUniform(this.gl, activeUniform.type, location, textureUnit);
            }
            // For texture arrays, set uniform as an array of texture units instead of just one
            if (uniform.value.length && uniform.value[0].texture) {
                const textureUnits = [];
                uniform.value.forEach((value)=>{
                    textureUnit = textureUnit + 1;
                    value.update(textureUnit);
                    textureUnits.push(textureUnit);
                });
                return $5d5fa8f7218537a7$var$setUniform(this.gl, activeUniform.type, location, textureUnits);
            }
            $5d5fa8f7218537a7$var$setUniform(this.gl, activeUniform.type, location, uniform.value);
        });
        this.applyState();
        if (flipFaces) this.gl.renderer.setFrontFace(this.frontFace === this.gl.CCW ? this.gl.CW : this.gl.CCW);
    }
    remove() {
        this.gl.deleteProgram(this.program);
    }
}
function $5d5fa8f7218537a7$var$setUniform(gl, type, location, value) {
    value = value.length ? $5d5fa8f7218537a7$var$flatten(value) : value;
    const setValue = gl.renderer.state.uniformLocations.get(location);
    // Avoid redundant uniform commands
    if (value.length) {
        if (setValue === undefined || setValue.length !== value.length) // clone array to store as cache
        gl.renderer.state.uniformLocations.set(location, value.slice(0));
        else {
            if ($5d5fa8f7218537a7$var$arraysEqual(setValue, value)) return;
            // Update cached array values
            setValue.set ? setValue.set(value) : $5d5fa8f7218537a7$var$setArray(setValue, value);
            gl.renderer.state.uniformLocations.set(location, setValue);
        }
    } else {
        if (setValue === value) return;
        gl.renderer.state.uniformLocations.set(location, value);
    }
    switch(type){
        case 5126:
            return value.length ? gl.uniform1fv(location, value) : gl.uniform1f(location, value);
        // FLOAT
        case 35664:
            return gl.uniform2fv(location, value);
        // FLOAT_VEC2
        case 35665:
            return gl.uniform3fv(location, value);
        // FLOAT_VEC3
        case 35666:
            return gl.uniform4fv(location, value);
        // FLOAT_VEC4
        case 35670:
        case 5124:
        case 35678:
        case 35680:
            return value.length ? gl.uniform1iv(location, value) : gl.uniform1i(location, value);
        // SAMPLER_CUBE
        case 35671:
        case 35667:
            return gl.uniform2iv(location, value);
        // INT_VEC2
        case 35672:
        case 35668:
            return gl.uniform3iv(location, value);
        // INT_VEC3
        case 35673:
        case 35669:
            return gl.uniform4iv(location, value);
        // INT_VEC4
        case 35674:
            return gl.uniformMatrix2fv(location, false, value);
        // FLOAT_MAT2
        case 35675:
            return gl.uniformMatrix3fv(location, false, value);
        // FLOAT_MAT3
        case 35676:
            return gl.uniformMatrix4fv(location, false, value);
    }
}
function $5d5fa8f7218537a7$var$addLineNumbers(string) {
    let lines = string.split("\n");
    for(let i = 0; i < lines.length; i++)lines[i] = i + 1 + ": " + lines[i];
    return lines.join("\n");
}
function $5d5fa8f7218537a7$var$flatten(a) {
    const arrayLen = a.length;
    const valueLen = a[0].length;
    if (valueLen === undefined) return a;
    const length = arrayLen * valueLen;
    let value = $5d5fa8f7218537a7$var$arrayCacheF32[length];
    if (!value) $5d5fa8f7218537a7$var$arrayCacheF32[length] = value = new Float32Array(length);
    for(let i = 0; i < arrayLen; i++)value.set(a[i], i * valueLen);
    return value;
}
function $5d5fa8f7218537a7$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $5d5fa8f7218537a7$var$setArray(a, b) {
    for(let i = 0, l = a.length; i < l; i++)a[i] = b[i];
}
let $5d5fa8f7218537a7$var$warnCount = 0;
function $5d5fa8f7218537a7$var$warn(message) {
    if ($5d5fa8f7218537a7$var$warnCount > 100) return;
    $5d5fa8f7218537a7$var$warnCount++;
    $5d5fa8f7218537a7$var$warnCount;
}



// TODO: Handle context loss https://www.khronos.org/webgl/wiki/HandlingContextLost
// Not automatic - devs to use these methods manually
// gl.colorMask( colorMask, colorMask, colorMask, colorMask );
// gl.clearColor( r, g, b, a );
// gl.stencilMask( stencilMask );
// gl.stencilFunc( stencilFunc, stencilRef, stencilMask );
// gl.stencilOp( stencilFail, stencilZFail, stencilZPass );
// gl.clearStencil( stencil );
const $9be90720ae75e4ee$var$tempVec3 = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
let $9be90720ae75e4ee$var$ID = 1;
class $9be90720ae75e4ee$export$88530751e3977073 {
    constructor({ canvas: canvas = document.createElement("canvas"), width: width = 300, height: height = 150, dpr: dpr = 1, alpha: alpha = false, depth: depth = true, stencil: stencil = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = false, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = "default", autoClear: autoClear = true, webgl: webgl = 2 } = {}){
        const attributes = {
            alpha: alpha,
            depth: depth,
            stencil: stencil,
            antialias: antialias,
            premultipliedAlpha: premultipliedAlpha,
            preserveDrawingBuffer: preserveDrawingBuffer,
            powerPreference: powerPreference
        };
        this.dpr = dpr;
        this.alpha = alpha;
        this.color = true;
        this.depth = depth;
        this.stencil = stencil;
        this.premultipliedAlpha = premultipliedAlpha;
        this.autoClear = autoClear;
        this.id = $9be90720ae75e4ee$var$ID++;
        // Attempt WebGL2 unless forced to 1, if not supported fallback to WebGL1
        if (webgl === 2) this.gl = canvas.getContext("webgl2", attributes);
        this.isWebgl2 = !!this.gl;
        if (!this.gl) this.gl = canvas.getContext("webgl", attributes);
        this.gl;
        // Attach renderer to gl so that all classes have access to internal state functions
        this.gl.renderer = this;
        // initialise size values
        this.setSize(width, height);
        // gl state stores to avoid redundant calls on methods used internally
        this.state = {};
        this.state.blendFunc = {
            src: this.gl.ONE,
            dst: this.gl.ZERO
        };
        this.state.blendEquation = {
            modeRGB: this.gl.FUNC_ADD
        };
        this.state.cullFace = false;
        this.state.frontFace = this.gl.CCW;
        this.state.depthMask = true;
        this.state.depthFunc = this.gl.LESS;
        this.state.premultiplyAlpha = false;
        this.state.flipY = false;
        this.state.unpackAlignment = 4;
        this.state.framebuffer = null;
        this.state.viewport = {
            x: 0,
            y: 0,
            width: null,
            height: null
        };
        this.state.textureUnits = [];
        this.state.activeTextureUnit = 0;
        this.state.boundBuffer = null;
        this.state.uniformLocations = new Map();
        this.state.currentProgram = null;
        // store requested extensions
        this.extensions = {};
        // Initialise extra format types
        if (this.isWebgl2) {
            this.getExtension("EXT_color_buffer_float");
            this.getExtension("OES_texture_float_linear");
        } else {
            this.getExtension("OES_texture_float");
            this.getExtension("OES_texture_float_linear");
            this.getExtension("OES_texture_half_float");
            this.getExtension("OES_texture_half_float_linear");
            this.getExtension("OES_element_index_uint");
            this.getExtension("OES_standard_derivatives");
            this.getExtension("EXT_sRGB");
            this.getExtension("WEBGL_depth_texture");
            this.getExtension("WEBGL_draw_buffers");
        }
        this.getExtension("WEBGL_compressed_texture_astc");
        this.getExtension("EXT_texture_compression_bptc");
        this.getExtension("WEBGL_compressed_texture_s3tc");
        this.getExtension("WEBGL_compressed_texture_etc1");
        this.getExtension("WEBGL_compressed_texture_pvrtc");
        this.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
        // Create method aliases using extension (WebGL1) or native if available (WebGL2)
        this.vertexAttribDivisor = this.getExtension("ANGLE_instanced_arrays", "vertexAttribDivisor", "vertexAttribDivisorANGLE");
        this.drawArraysInstanced = this.getExtension("ANGLE_instanced_arrays", "drawArraysInstanced", "drawArraysInstancedANGLE");
        this.drawElementsInstanced = this.getExtension("ANGLE_instanced_arrays", "drawElementsInstanced", "drawElementsInstancedANGLE");
        this.createVertexArray = this.getExtension("OES_vertex_array_object", "createVertexArray", "createVertexArrayOES");
        this.bindVertexArray = this.getExtension("OES_vertex_array_object", "bindVertexArray", "bindVertexArrayOES");
        this.deleteVertexArray = this.getExtension("OES_vertex_array_object", "deleteVertexArray", "deleteVertexArrayOES");
        this.drawBuffers = this.getExtension("WEBGL_draw_buffers", "drawBuffers", "drawBuffersWEBGL");
        // Store device parameters
        this.parameters = {};
        this.parameters.maxTextureUnits = this.gl.getParameter(this.gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
        this.parameters.maxAnisotropy = this.getExtension("EXT_texture_filter_anisotropic") ? this.gl.getParameter(this.getExtension("EXT_texture_filter_anisotropic").MAX_TEXTURE_MAX_ANISOTROPY_EXT) : 0;
    }
    setSize(width, height) {
        this.width = width;
        this.height = height;
        this.gl.canvas.width = width * this.dpr;
        this.gl.canvas.height = height * this.dpr;
        if (!this.gl.canvas.style) return;
        Object.assign(this.gl.canvas.style, {
            width: width + "px",
            height: height + "px"
        });
    }
    setViewport(width, height, x = 0, y = 0) {
        if (this.state.viewport.width === width && this.state.viewport.height === height) return;
        this.state.viewport.width = width;
        this.state.viewport.height = height;
        this.state.viewport.x = x;
        this.state.viewport.y = y;
        this.gl.viewport(x, y, width, height);
    }
    setScissor(width, height, x = 0, y = 0) {
        this.gl.scissor(x, y, width, height);
    }
    enable(id) {
        if (this.state[id] === true) return;
        this.gl.enable(id);
        this.state[id] = true;
    }
    disable(id) {
        if (this.state[id] === false) return;
        this.gl.disable(id);
        this.state[id] = false;
    }
    setBlendFunc(src, dst, srcAlpha, dstAlpha) {
        if (this.state.blendFunc.src === src && this.state.blendFunc.dst === dst && this.state.blendFunc.srcAlpha === srcAlpha && this.state.blendFunc.dstAlpha === dstAlpha) return;
        this.state.blendFunc.src = src;
        this.state.blendFunc.dst = dst;
        this.state.blendFunc.srcAlpha = srcAlpha;
        this.state.blendFunc.dstAlpha = dstAlpha;
        if (srcAlpha !== undefined) this.gl.blendFuncSeparate(src, dst, srcAlpha, dstAlpha);
        else this.gl.blendFunc(src, dst);
    }
    setBlendEquation(modeRGB, modeAlpha) {
        modeRGB = modeRGB || this.gl.FUNC_ADD;
        if (this.state.blendEquation.modeRGB === modeRGB && this.state.blendEquation.modeAlpha === modeAlpha) return;
        this.state.blendEquation.modeRGB = modeRGB;
        this.state.blendEquation.modeAlpha = modeAlpha;
        if (modeAlpha !== undefined) this.gl.blendEquationSeparate(modeRGB, modeAlpha);
        else this.gl.blendEquation(modeRGB);
    }
    setCullFace(value) {
        if (this.state.cullFace === value) return;
        this.state.cullFace = value;
        this.gl.cullFace(value);
    }
    setFrontFace(value) {
        if (this.state.frontFace === value) return;
        this.state.frontFace = value;
        this.gl.frontFace(value);
    }
    setDepthMask(value) {
        if (this.state.depthMask === value) return;
        this.state.depthMask = value;
        this.gl.depthMask(value);
    }
    setDepthFunc(value) {
        if (this.state.depthFunc === value) return;
        this.state.depthFunc = value;
        this.gl.depthFunc(value);
    }
    activeTexture(value) {
        if (this.state.activeTextureUnit === value) return;
        this.state.activeTextureUnit = value;
        this.gl.activeTexture(this.gl.TEXTURE0 + value);
    }
    bindFramebuffer({ target: target = this.gl.FRAMEBUFFER, buffer: buffer = null } = {}) {
        if (this.state.framebuffer === buffer) return;
        this.state.framebuffer = buffer;
        this.gl.bindFramebuffer(target, buffer);
    }
    getExtension(extension, webgl2Func, extFunc) {
        // if webgl2 function supported, return func bound to gl context
        if (webgl2Func && this.gl[webgl2Func]) return this.gl[webgl2Func].bind(this.gl);
        // fetch extension once only
        if (!this.extensions[extension]) this.extensions[extension] = this.gl.getExtension(extension);
        // return extension if no function requested
        if (!webgl2Func) return this.extensions[extension];
        // Return null if extension not supported
        if (!this.extensions[extension]) return null;
        // return extension function, bound to extension
        return this.extensions[extension][extFunc].bind(this.extensions[extension]);
    }
    sortOpaque(a, b) {
        if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
        else if (a.program.id !== b.program.id) return a.program.id - b.program.id;
        else if (a.zDepth !== b.zDepth) return a.zDepth - b.zDepth;
        else return b.id - a.id;
    }
    sortTransparent(a, b) {
        if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
        if (a.zDepth !== b.zDepth) return b.zDepth - a.zDepth;
        else return b.id - a.id;
    }
    sortUI(a, b) {
        if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
        else if (a.program.id !== b.program.id) return a.program.id - b.program.id;
        else return b.id - a.id;
    }
    getRenderList({ scene: scene, camera: camera, frustumCull: frustumCull, sort: sort }) {
        let renderList = [];
        if (camera && frustumCull) camera.updateFrustum();
        // Get visible
        scene.traverse((node)=>{
            if (!node.visible) return true;
            if (!node.draw) return;
            if (frustumCull && node.frustumCulled && camera) {
                if (!camera.frustumIntersectsMesh(node)) return;
            }
            renderList.push(node);
        });
        if (sort) {
            const opaque = [];
            const transparent = []; // depthTest true
            const ui = []; // depthTest false
            renderList.forEach((node)=>{
                // Split into the 3 render groups
                if (!node.program.transparent) opaque.push(node);
                else if (node.program.depthTest) transparent.push(node);
                else ui.push(node);
                node.zDepth = 0;
                // Only calculate z-depth if renderOrder unset and depthTest is true
                if (node.renderOrder !== 0 || !node.program.depthTest || !camera) return;
                // update z-depth
                node.worldMatrix.getTranslation($9be90720ae75e4ee$var$tempVec3);
                $9be90720ae75e4ee$var$tempVec3.applyMatrix4(camera.projectionViewMatrix);
                node.zDepth = $9be90720ae75e4ee$var$tempVec3.z;
            });
            opaque.sort(this.sortOpaque);
            transparent.sort(this.sortTransparent);
            ui.sort(this.sortUI);
            renderList = opaque.concat(transparent, ui);
        }
        return renderList;
    }
    render({ scene: scene, camera: camera, target: target = null, update: update = true, sort: sort = true, frustumCull: frustumCull = true, clear: clear }) {
        if (target === null) {
            // make sure no render target bound so draws to canvas
            this.bindFramebuffer();
            this.setViewport(this.width * this.dpr, this.height * this.dpr);
        } else {
            // bind supplied render target and update viewport
            this.bindFramebuffer(target);
            this.setViewport(target.width, target.height);
        }
        if (clear || this.autoClear && clear !== false) {
            // Ensure depth buffer writing is enabled so it can be cleared
            if (this.depth && (!target || target.depth)) {
                this.enable(this.gl.DEPTH_TEST);
                this.setDepthMask(true);
            }
            this.gl.clear((this.color ? this.gl.COLOR_BUFFER_BIT : 0) | (this.depth ? this.gl.DEPTH_BUFFER_BIT : 0) | (this.stencil ? this.gl.STENCIL_BUFFER_BIT : 0));
        }
        // updates all scene graph matrices
        if (update) scene.updateMatrixWorld();
        // Update camera separately, in case not in scene graph
        if (camera) camera.updateMatrixWorld();
        // Get render list - entails culling and sorting
        const renderList = this.getRenderList({
            scene: scene,
            camera: camera,
            frustumCull: frustumCull,
            sort: sort
        });
        renderList.forEach((node)=>{
            node.draw({
                camera: camera
            });
        });
    }
}



const $faaca60ecfc6315f$var$EPSILON = 0.000001;
function $faaca60ecfc6315f$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $faaca60ecfc6315f$export$adaa4cf7ef1b65be(out, x, y, z, w) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $faaca60ecfc6315f$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
}
function $faaca60ecfc6315f$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
}
function $faaca60ecfc6315f$export$f24224f1c91d8156(a) {
    let x = a[0];
    let y = a[1];
    let z = a[2];
    let w = a[3];
    return Math.sqrt(x * x + y * y + z * z + w * w);
}
function $faaca60ecfc6315f$export$a3295358bff77e(out, a) {
    let x = a[0];
    let y = a[1];
    let z = a[2];
    let w = a[3];
    let len = x * x + y * y + z * z + w * w;
    if (len > 0) len = 1 / Math.sqrt(len);
    out[0] = x * len;
    out[1] = y * len;
    out[2] = z * len;
    out[3] = w * len;
    return out;
}
function $faaca60ecfc6315f$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
function $faaca60ecfc6315f$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    let ax = a[0];
    let ay = a[1];
    let az = a[2];
    let aw = a[3];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    out[3] = aw + t * (b[3] - aw);
    return out;
}


function $18cb46528d87b2b6$export$f0954fd7d5368655(out) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
}
function $18cb46528d87b2b6$export$4286ddefc8f49512(out, axis, rad) {
    rad = rad * 0.5;
    let s = Math.sin(rad);
    out[0] = s * axis[0];
    out[1] = s * axis[1];
    out[2] = s * axis[2];
    out[3] = Math.cos(rad);
    return out;
}
function $18cb46528d87b2b6$export$2060d2db72cce88f(out, a, b) {
    let ax = a[0], ay = a[1], az = a[2], aw = a[3];
    let bx = b[0], by = b[1], bz = b[2], bw = b[3];
    out[0] = ax * bw + aw * bx + ay * bz - az * by;
    out[1] = ay * bw + aw * by + az * bx - ax * bz;
    out[2] = az * bw + aw * bz + ax * by - ay * bx;
    out[3] = aw * bw - ax * bx - ay * by - az * bz;
    return out;
}
function $18cb46528d87b2b6$export$a59c8716592e09af(out, a, rad) {
    rad *= 0.5;
    let ax = a[0], ay = a[1], az = a[2], aw = a[3];
    let bx = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + aw * bx;
    out[1] = ay * bw + az * bx;
    out[2] = az * bw - ay * bx;
    out[3] = aw * bw - ax * bx;
    return out;
}
function $18cb46528d87b2b6$export$cf71e4d4ca4d1cfd(out, a, rad) {
    rad *= 0.5;
    let ax = a[0], ay = a[1], az = a[2], aw = a[3];
    let by = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw - az * by;
    out[1] = ay * bw + aw * by;
    out[2] = az * bw + ax * by;
    out[3] = aw * bw - ay * by;
    return out;
}
function $18cb46528d87b2b6$export$ea6eae3365de5b9c(out, a, rad) {
    rad *= 0.5;
    let ax = a[0], ay = a[1], az = a[2], aw = a[3];
    let bz = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + ay * bz;
    out[1] = ay * bw - ax * bz;
    out[2] = az * bw + aw * bz;
    out[3] = aw * bw - az * bz;
    return out;
}
function $18cb46528d87b2b6$export$1544d9bc2995de08(out, a, b, t) {
    // benchmarks:
    //    http://jsperf.com/quaternion-slerp-implementations
    let ax = a[0], ay = a[1], az = a[2], aw = a[3];
    let bx = b[0], by = b[1], bz = b[2], bw = b[3];
    let omega, cosom, sinom, scale0, scale1;
    // calc cosine
    cosom = ax * bx + ay * by + az * bz + aw * bw;
    // adjust signs (if necessary)
    if (cosom < 0.0) {
        cosom = -cosom;
        bx = -bx;
        by = -by;
        bz = -bz;
        bw = -bw;
    }
    // calculate coefficients
    if (1.0 - cosom > 0.000001) {
        // standard case (slerp)
        omega = Math.acos(cosom);
        sinom = Math.sin(omega);
        scale0 = Math.sin((1.0 - t) * omega) / sinom;
        scale1 = Math.sin(t * omega) / sinom;
    } else {
        // "from" and "to" quaternions are very close
        //  ... so we can do a linear interpolation
        scale0 = 1.0 - t;
        scale1 = t;
    }
    // calculate final values
    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;
    return out;
}
function $18cb46528d87b2b6$export$6897c284b6f9f4dc(out, a) {
    let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    let dot = a0 * a0 + a1 * a1 + a2 * a2 + a3 * a3;
    let invDot = dot ? 1.0 / dot : 0;
    // TODO: Would be faster to return [0,0,0,0] immediately if dot == 0
    out[0] = -a0 * invDot;
    out[1] = -a1 * invDot;
    out[2] = -a2 * invDot;
    out[3] = a3 * invDot;
    return out;
}
function $18cb46528d87b2b6$export$7679f47e72c62560(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = a[3];
    return out;
}
function $18cb46528d87b2b6$export$272a1eb8e5a4b55b(out, m) {
    // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
    // article "Quaternion Calculus and Fast Animation".
    let fTrace = m[0] + m[4] + m[8];
    let fRoot;
    if (fTrace > 0.0) {
        // |w| > 1/2, may as well choose w > 1/2
        fRoot = Math.sqrt(fTrace + 1.0); // 2w
        out[3] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot; // 1/(4w)
        out[0] = (m[5] - m[7]) * fRoot;
        out[1] = (m[6] - m[2]) * fRoot;
        out[2] = (m[1] - m[3]) * fRoot;
    } else {
        // |w| <= 1/2
        let i = 0;
        if (m[4] > m[0]) i = 1;
        if (m[8] > m[i * 3 + i]) i = 2;
        let j = (i + 1) % 3;
        let k = (i + 2) % 3;
        fRoot = Math.sqrt(m[i * 3 + i] - m[j * 3 + j] - m[k * 3 + k] + 1.0);
        out[i] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot;
        out[3] = (m[j * 3 + k] - m[k * 3 + j]) * fRoot;
        out[j] = (m[j * 3 + i] + m[i * 3 + j]) * fRoot;
        out[k] = (m[k * 3 + i] + m[i * 3 + k]) * fRoot;
    }
    return out;
}
function $18cb46528d87b2b6$export$7a404a587ea85af(out, euler, order = "YXZ") {
    let sx = Math.sin(euler[0] * 0.5);
    let cx = Math.cos(euler[0] * 0.5);
    let sy = Math.sin(euler[1] * 0.5);
    let cy = Math.cos(euler[1] * 0.5);
    let sz = Math.sin(euler[2] * 0.5);
    let cz = Math.cos(euler[2] * 0.5);
    if (order === "XYZ") {
        out[0] = sx * cy * cz + cx * sy * sz;
        out[1] = cx * sy * cz - sx * cy * sz;
        out[2] = cx * cy * sz + sx * sy * cz;
        out[3] = cx * cy * cz - sx * sy * sz;
    } else if (order === "YXZ") {
        out[0] = sx * cy * cz + cx * sy * sz;
        out[1] = cx * sy * cz - sx * cy * sz;
        out[2] = cx * cy * sz - sx * sy * cz;
        out[3] = cx * cy * cz + sx * sy * sz;
    } else if (order === "ZXY") {
        out[0] = sx * cy * cz - cx * sy * sz;
        out[1] = cx * sy * cz + sx * cy * sz;
        out[2] = cx * cy * sz + sx * sy * cz;
        out[3] = cx * cy * cz - sx * sy * sz;
    } else if (order === "ZYX") {
        out[0] = sx * cy * cz - cx * sy * sz;
        out[1] = cx * sy * cz + sx * cy * sz;
        out[2] = cx * cy * sz - sx * sy * cz;
        out[3] = cx * cy * cz + sx * sy * sz;
    } else if (order === "YZX") {
        out[0] = sx * cy * cz + cx * sy * sz;
        out[1] = cx * sy * cz + sx * cy * sz;
        out[2] = cx * cy * sz - sx * sy * cz;
        out[3] = cx * cy * cz - sx * sy * sz;
    } else if (order === "XZY") {
        out[0] = sx * cy * cz - cx * sy * sz;
        out[1] = cx * sy * cz - sx * cy * sz;
        out[2] = cx * cy * sz + sx * sy * cz;
        out[3] = cx * cy * cz + sx * sy * sz;
    }
    return out;
}
const $18cb46528d87b2b6$export$784d13d8ee351f07 = $faaca60ecfc6315f$export$784d13d8ee351f07;
const $18cb46528d87b2b6$export$adaa4cf7ef1b65be = $faaca60ecfc6315f$export$adaa4cf7ef1b65be;
const $18cb46528d87b2b6$export$e16d8520af44a096 = $faaca60ecfc6315f$export$e16d8520af44a096;
const $18cb46528d87b2b6$export$dcdf75081b88279d = $faaca60ecfc6315f$export$dcdf75081b88279d;
const $18cb46528d87b2b6$export$94132a0e348806d4 = $faaca60ecfc6315f$export$94132a0e348806d4;
const $18cb46528d87b2b6$export$3a89f8d6f6bf6c9f = $faaca60ecfc6315f$export$3a89f8d6f6bf6c9f;
const $18cb46528d87b2b6$export$f24224f1c91d8156 = $faaca60ecfc6315f$export$f24224f1c91d8156;
const $18cb46528d87b2b6$export$a3295358bff77e = $faaca60ecfc6315f$export$a3295358bff77e;


class $8bba1ae865bec56b$export$5edfe12bb88684c8 extends Array {
    constructor(x = 0, y = 0, z = 0, w = 1){
        super(x, y, z, w);
        this.onChange = ()=>{};
        return this;
    }
    get x() {
        return this[0];
    }
    get y() {
        return this[1];
    }
    get z() {
        return this[2];
    }
    get w() {
        return this[3];
    }
    set x(v) {
        this[0] = v;
        this.onChange();
    }
    set y(v) {
        this[1] = v;
        this.onChange();
    }
    set z(v) {
        this[2] = v;
        this.onChange();
    }
    set w(v) {
        this[3] = v;
        this.onChange();
    }
    identity() {
        $18cb46528d87b2b6$export$f0954fd7d5368655(this);
        this.onChange();
        return this;
    }
    set(x, y, z, w) {
        if (x.length) return this.copy(x);
        $18cb46528d87b2b6$export$adaa4cf7ef1b65be(this, x, y, z, w);
        this.onChange();
        return this;
    }
    rotateX(a) {
        $18cb46528d87b2b6$export$a59c8716592e09af(this, this, a);
        this.onChange();
        return this;
    }
    rotateY(a) {
        $18cb46528d87b2b6$export$cf71e4d4ca4d1cfd(this, this, a);
        this.onChange();
        return this;
    }
    rotateZ(a) {
        $18cb46528d87b2b6$export$ea6eae3365de5b9c(this, this, a);
        this.onChange();
        return this;
    }
    inverse(q = this) {
        $18cb46528d87b2b6$export$6897c284b6f9f4dc(this, q);
        this.onChange();
        return this;
    }
    conjugate(q = this) {
        $18cb46528d87b2b6$export$7679f47e72c62560(this, q);
        this.onChange();
        return this;
    }
    copy(q) {
        $18cb46528d87b2b6$export$784d13d8ee351f07(this, q);
        this.onChange();
        return this;
    }
    normalize(q = this) {
        $18cb46528d87b2b6$export$a3295358bff77e(this, q);
        this.onChange();
        return this;
    }
    multiply(qA, qB) {
        if (qB) $18cb46528d87b2b6$export$2060d2db72cce88f(this, qA, qB);
        else $18cb46528d87b2b6$export$2060d2db72cce88f(this, this, qA);
        this.onChange();
        return this;
    }
    dot(v) {
        return $18cb46528d87b2b6$export$94132a0e348806d4(this, v);
    }
    fromMatrix3(matrix3) {
        $18cb46528d87b2b6$export$272a1eb8e5a4b55b(this, matrix3);
        this.onChange();
        return this;
    }
    fromEuler(euler) {
        $18cb46528d87b2b6$export$7a404a587ea85af(this, euler, euler.order);
        return this;
    }
    fromAxisAngle(axis, a) {
        $18cb46528d87b2b6$export$4286ddefc8f49512(this, axis, a);
        this.onChange();
        return this;
    }
    slerp(q, t) {
        $18cb46528d87b2b6$export$1544d9bc2995de08(this, this, q, t);
        this.onChange();
        return this;
    }
    fromArray(a, o = 0) {
        this[0] = a[o];
        this[1] = a[o + 1];
        this[2] = a[o + 2];
        this[3] = a[o + 3];
        this.onChange();
        return this;
    }
    toArray(a = [], o = 0) {
        a[o] = this[0];
        a[o + 1] = this[1];
        a[o + 2] = this[2];
        a[o + 3] = this[3];
        return a;
    }
}


const $591f20e2c018a8ab$var$EPSILON = 0.000001;
function $591f20e2c018a8ab$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $591f20e2c018a8ab$export$adaa4cf7ef1b65be(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $591f20e2c018a8ab$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $591f20e2c018a8ab$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        let a01 = a[1], a02 = a[2], a03 = a[3];
        let a12 = a[6], a13 = a[7];
        let a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
}
function $591f20e2c018a8ab$export$6897c284b6f9f4dc(out, a) {
    let a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    let a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    let a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    let a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    let b00 = a00 * a11 - a01 * a10;
    let b01 = a00 * a12 - a02 * a10;
    let b02 = a00 * a13 - a03 * a10;
    let b03 = a01 * a12 - a02 * a11;
    let b04 = a01 * a13 - a03 * a11;
    let b05 = a02 * a13 - a03 * a12;
    let b06 = a20 * a31 - a21 * a30;
    let b07 = a20 * a32 - a22 * a30;
    let b08 = a20 * a33 - a23 * a30;
    let b09 = a21 * a32 - a22 * a31;
    let b10 = a21 * a33 - a23 * a31;
    let b11 = a22 * a33 - a23 * a32;
    // Calculate the determinant
    let det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
function $591f20e2c018a8ab$export$a04698f914c55ed9(a) {
    let a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    let a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    let a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    let a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    let b00 = a00 * a11 - a01 * a10;
    let b01 = a00 * a12 - a02 * a10;
    let b02 = a00 * a13 - a03 * a10;
    let b03 = a01 * a12 - a02 * a11;
    let b04 = a01 * a13 - a03 * a11;
    let b05 = a02 * a13 - a03 * a12;
    let b06 = a20 * a31 - a21 * a30;
    let b07 = a20 * a32 - a22 * a30;
    let b08 = a20 * a33 - a23 * a30;
    let b09 = a21 * a32 - a22 * a31;
    let b10 = a21 * a33 - a23 * a31;
    let b11 = a22 * a33 - a23 * a32;
    // Calculate the determinant
    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
function $591f20e2c018a8ab$export$2060d2db72cce88f(out, a, b) {
    let a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    let a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    let a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    let a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    // Cache only the current line of the second matrix
    let b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
function $591f20e2c018a8ab$export$d73ee8ef04f5226a(out, a, v) {
    let x = v[0], y = v[1], z = v[2];
    let a00, a01, a02, a03;
    let a10, a11, a12, a13;
    let a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
function $591f20e2c018a8ab$export$dcdf75081b88279d(out, a, v) {
    let x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $591f20e2c018a8ab$export$bb628a54ab399bc9(out, a, rad, axis) {
    let x = axis[0], y = axis[1], z = axis[2];
    let len = Math.hypot(x, y, z);
    let s, c, t;
    let a00, a01, a02, a03;
    let a10, a11, a12, a13;
    let a20, a21, a22, a23;
    let b00, b01, b02;
    let b10, b11, b12;
    let b20, b21, b22;
    if (Math.abs(len) < $591f20e2c018a8ab$var$EPSILON) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11];
    // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c;
    // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
}
function $591f20e2c018a8ab$export$202e99f82f7f0395(out, mat) {
    out[0] = mat[12];
    out[1] = mat[13];
    out[2] = mat[14];
    return out;
}
function $591f20e2c018a8ab$export$71dc54d92bd04b57(out, mat) {
    let m11 = mat[0];
    let m12 = mat[1];
    let m13 = mat[2];
    let m21 = mat[4];
    let m22 = mat[5];
    let m23 = mat[6];
    let m31 = mat[8];
    let m32 = mat[9];
    let m33 = mat[10];
    out[0] = Math.hypot(m11, m12, m13);
    out[1] = Math.hypot(m21, m22, m23);
    out[2] = Math.hypot(m31, m32, m33);
    return out;
}
function $591f20e2c018a8ab$export$6276f53cd18ff805(mat) {
    let m11 = mat[0];
    let m12 = mat[1];
    let m13 = mat[2];
    let m21 = mat[4];
    let m22 = mat[5];
    let m23 = mat[6];
    let m31 = mat[8];
    let m32 = mat[9];
    let m33 = mat[10];
    const x = m11 * m11 + m12 * m12 + m13 * m13;
    const y = m21 * m21 + m22 * m22 + m23 * m23;
    const z = m31 * m31 + m32 * m32 + m33 * m33;
    return Math.sqrt(Math.max(x, y, z));
}
const $591f20e2c018a8ab$export$df3937d3b537df0a = function() {
    const temp = [
        1,
        1,
        1
    ];
    return function(out, mat) {
        let scaling = temp;
        $591f20e2c018a8ab$export$71dc54d92bd04b57(scaling, mat);
        let is1 = 1 / scaling[0];
        let is2 = 1 / scaling[1];
        let is3 = 1 / scaling[2];
        let sm11 = mat[0] * is1;
        let sm12 = mat[1] * is2;
        let sm13 = mat[2] * is3;
        let sm21 = mat[4] * is1;
        let sm22 = mat[5] * is2;
        let sm23 = mat[6] * is3;
        let sm31 = mat[8] * is1;
        let sm32 = mat[9] * is2;
        let sm33 = mat[10] * is3;
        let trace = sm11 + sm22 + sm33;
        let S = 0;
        if (trace > 0) {
            S = Math.sqrt(trace + 1.0) * 2;
            out[3] = 0.25 * S;
            out[0] = (sm23 - sm32) / S;
            out[1] = (sm31 - sm13) / S;
            out[2] = (sm12 - sm21) / S;
        } else if (sm11 > sm22 && sm11 > sm33) {
            S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
            out[3] = (sm23 - sm32) / S;
            out[0] = 0.25 * S;
            out[1] = (sm12 + sm21) / S;
            out[2] = (sm31 + sm13) / S;
        } else if (sm22 > sm33) {
            S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
            out[3] = (sm31 - sm13) / S;
            out[0] = (sm12 + sm21) / S;
            out[1] = 0.25 * S;
            out[2] = (sm23 + sm32) / S;
        } else {
            S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
            out[3] = (sm12 - sm21) / S;
            out[0] = (sm31 + sm13) / S;
            out[1] = (sm23 + sm32) / S;
            out[2] = 0.25 * S;
        }
        return out;
    };
}();
function $591f20e2c018a8ab$export$ddf9c55c9f2be172(out, q, v, s) {
    // Quaternion math
    let x = q[0], y = q[1], z = q[2], w = q[3];
    let x2 = x + x;
    let y2 = y + y;
    let z2 = z + z;
    let xx = x * x2;
    let xy = x * y2;
    let xz = x * z2;
    let yy = y * y2;
    let yz = y * z2;
    let zz = z * z2;
    let wx = w * x2;
    let wy = w * y2;
    let wz = w * z2;
    let sx = s[0];
    let sy = s[1];
    let sz = s[2];
    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $591f20e2c018a8ab$export$2ff2bbe382249af7(out, q) {
    let x = q[0], y = q[1], z = q[2], w = q[3];
    let x2 = x + x;
    let y2 = y + y;
    let z2 = z + z;
    let xx = x * x2;
    let yx = y * x2;
    let yy = y * y2;
    let zx = z * x2;
    let zy = z * y2;
    let zz = z * z2;
    let wx = w * x2;
    let wy = w * y2;
    let wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $591f20e2c018a8ab$export$541149539f3a4684(out, fovy, aspect, near, far) {
    let f = 1.0 / Math.tan(fovy / 2);
    let nf = 1 / (near - far);
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = 2 * far * near * nf;
    out[15] = 0;
    return out;
}
function $591f20e2c018a8ab$export$4f2167e613cfc87b(out, left, right, bottom, top, near, far) {
    let lr = 1 / (left - right);
    let bt = 1 / (bottom - top);
    let nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}
function $591f20e2c018a8ab$export$aa67782f4dc9e52c(out, eye, target, up) {
    let eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2];
    let z0 = eyex - target[0], z1 = eyey - target[1], z2 = eyez - target[2];
    let len = z0 * z0 + z1 * z1 + z2 * z2;
    if (len === 0) // eye and target are in the same position
    z2 = 1;
    else {
        len = 1 / Math.sqrt(len);
        z0 *= len;
        z1 *= len;
        z2 *= len;
    }
    let x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
    len = x0 * x0 + x1 * x1 + x2 * x2;
    if (len === 0) {
        // up and z are parallel
        if (upz) upx += 1e-6;
        else if (upy) upz += 1e-6;
        else upy += 1e-6;
        x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
        len = x0 * x0 + x1 * x1 + x2 * x2;
    }
    len = 1 / Math.sqrt(len);
    x0 *= len;
    x1 *= len;
    x2 *= len;
    out[0] = x0;
    out[1] = x1;
    out[2] = x2;
    out[3] = 0;
    out[4] = z1 * x2 - z2 * x1;
    out[5] = z2 * x0 - z0 * x2;
    out[6] = z0 * x1 - z1 * x0;
    out[7] = 0;
    out[8] = z0;
    out[9] = z1;
    out[10] = z2;
    out[11] = 0;
    out[12] = eyex;
    out[13] = eyey;
    out[14] = eyez;
    out[15] = 1;
    return out;
}
function $591f20e2c018a8ab$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    out[9] = a[9] + b[9];
    out[10] = a[10] + b[10];
    out[11] = a[11] + b[11];
    out[12] = a[12] + b[12];
    out[13] = a[13] + b[13];
    out[14] = a[14] + b[14];
    out[15] = a[15] + b[15];
    return out;
}
function $591f20e2c018a8ab$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    out[9] = a[9] - b[9];
    out[10] = a[10] - b[10];
    out[11] = a[11] - b[11];
    out[12] = a[12] - b[12];
    out[13] = a[13] - b[13];
    out[14] = a[14] - b[14];
    out[15] = a[15] - b[15];
    return out;
}
function $591f20e2c018a8ab$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    out[9] = a[9] * b;
    out[10] = a[10] * b;
    out[11] = a[11] * b;
    out[12] = a[12] * b;
    out[13] = a[13] * b;
    out[14] = a[14] * b;
    out[15] = a[15] * b;
    return out;
}


class $6b06e593d6b503e3$export$21c0e3d5e995d7e1 extends Array {
    constructor(m00 = 1, m01 = 0, m02 = 0, m03 = 0, m10 = 0, m11 = 1, m12 = 0, m13 = 0, m20 = 0, m21 = 0, m22 = 1, m23 = 0, m30 = 0, m31 = 0, m32 = 0, m33 = 1){
        super(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33);
        return this;
    }
    get x() {
        return this[12];
    }
    get y() {
        return this[13];
    }
    get z() {
        return this[14];
    }
    get w() {
        return this[15];
    }
    set x(v) {
        this[12] = v;
    }
    set y(v) {
        this[13] = v;
    }
    set z(v) {
        this[14] = v;
    }
    set w(v) {
        this[15] = v;
    }
    set(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
        if (m00.length) return this.copy(m00);
        $591f20e2c018a8ab$export$adaa4cf7ef1b65be(this, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33);
        return this;
    }
    translate(v, m = this) {
        $591f20e2c018a8ab$export$d73ee8ef04f5226a(this, m, v);
        return this;
    }
    rotate(v, axis, m = this) {
        $591f20e2c018a8ab$export$bb628a54ab399bc9(this, m, v, axis);
        return this;
    }
    scale(v, m = this) {
        $591f20e2c018a8ab$export$dcdf75081b88279d(this, m, typeof v === "number" ? [
            v,
            v,
            v
        ] : v);
        return this;
    }
    add(ma, mb) {
        if (mb) $591f20e2c018a8ab$export$e16d8520af44a096(this, ma, mb);
        else $591f20e2c018a8ab$export$e16d8520af44a096(this, this, ma);
        return this;
    }
    sub(ma, mb) {
        if (mb) $591f20e2c018a8ab$export$4e2d2ead65e5f7e3(this, ma, mb);
        else $591f20e2c018a8ab$export$4e2d2ead65e5f7e3(this, this, ma);
        return this;
    }
    multiply(ma, mb) {
        if (!ma.length) $591f20e2c018a8ab$export$c697bed75648cdb7(this, this, ma);
        else if (mb) $591f20e2c018a8ab$export$2060d2db72cce88f(this, ma, mb);
        else $591f20e2c018a8ab$export$2060d2db72cce88f(this, this, ma);
        return this;
    }
    identity() {
        $591f20e2c018a8ab$export$f0954fd7d5368655(this);
        return this;
    }
    copy(m) {
        $591f20e2c018a8ab$export$784d13d8ee351f07(this, m);
        return this;
    }
    fromPerspective({ fov: fov, aspect: aspect, near: near, far: far } = {}) {
        $591f20e2c018a8ab$export$541149539f3a4684(this, fov, aspect, near, far);
        return this;
    }
    fromOrthogonal({ left: left, right: right, bottom: bottom, top: top, near: near, far: far }) {
        $591f20e2c018a8ab$export$4f2167e613cfc87b(this, left, right, bottom, top, near, far);
        return this;
    }
    fromQuaternion(q) {
        $591f20e2c018a8ab$export$2ff2bbe382249af7(this, q);
        return this;
    }
    setPosition(v) {
        this.x = v[0];
        this.y = v[1];
        this.z = v[2];
        return this;
    }
    inverse(m = this) {
        $591f20e2c018a8ab$export$6897c284b6f9f4dc(this, m);
        return this;
    }
    compose(q, pos, scale) {
        $591f20e2c018a8ab$export$ddf9c55c9f2be172(this, q, pos, scale);
        return this;
    }
    getRotation(q) {
        $591f20e2c018a8ab$export$df3937d3b537df0a(q, this);
        return this;
    }
    getTranslation(pos) {
        $591f20e2c018a8ab$export$202e99f82f7f0395(pos, this);
        return this;
    }
    getScaling(scale) {
        $591f20e2c018a8ab$export$71dc54d92bd04b57(scale, this);
        return this;
    }
    getMaxScaleOnAxis() {
        return $591f20e2c018a8ab$export$6276f53cd18ff805(this);
    }
    lookAt(eye, target, up) {
        $591f20e2c018a8ab$export$aa67782f4dc9e52c(this, eye, target, up);
        return this;
    }
    determinant() {
        return $591f20e2c018a8ab$export$a04698f914c55ed9(this);
    }
    fromArray(a, o = 0) {
        this[0] = a[o];
        this[1] = a[o + 1];
        this[2] = a[o + 2];
        this[3] = a[o + 3];
        this[4] = a[o + 4];
        this[5] = a[o + 5];
        this[6] = a[o + 6];
        this[7] = a[o + 7];
        this[8] = a[o + 8];
        this[9] = a[o + 9];
        this[10] = a[o + 10];
        this[11] = a[o + 11];
        this[12] = a[o + 12];
        this[13] = a[o + 13];
        this[14] = a[o + 14];
        this[15] = a[o + 15];
        return this;
    }
    toArray(a = [], o = 0) {
        a[o] = this[0];
        a[o + 1] = this[1];
        a[o + 2] = this[2];
        a[o + 3] = this[3];
        a[o + 4] = this[4];
        a[o + 5] = this[5];
        a[o + 6] = this[6];
        a[o + 7] = this[7];
        a[o + 8] = this[8];
        a[o + 9] = this[9];
        a[o + 10] = this[10];
        a[o + 11] = this[11];
        a[o + 12] = this[12];
        a[o + 13] = this[13];
        a[o + 14] = this[14];
        a[o + 15] = this[15];
        return a;
    }
}


// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
function $ef83b3cac9aab7a2$export$48889b85f55f068c(out, m, order = "YXZ") {
    if (order === "XYZ") {
        out[1] = Math.asin(Math.min(Math.max(m[8], -1), 1));
        if (Math.abs(m[8]) < 0.99999) {
            out[0] = Math.atan2(-m[9], m[10]);
            out[2] = Math.atan2(-m[4], m[0]);
        } else {
            out[0] = Math.atan2(m[6], m[5]);
            out[2] = 0;
        }
    } else if (order === "YXZ") {
        out[0] = Math.asin(-Math.min(Math.max(m[9], -1), 1));
        if (Math.abs(m[9]) < 0.99999) {
            out[1] = Math.atan2(m[8], m[10]);
            out[2] = Math.atan2(m[1], m[5]);
        } else {
            out[1] = Math.atan2(-m[2], m[0]);
            out[2] = 0;
        }
    } else if (order === "ZXY") {
        out[0] = Math.asin(Math.min(Math.max(m[6], -1), 1));
        if (Math.abs(m[6]) < 0.99999) {
            out[1] = Math.atan2(-m[2], m[10]);
            out[2] = Math.atan2(-m[4], m[5]);
        } else {
            out[1] = 0;
            out[2] = Math.atan2(m[1], m[0]);
        }
    } else if (order === "ZYX") {
        out[1] = Math.asin(-Math.min(Math.max(m[2], -1), 1));
        if (Math.abs(m[2]) < 0.99999) {
            out[0] = Math.atan2(m[6], m[10]);
            out[2] = Math.atan2(m[1], m[0]);
        } else {
            out[0] = 0;
            out[2] = Math.atan2(-m[4], m[5]);
        }
    } else if (order === "YZX") {
        out[2] = Math.asin(Math.min(Math.max(m[1], -1), 1));
        if (Math.abs(m[1]) < 0.99999) {
            out[0] = Math.atan2(-m[9], m[5]);
            out[1] = Math.atan2(-m[2], m[0]);
        } else {
            out[0] = 0;
            out[1] = Math.atan2(m[8], m[10]);
        }
    } else if (order === "XZY") {
        out[2] = Math.asin(-Math.min(Math.max(m[4], -1), 1));
        if (Math.abs(m[4]) < 0.99999) {
            out[0] = Math.atan2(m[6], m[5]);
            out[1] = Math.atan2(m[8], m[0]);
        } else {
            out[0] = Math.atan2(-m[9], m[10]);
            out[1] = 0;
        }
    }
    return out;
}



const $7a2a181fbb485d77$var$tmpMat4 = /* @__PURE__ */ new (0, $6b06e593d6b503e3$export$21c0e3d5e995d7e1)();
class $7a2a181fbb485d77$export$d93cc409a0768c5f extends Array {
    constructor(x = 0, y = x, z = x, order = "YXZ"){
        super(x, y, z);
        this.order = order;
        this.onChange = ()=>{};
        return this;
    }
    get x() {
        return this[0];
    }
    get y() {
        return this[1];
    }
    get z() {
        return this[2];
    }
    set x(v) {
        this[0] = v;
        this.onChange();
    }
    set y(v) {
        this[1] = v;
        this.onChange();
    }
    set z(v) {
        this[2] = v;
        this.onChange();
    }
    set(x, y = x, z = x) {
        if (x.length) return this.copy(x);
        this[0] = x;
        this[1] = y;
        this[2] = z;
        this.onChange();
        return this;
    }
    copy(v) {
        this[0] = v[0];
        this[1] = v[1];
        this[2] = v[2];
        this.onChange();
        return this;
    }
    reorder(order) {
        this.order = order;
        this.onChange();
        return this;
    }
    fromRotationMatrix(m, order = this.order) {
        $ef83b3cac9aab7a2$export$48889b85f55f068c(this, m, order);
        this.onChange();
        return this;
    }
    fromQuaternion(q, order = this.order) {
        $7a2a181fbb485d77$var$tmpMat4.fromQuaternion(q);
        return this.fromRotationMatrix($7a2a181fbb485d77$var$tmpMat4, order);
    }
    fromArray(a, o = 0) {
        this[0] = a[o];
        this[1] = a[o + 1];
        this[2] = a[o + 2];
        return this;
    }
    toArray(a = [], o = 0) {
        a[o] = this[0];
        a[o + 1] = this[1];
        a[o + 2] = this[2];
        return a;
    }
}


class $7f271013d8caa07e$export$563a914cafbdc389 {
    constructor(){
        this.parent = null;
        this.children = [];
        this.visible = true;
        this.matrix = new (0, $6b06e593d6b503e3$export$21c0e3d5e995d7e1)();
        this.worldMatrix = new (0, $6b06e593d6b503e3$export$21c0e3d5e995d7e1)();
        this.matrixAutoUpdate = true;
        this.worldMatrixNeedsUpdate = false;
        this.position = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
        this.quaternion = new (0, $8bba1ae865bec56b$export$5edfe12bb88684c8)();
        this.scale = new (0, $77acc528c45f5d37$export$838423f3adec30fa)(1);
        this.rotation = new (0, $7a2a181fbb485d77$export$d93cc409a0768c5f)();
        this.up = new (0, $77acc528c45f5d37$export$838423f3adec30fa)(0, 1, 0);
        this.rotation.onChange = ()=>this.quaternion.fromEuler(this.rotation);
        this.quaternion.onChange = ()=>this.rotation.fromQuaternion(this.quaternion);
    }
    setParent(parent, notifyParent = true) {
        if (this.parent && parent !== this.parent) this.parent.removeChild(this, false);
        this.parent = parent;
        if (notifyParent && parent) parent.addChild(this, false);
    }
    addChild(child, notifyChild = true) {
        if (!~this.children.indexOf(child)) this.children.push(child);
        if (notifyChild) child.setParent(this, false);
    }
    removeChild(child, notifyChild = true) {
        if (!!~this.children.indexOf(child)) this.children.splice(this.children.indexOf(child), 1);
        if (notifyChild) child.setParent(null, false);
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.worldMatrixNeedsUpdate || force) {
            if (this.parent === null) this.worldMatrix.copy(this.matrix);
            else this.worldMatrix.multiply(this.parent.worldMatrix, this.matrix);
            this.worldMatrixNeedsUpdate = false;
            force = true;
        }
        for(let i = 0, l = this.children.length; i < l; i++)this.children[i].updateMatrixWorld(force);
    }
    updateMatrix() {
        this.matrix.compose(this.quaternion, this.position, this.scale);
        this.worldMatrixNeedsUpdate = true;
    }
    traverse(callback) {
        // Return true in callback to stop traversing children
        if (callback(this)) return;
        for(let i = 0, l = this.children.length; i < l; i++)this.children[i].traverse(callback);
    }
    decompose() {
        this.matrix.getTranslation(this.position);
        this.matrix.getRotation(this.quaternion);
        this.matrix.getScaling(this.scale);
        this.rotation.fromQuaternion(this.quaternion);
    }
    lookAt(target, invert = false) {
        if (invert) this.matrix.lookAt(this.position, target, this.up);
        else this.matrix.lookAt(target, this.position, this.up);
        this.matrix.getRotation(this.quaternion);
        this.rotation.fromQuaternion(this.quaternion);
    }
}




const $6a03d990fd9755d9$var$tempMat4 = /* @__PURE__ */ new (0, $6b06e593d6b503e3$export$21c0e3d5e995d7e1)();
const $6a03d990fd9755d9$var$tempVec3a = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $6a03d990fd9755d9$var$tempVec3b = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
class $6a03d990fd9755d9$export$79f141de891a5fed extends (0, $7f271013d8caa07e$export$563a914cafbdc389) {
    constructor(gl, { near: near = 0.1, far: far = 100, fov: fov = 45, aspect: aspect = 1, left: left, right: right, bottom: bottom, top: top, zoom: zoom = 1 } = {}){
        super();
        Object.assign(this, {
            near: near,
            far: far,
            fov: fov,
            aspect: aspect,
            left: left,
            right: right,
            bottom: bottom,
            top: top,
            zoom: zoom
        });
        this.projectionMatrix = new (0, $6b06e593d6b503e3$export$21c0e3d5e995d7e1)();
        this.viewMatrix = new (0, $6b06e593d6b503e3$export$21c0e3d5e995d7e1)();
        this.projectionViewMatrix = new (0, $6b06e593d6b503e3$export$21c0e3d5e995d7e1)();
        this.worldPosition = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
        // Use orthographic if left/right set, else default to perspective camera
        this.type = left || right ? "orthographic" : "perspective";
        if (this.type === "orthographic") this.orthographic();
        else this.perspective();
    }
    perspective({ near: near = this.near, far: far = this.far, fov: fov = this.fov, aspect: aspect = this.aspect } = {}) {
        Object.assign(this, {
            near: near,
            far: far,
            fov: fov,
            aspect: aspect
        });
        this.projectionMatrix.fromPerspective({
            fov: fov * (Math.PI / 180),
            aspect: aspect,
            near: near,
            far: far
        });
        this.type = "perspective";
        return this;
    }
    orthographic({ near: near = this.near, far: far = this.far, left: left = this.left || -1, right: right = this.right || 1, bottom: bottom = this.bottom || -1, top: top = this.top || 1, zoom: zoom = this.zoom } = {}) {
        Object.assign(this, {
            near: near,
            far: far,
            left: left,
            right: right,
            bottom: bottom,
            top: top,
            zoom: zoom
        });
        left /= zoom;
        right /= zoom;
        bottom /= zoom;
        top /= zoom;
        this.projectionMatrix.fromOrthogonal({
            left: left,
            right: right,
            bottom: bottom,
            top: top,
            near: near,
            far: far
        });
        this.type = "orthographic";
        return this;
    }
    updateMatrixWorld() {
        super.updateMatrixWorld();
        this.viewMatrix.inverse(this.worldMatrix);
        this.worldMatrix.getTranslation(this.worldPosition);
        // used for sorting
        this.projectionViewMatrix.multiply(this.projectionMatrix, this.viewMatrix);
        return this;
    }
    lookAt(target) {
        super.lookAt(target, true);
        return this;
    }
    // Project 3D coordinate to 2D point
    project(v) {
        v.applyMatrix4(this.viewMatrix);
        v.applyMatrix4(this.projectionMatrix);
        return this;
    }
    // Unproject 2D point to 3D coordinate
    unproject(v) {
        v.applyMatrix4($6a03d990fd9755d9$var$tempMat4.inverse(this.projectionMatrix));
        v.applyMatrix4(this.worldMatrix);
        return this;
    }
    updateFrustum() {
        if (!this.frustum) this.frustum = [
            new (0, $77acc528c45f5d37$export$838423f3adec30fa)(),
            new (0, $77acc528c45f5d37$export$838423f3adec30fa)(),
            new (0, $77acc528c45f5d37$export$838423f3adec30fa)(),
            new (0, $77acc528c45f5d37$export$838423f3adec30fa)(),
            new (0, $77acc528c45f5d37$export$838423f3adec30fa)(),
            new (0, $77acc528c45f5d37$export$838423f3adec30fa)()
        ];
        const m = this.projectionViewMatrix;
        this.frustum[0].set(m[3] - m[0], m[7] - m[4], m[11] - m[8]).constant = m[15] - m[12]; // -x
        this.frustum[1].set(m[3] + m[0], m[7] + m[4], m[11] + m[8]).constant = m[15] + m[12]; // +x
        this.frustum[2].set(m[3] + m[1], m[7] + m[5], m[11] + m[9]).constant = m[15] + m[13]; // +y
        this.frustum[3].set(m[3] - m[1], m[7] - m[5], m[11] - m[9]).constant = m[15] - m[13]; // -y
        this.frustum[4].set(m[3] - m[2], m[7] - m[6], m[11] - m[10]).constant = m[15] - m[14]; // +z (far)
        this.frustum[5].set(m[3] + m[2], m[7] + m[6], m[11] + m[10]).constant = m[15] + m[14]; // -z (near)
        for(let i = 0; i < 6; i++){
            const invLen = 1.0 / this.frustum[i].distance();
            this.frustum[i].multiply(invLen);
            this.frustum[i].constant *= invLen;
        }
    }
    frustumIntersectsMesh(node, worldMatrix = node.worldMatrix) {
        // If no position attribute, treat as frustumCulled false
        if (!node.geometry.attributes.position) return true;
        if (!node.geometry.bounds || node.geometry.bounds.radius === Infinity) node.geometry.computeBoundingSphere();
        if (!node.geometry.bounds) return true;
        const center = $6a03d990fd9755d9$var$tempVec3a;
        center.copy(node.geometry.bounds.center);
        center.applyMatrix4(worldMatrix);
        const radius = node.geometry.bounds.radius * worldMatrix.getMaxScaleOnAxis();
        return this.frustumIntersectsSphere(center, radius);
    }
    frustumIntersectsSphere(center, radius) {
        const normal = $6a03d990fd9755d9$var$tempVec3b;
        for(let i = 0; i < 6; i++){
            const plane = this.frustum[i];
            const distance = normal.copy(plane).dot(center) + plane.constant;
            if (distance < -radius) return false;
        }
        return true;
    }
}




const $f91be6307865e84b$var$EPSILON = 0.000001;
function $f91be6307865e84b$export$b4ad467060d346fe(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[4];
    out[4] = a[5];
    out[5] = a[6];
    out[6] = a[8];
    out[7] = a[9];
    out[8] = a[10];
    return out;
}
function $f91be6307865e84b$export$2ff2bbe382249af7(out, q) {
    let x = q[0], y = q[1], z = q[2], w = q[3];
    let x2 = x + x;
    let y2 = y + y;
    let z2 = z + z;
    let xx = x * x2;
    let yx = y * x2;
    let yy = y * y2;
    let zx = z * x2;
    let zy = z * y2;
    let zz = z * z2;
    let wx = w * x2;
    let wy = w * y2;
    let wz = w * z2;
    out[0] = 1 - yy - zz;
    out[3] = yx - wz;
    out[6] = zx + wy;
    out[1] = yx + wz;
    out[4] = 1 - xx - zz;
    out[7] = zy - wx;
    out[2] = zx - wy;
    out[5] = zy + wx;
    out[8] = 1 - xx - yy;
    return out;
}
function $f91be6307865e84b$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $f91be6307865e84b$export$adaa4cf7ef1b65be(out, m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
function $f91be6307865e84b$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $f91be6307865e84b$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        let a01 = a[1], a02 = a[2], a12 = a[5];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a01;
        out[5] = a[7];
        out[6] = a02;
        out[7] = a12;
    } else {
        out[0] = a[0];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a[1];
        out[4] = a[4];
        out[5] = a[7];
        out[6] = a[2];
        out[7] = a[5];
        out[8] = a[8];
    }
    return out;
}
function $f91be6307865e84b$export$6897c284b6f9f4dc(out, a) {
    let a00 = a[0], a01 = a[1], a02 = a[2];
    let a10 = a[3], a11 = a[4], a12 = a[5];
    let a20 = a[6], a21 = a[7], a22 = a[8];
    let b01 = a22 * a11 - a12 * a21;
    let b11 = -a22 * a10 + a12 * a20;
    let b21 = a21 * a10 - a11 * a20;
    // Calculate the determinant
    let det = a00 * b01 + a01 * b11 + a02 * b21;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = b01 * det;
    out[1] = (-a22 * a01 + a02 * a21) * det;
    out[2] = (a12 * a01 - a02 * a11) * det;
    out[3] = b11 * det;
    out[4] = (a22 * a00 - a02 * a20) * det;
    out[5] = (-a12 * a00 + a02 * a10) * det;
    out[6] = b21 * det;
    out[7] = (-a21 * a00 + a01 * a20) * det;
    out[8] = (a11 * a00 - a01 * a10) * det;
    return out;
}
function $f91be6307865e84b$export$a04698f914c55ed9(a) {
    let a00 = a[0], a01 = a[1], a02 = a[2];
    let a10 = a[3], a11 = a[4], a12 = a[5];
    let a20 = a[6], a21 = a[7], a22 = a[8];
    return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
}
function $f91be6307865e84b$export$2060d2db72cce88f(out, a, b) {
    let a00 = a[0], a01 = a[1], a02 = a[2];
    let a10 = a[3], a11 = a[4], a12 = a[5];
    let a20 = a[6], a21 = a[7], a22 = a[8];
    let b00 = b[0], b01 = b[1], b02 = b[2];
    let b10 = b[3], b11 = b[4], b12 = b[5];
    let b20 = b[6], b21 = b[7], b22 = b[8];
    out[0] = b00 * a00 + b01 * a10 + b02 * a20;
    out[1] = b00 * a01 + b01 * a11 + b02 * a21;
    out[2] = b00 * a02 + b01 * a12 + b02 * a22;
    out[3] = b10 * a00 + b11 * a10 + b12 * a20;
    out[4] = b10 * a01 + b11 * a11 + b12 * a21;
    out[5] = b10 * a02 + b11 * a12 + b12 * a22;
    out[6] = b20 * a00 + b21 * a10 + b22 * a20;
    out[7] = b20 * a01 + b21 * a11 + b22 * a21;
    out[8] = b20 * a02 + b21 * a12 + b22 * a22;
    return out;
}
function $f91be6307865e84b$export$d73ee8ef04f5226a(out, a, v) {
    let a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], x = v[0], y = v[1];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a10;
    out[4] = a11;
    out[5] = a12;
    out[6] = x * a00 + y * a10 + a20;
    out[7] = x * a01 + y * a11 + a21;
    out[8] = x * a02 + y * a12 + a22;
    return out;
}
function $f91be6307865e84b$export$bb628a54ab399bc9(out, a, rad) {
    let a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c * a00 + s * a10;
    out[1] = c * a01 + s * a11;
    out[2] = c * a02 + s * a12;
    out[3] = c * a10 - s * a00;
    out[4] = c * a11 - s * a01;
    out[5] = c * a12 - s * a02;
    out[6] = a20;
    out[7] = a21;
    out[8] = a22;
    return out;
}
function $f91be6307865e84b$export$dcdf75081b88279d(out, a, v) {
    let x = v[0], y = v[1];
    out[0] = x * a[0];
    out[1] = x * a[1];
    out[2] = x * a[2];
    out[3] = y * a[3];
    out[4] = y * a[4];
    out[5] = y * a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $f91be6307865e84b$export$966b25ab6dc1b1f9(out, a) {
    let a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    let a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    let a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    let a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    let b00 = a00 * a11 - a01 * a10;
    let b01 = a00 * a12 - a02 * a10;
    let b02 = a00 * a13 - a03 * a10;
    let b03 = a01 * a12 - a02 * a11;
    let b04 = a01 * a13 - a03 * a11;
    let b05 = a02 * a13 - a03 * a12;
    let b06 = a20 * a31 - a21 * a30;
    let b07 = a20 * a32 - a22 * a30;
    let b08 = a20 * a33 - a23 * a30;
    let b09 = a21 * a32 - a22 * a31;
    let b10 = a21 * a33 - a23 * a31;
    let b11 = a22 * a33 - a23 * a32;
    // Calculate the determinant
    let det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    return out;
}
function $f91be6307865e84b$export$b74061472fe7c07(out, width, height) {
    out[0] = 2 / width;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = -2 / height;
    out[5] = 0;
    out[6] = -1;
    out[7] = 1;
    out[8] = 1;
    return out;
}
function $f91be6307865e84b$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    return out;
}
function $f91be6307865e84b$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    return out;
}
function $f91be6307865e84b$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    return out;
}


class $bf9227dcdf73dea9$export$83f4edd572c84121 extends Array {
    constructor(m00 = 1, m01 = 0, m02 = 0, m10 = 0, m11 = 1, m12 = 0, m20 = 0, m21 = 0, m22 = 1){
        super(m00, m01, m02, m10, m11, m12, m20, m21, m22);
        return this;
    }
    set(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
        if (m00.length) return this.copy(m00);
        $f91be6307865e84b$export$adaa4cf7ef1b65be(this, m00, m01, m02, m10, m11, m12, m20, m21, m22);
        return this;
    }
    translate(v, m = this) {
        $f91be6307865e84b$export$d73ee8ef04f5226a(this, m, v);
        return this;
    }
    rotate(v, m = this) {
        $f91be6307865e84b$export$bb628a54ab399bc9(this, m, v);
        return this;
    }
    scale(v, m = this) {
        $f91be6307865e84b$export$dcdf75081b88279d(this, m, v);
        return this;
    }
    multiply(ma, mb) {
        if (mb) $f91be6307865e84b$export$2060d2db72cce88f(this, ma, mb);
        else $f91be6307865e84b$export$2060d2db72cce88f(this, this, ma);
        return this;
    }
    identity() {
        $f91be6307865e84b$export$f0954fd7d5368655(this);
        return this;
    }
    copy(m) {
        $f91be6307865e84b$export$784d13d8ee351f07(this, m);
        return this;
    }
    fromMatrix4(m) {
        $f91be6307865e84b$export$b4ad467060d346fe(this, m);
        return this;
    }
    fromQuaternion(q) {
        $f91be6307865e84b$export$2ff2bbe382249af7(this, q);
        return this;
    }
    fromBasis(vec3a, vec3b, vec3c) {
        this.set(vec3a[0], vec3a[1], vec3a[2], vec3b[0], vec3b[1], vec3b[2], vec3c[0], vec3c[1], vec3c[2]);
        return this;
    }
    inverse(m = this) {
        $f91be6307865e84b$export$6897c284b6f9f4dc(this, m);
        return this;
    }
    getNormalMatrix(m) {
        $f91be6307865e84b$export$966b25ab6dc1b1f9(this, m);
        return this;
    }
}



let $ce267c790a189d7e$var$ID = 0;
class $ce267c790a189d7e$export$e176487c05830cc5 extends (0, $7f271013d8caa07e$export$563a914cafbdc389) {
    constructor(gl, { geometry: geometry, program: program, mode: mode = gl.TRIANGLES, frustumCulled: frustumCulled = true, renderOrder: renderOrder = 0 } = {}){
        super();
        gl.canvas;
        this.gl = gl;
        this.id = $ce267c790a189d7e$var$ID++;
        this.geometry = geometry;
        this.program = program;
        this.mode = mode;
        // Used to skip frustum culling
        this.frustumCulled = frustumCulled;
        // Override sorting to force an order
        this.renderOrder = renderOrder;
        this.modelViewMatrix = new (0, $6b06e593d6b503e3$export$21c0e3d5e995d7e1)();
        this.normalMatrix = new (0, $bf9227dcdf73dea9$export$83f4edd572c84121)();
        this.beforeRenderCallbacks = [];
        this.afterRenderCallbacks = [];
    }
    onBeforeRender(f) {
        this.beforeRenderCallbacks.push(f);
        return this;
    }
    onAfterRender(f) {
        this.afterRenderCallbacks.push(f);
        return this;
    }
    draw({ camera: camera } = {}) {
        if (camera) {
            // Add empty matrix uniforms to program if unset
            if (!this.program.uniforms.modelMatrix) Object.assign(this.program.uniforms, {
                modelMatrix: {
                    value: null
                },
                viewMatrix: {
                    value: null
                },
                modelViewMatrix: {
                    value: null
                },
                normalMatrix: {
                    value: null
                },
                projectionMatrix: {
                    value: null
                },
                cameraPosition: {
                    value: null
                }
            });
            // Set the matrix uniforms
            this.program.uniforms.projectionMatrix.value = camera.projectionMatrix;
            this.program.uniforms.cameraPosition.value = camera.worldPosition;
            this.program.uniforms.viewMatrix.value = camera.viewMatrix;
            this.modelViewMatrix.multiply(camera.viewMatrix, this.worldMatrix);
            this.normalMatrix.getNormalMatrix(this.modelViewMatrix);
            this.program.uniforms.modelMatrix.value = this.worldMatrix;
            this.program.uniforms.modelViewMatrix.value = this.modelViewMatrix;
            this.program.uniforms.normalMatrix.value = this.normalMatrix;
        }
        this.beforeRenderCallbacks.forEach((f)=>f && f({
                mesh: this,
                camera: camera
            }));
        // determine if faces need to be flipped - when mesh scaled negatively
        let flipFaces = this.program.cullFace && this.worldMatrix.determinant() < 0;
        this.program.use({
            flipFaces: flipFaces
        });
        this.geometry.draw({
            mode: this.mode,
            program: this.program
        });
        this.afterRenderCallbacks.forEach((f)=>f && f({
                mesh: this,
                camera: camera
            }));
    }
}


// TODO: delete texture
// TODO: use texSubImage2D for updates (video or when loaded)
// TODO: need? encoding = linearEncoding
// TODO: support non-compressed mipmaps uploads
const $456587f66521e022$var$emptyPixel = new Uint8Array(4);
function $456587f66521e022$var$isPowerOf2(value) {
    return (value & value - 1) === 0;
}
let $456587f66521e022$var$ID = 1;
class $456587f66521e022$export$5431306cf43de24a {
    constructor(gl, { image: image, target: target = gl.TEXTURE_2D, type: type = gl.UNSIGNED_BYTE, format: format = gl.RGBA, internalFormat: internalFormat = format, wrapS: wrapS = gl.CLAMP_TO_EDGE, wrapT: wrapT = gl.CLAMP_TO_EDGE, generateMipmaps: generateMipmaps = true, minFilter: minFilter = generateMipmaps ? gl.NEAREST_MIPMAP_LINEAR : gl.LINEAR, magFilter: magFilter = gl.LINEAR, premultiplyAlpha: premultiplyAlpha = false, unpackAlignment: unpackAlignment = 4, flipY: flipY = target == gl.TEXTURE_2D ? true : false, anisotropy: anisotropy = 0, level: level = 0, width: width, height: // used for RenderTargets or Data Textures
    height = width } = {}){
        this.gl = gl;
        this.id = $456587f66521e022$var$ID++;
        this.image = image;
        this.target = target;
        this.type = type;
        this.format = format;
        this.internalFormat = internalFormat;
        this.minFilter = minFilter;
        this.magFilter = magFilter;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.generateMipmaps = generateMipmaps;
        this.premultiplyAlpha = premultiplyAlpha;
        this.unpackAlignment = unpackAlignment;
        this.flipY = flipY;
        this.anisotropy = Math.min(anisotropy, this.gl.renderer.parameters.maxAnisotropy);
        this.level = level;
        this.width = width;
        this.height = height;
        this.texture = this.gl.createTexture();
        this.store = {
            image: null
        };
        // Alias for state store to avoid redundant calls for global state
        this.glState = this.gl.renderer.state;
        // State store to avoid redundant calls for per-texture state
        this.state = {};
        this.state.minFilter = this.gl.NEAREST_MIPMAP_LINEAR;
        this.state.magFilter = this.gl.LINEAR;
        this.state.wrapS = this.gl.REPEAT;
        this.state.wrapT = this.gl.REPEAT;
        this.state.anisotropy = 0;
    }
    bind() {
        // Already bound to active texture unit
        if (this.glState.textureUnits[this.glState.activeTextureUnit] === this.id) return;
        this.gl.bindTexture(this.target, this.texture);
        this.glState.textureUnits[this.glState.activeTextureUnit] = this.id;
    }
    update(textureUnit = 0) {
        const needsUpdate = !(this.image === this.store.image && !this.needsUpdate);
        // Make sure that texture is bound to its texture unit
        if (needsUpdate || this.glState.textureUnits[textureUnit] !== this.id) {
            // set active texture unit to perform texture functions
            this.gl.renderer.activeTexture(textureUnit);
            this.bind();
        }
        if (!needsUpdate) return;
        this.needsUpdate = false;
        if (this.flipY !== this.glState.flipY) {
            this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, this.flipY);
            this.glState.flipY = this.flipY;
        }
        if (this.premultiplyAlpha !== this.glState.premultiplyAlpha) {
            this.gl.pixelStorei(this.gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.premultiplyAlpha);
            this.glState.premultiplyAlpha = this.premultiplyAlpha;
        }
        if (this.unpackAlignment !== this.glState.unpackAlignment) {
            this.gl.pixelStorei(this.gl.UNPACK_ALIGNMENT, this.unpackAlignment);
            this.glState.unpackAlignment = this.unpackAlignment;
        }
        if (this.minFilter !== this.state.minFilter) {
            this.gl.texParameteri(this.target, this.gl.TEXTURE_MIN_FILTER, this.minFilter);
            this.state.minFilter = this.minFilter;
        }
        if (this.magFilter !== this.state.magFilter) {
            this.gl.texParameteri(this.target, this.gl.TEXTURE_MAG_FILTER, this.magFilter);
            this.state.magFilter = this.magFilter;
        }
        if (this.wrapS !== this.state.wrapS) {
            this.gl.texParameteri(this.target, this.gl.TEXTURE_WRAP_S, this.wrapS);
            this.state.wrapS = this.wrapS;
        }
        if (this.wrapT !== this.state.wrapT) {
            this.gl.texParameteri(this.target, this.gl.TEXTURE_WRAP_T, this.wrapT);
            this.state.wrapT = this.wrapT;
        }
        if (this.anisotropy && this.anisotropy !== this.state.anisotropy) {
            this.gl.texParameterf(this.target, this.gl.renderer.getExtension("EXT_texture_filter_anisotropic").TEXTURE_MAX_ANISOTROPY_EXT, this.anisotropy);
            this.state.anisotropy = this.anisotropy;
        }
        if (this.image) {
            if (this.image.width) {
                this.width = this.image.width;
                this.height = this.image.height;
            }
            if (this.target === this.gl.TEXTURE_CUBE_MAP) // For cube maps
            for(let i = 0; i < 6; i++)this.gl.texImage2D(this.gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, this.level, this.internalFormat, this.format, this.type, this.image[i]);
            else if (ArrayBuffer.isView(this.image)) // Data texture
            this.gl.texImage2D(this.target, this.level, this.internalFormat, this.width, this.height, 0, this.format, this.type, this.image);
            else if (this.image.isCompressedTexture) // Compressed texture
            for(let level = 0; level < this.image.length; level++)this.gl.compressedTexImage2D(this.target, level, this.internalFormat, this.image[level].width, this.image[level].height, 0, this.image[level].data);
            else // Regular texture
            this.gl.texImage2D(this.target, this.level, this.internalFormat, this.format, this.type, this.image);
            if (this.generateMipmaps) {
                // For WebGL1, if not a power of 2, turn off mips, set wrapping to clamp to edge and minFilter to linear
                if (!this.gl.renderer.isWebgl2 && (!$456587f66521e022$var$isPowerOf2(this.image.width) || !$456587f66521e022$var$isPowerOf2(this.image.height))) {
                    this.generateMipmaps = false;
                    this.wrapS = this.wrapT = this.gl.CLAMP_TO_EDGE;
                    this.minFilter = this.gl.LINEAR;
                } else this.gl.generateMipmap(this.target);
            }
            // Callback for when data is pushed to GPU
            this.onUpdate && this.onUpdate();
        } else {
            if (this.target === this.gl.TEXTURE_CUBE_MAP) // Upload empty pixel for each side while no image to avoid errors while image or video loading
            for(let i = 0; i < 6; i++)this.gl.texImage2D(this.gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, this.gl.RGBA, 1, 1, 0, this.gl.RGBA, this.gl.UNSIGNED_BYTE, $456587f66521e022$var$emptyPixel);
            else if (this.width) // image intentionally left null for RenderTarget
            this.gl.texImage2D(this.target, this.level, this.internalFormat, this.width, this.height, 0, this.format, this.type, null);
            else // Upload empty pixel if no image to avoid errors while image or video loading
            this.gl.texImage2D(this.target, 0, this.gl.RGBA, 1, 1, 0, this.gl.RGBA, this.gl.UNSIGNED_BYTE, $456587f66521e022$var$emptyPixel);
        }
        this.store.image = this.image;
    }
}


// TODO: test stencil and depth

class $4f246b9cc5d577eb$export$efcb1f8bf367cbfb {
    constructor(gl, { width: width = gl.canvas.width, height: height = gl.canvas.height, target: target = gl.FRAMEBUFFER, color: color = 1, depth: // number of color attachments
    depth = true, stencil: stencil = false, depthTexture: depthTexture = false, wrapS: // note - stencil breaks
    wrapS = gl.CLAMP_TO_EDGE, wrapT: wrapT = gl.CLAMP_TO_EDGE, minFilter: minFilter = gl.LINEAR, magFilter: magFilter = minFilter, type: type = gl.UNSIGNED_BYTE, format: format = gl.RGBA, internalFormat: internalFormat = format, unpackAlignment: unpackAlignment, premultiplyAlpha: premultiplyAlpha } = {}){
        this.gl = gl;
        this.width = width;
        this.height = height;
        this.depth = depth;
        this.buffer = this.gl.createFramebuffer();
        this.target = target;
        this.gl.renderer.bindFramebuffer(this);
        this.textures = [];
        const drawBuffers = [];
        // create and attach required num of color textures
        for(let i = 0; i < color; i++){
            this.textures.push(new (0, $456587f66521e022$export$5431306cf43de24a)(gl, {
                width: width,
                height: height,
                wrapS: wrapS,
                wrapT: wrapT,
                minFilter: minFilter,
                magFilter: magFilter,
                type: type,
                format: format,
                internalFormat: internalFormat,
                unpackAlignment: unpackAlignment,
                premultiplyAlpha: premultiplyAlpha,
                flipY: false,
                generateMipmaps: false
            }));
            this.textures[i].update();
            this.gl.framebufferTexture2D(this.target, this.gl.COLOR_ATTACHMENT0 + i, this.gl.TEXTURE_2D, this.textures[i].texture, 0 /* level */ );
            drawBuffers.push(this.gl.COLOR_ATTACHMENT0 + i);
        }
        // For multi-render targets shader access
        if (drawBuffers.length > 1) this.gl.renderer.drawBuffers(drawBuffers);
        // alias for majority of use cases
        this.texture = this.textures[0];
        // note depth textures break stencil - so can't use together
        if (depthTexture && (this.gl.renderer.isWebgl2 || this.gl.renderer.getExtension("WEBGL_depth_texture"))) {
            this.depthTexture = new (0, $456587f66521e022$export$5431306cf43de24a)(gl, {
                width: width,
                height: height,
                minFilter: this.gl.NEAREST,
                magFilter: this.gl.NEAREST,
                format: this.gl.DEPTH_COMPONENT,
                internalFormat: gl.renderer.isWebgl2 ? this.gl.DEPTH_COMPONENT16 : this.gl.DEPTH_COMPONENT,
                type: this.gl.UNSIGNED_INT
            });
            this.depthTexture.update();
            this.gl.framebufferTexture2D(this.target, this.gl.DEPTH_ATTACHMENT, this.gl.TEXTURE_2D, this.depthTexture.texture, 0 /* level */ );
        } else {
            // Render buffers
            if (depth && !stencil) {
                this.depthBuffer = this.gl.createRenderbuffer();
                this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, this.depthBuffer);
                this.gl.renderbufferStorage(this.gl.RENDERBUFFER, this.gl.DEPTH_COMPONENT16, width, height);
                this.gl.framebufferRenderbuffer(this.target, this.gl.DEPTH_ATTACHMENT, this.gl.RENDERBUFFER, this.depthBuffer);
            }
            if (stencil && !depth) {
                this.stencilBuffer = this.gl.createRenderbuffer();
                this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, this.stencilBuffer);
                this.gl.renderbufferStorage(this.gl.RENDERBUFFER, this.gl.STENCIL_INDEX8, width, height);
                this.gl.framebufferRenderbuffer(this.target, this.gl.STENCIL_ATTACHMENT, this.gl.RENDERBUFFER, this.stencilBuffer);
            }
            if (depth && stencil) {
                this.depthStencilBuffer = this.gl.createRenderbuffer();
                this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, this.depthStencilBuffer);
                this.gl.renderbufferStorage(this.gl.RENDERBUFFER, this.gl.DEPTH_STENCIL, width, height);
                this.gl.framebufferRenderbuffer(this.target, this.gl.DEPTH_STENCIL_ATTACHMENT, this.gl.RENDERBUFFER, this.depthStencilBuffer);
            }
        }
        this.gl.renderer.bindFramebuffer({
            target: this.target
        });
    }
    setSize(width, height) {
        if (this.width === width && this.height === height) return;
        this.width = width;
        this.height = height;
        this.gl.renderer.bindFramebuffer(this);
        for(let i = 0; i < this.textures.length; i++){
            this.textures[i].width = width;
            this.textures[i].height = height;
            this.textures[i].needsUpdate = true;
            this.textures[i].update();
            this.gl.framebufferTexture2D(this.target, this.gl.COLOR_ATTACHMENT0 + i, this.gl.TEXTURE_2D, this.textures[i].texture, 0 /* level */ );
        }
        if (this.depthTexture) {
            this.depthTexture.width = width;
            this.depthTexture.height = height;
            this.depthTexture.needsUpdate = true;
            this.depthTexture.update();
            this.gl.framebufferTexture2D(this.target, this.gl.DEPTH_ATTACHMENT, this.gl.TEXTURE_2D, this.depthTexture.texture, 0 /* level */ );
        } else {
            if (this.depthBuffer) {
                this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, this.depthBuffer);
                this.gl.renderbufferStorage(this.gl.RENDERBUFFER, this.gl.DEPTH_COMPONENT16, width, height);
            }
            if (this.stencilBuffer) {
                this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, this.stencilBuffer);
                this.gl.renderbufferStorage(this.gl.RENDERBUFFER, this.gl.STENCIL_INDEX8, width, height);
            }
            if (this.depthStencilBuffer) {
                this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, this.depthStencilBuffer);
                this.gl.renderbufferStorage(this.gl.RENDERBUFFER, this.gl.DEPTH_STENCIL, width, height);
            }
        }
        this.gl.renderer.bindFramebuffer({
            target: this.target
        });
    }
}


const $abb0c81455953291$var$NAMES = {
    black: "#000000",
    white: "#ffffff",
    red: "#ff0000",
    green: "#00ff00",
    blue: "#0000ff",
    fuchsia: "#ff00ff",
    cyan: "#00ffff",
    yellow: "#ffff00",
    orange: "#ff8000"
};
function $abb0c81455953291$export$848d71df1f759bc(hex) {
    if (hex.length === 4) hex = hex[0] + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
    const rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    rgb;
    return [
        parseInt(rgb[1], 16) / 255,
        parseInt(rgb[2], 16) / 255,
        parseInt(rgb[3], 16) / 255
    ];
}
function $abb0c81455953291$export$a564e3eeccb7f9fa(num) {
    num = parseInt(num);
    return [
        (num >> 16 & 255) / 255,
        (num >> 8 & 255) / 255,
        (num & 255) / 255
    ];
}
function $abb0c81455953291$export$6e865ea70d7724f(color) {
    // Empty
    if (color === undefined) return [
        0,
        0,
        0
    ];
    // Decimal
    if (arguments.length === 3) return arguments;
    // Number
    if (!isNaN(color)) return $abb0c81455953291$export$a564e3eeccb7f9fa(color);
    // Hex
    if (color[0] === "#") return $abb0c81455953291$export$848d71df1f759bc(color);
    // Names
    if ($abb0c81455953291$var$NAMES[color.toLowerCase()]) return $abb0c81455953291$export$848d71df1f759bc($abb0c81455953291$var$NAMES[color.toLowerCase()]);
    return [
        0,
        0,
        0
    ];
}


class $b48d3797a6f93803$export$892596cec99bc70e extends Array {
    constructor(color){
        if (Array.isArray(color)) return super(...color);
        return super(...$abb0c81455953291$export$6e865ea70d7724f(...arguments));
    }
    get r() {
        return this[0];
    }
    get g() {
        return this[1];
    }
    get b() {
        return this[2];
    }
    set r(v) {
        this[0] = v;
    }
    set g(v) {
        this[1] = v;
    }
    set b(v) {
        this[2] = v;
    }
    set(color) {
        if (Array.isArray(color)) return this.copy(color);
        return this.copy($abb0c81455953291$export$6e865ea70d7724f(...arguments));
    }
    copy(v) {
        this[0] = v[0];
        this[1] = v[1];
        this[2] = v[2];
        return this;
    }
}






const $cd2a6142c550da69$var$EPSILON = 0.000001;
function $cd2a6142c550da69$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $cd2a6142c550da69$export$adaa4cf7ef1b65be(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
}
function $cd2a6142c550da69$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
}
function $cd2a6142c550da69$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
}
function $cd2a6142c550da69$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
}
function $cd2a6142c550da69$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
}
function $cd2a6142c550da69$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
}
function $cd2a6142c550da69$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.sqrt(x * x + y * y);
}
function $cd2a6142c550da69$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
}
function $cd2a6142c550da69$export$f24224f1c91d8156(a) {
    var x = a[0], y = a[1];
    return Math.sqrt(x * x + y * y);
}
function $cd2a6142c550da69$export$ab44e1323ffc8376(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
}
function $cd2a6142c550da69$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
}
function $cd2a6142c550da69$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    return out;
}
function $cd2a6142c550da69$export$a3295358bff77e(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    return out;
}
function $cd2a6142c550da69$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}
function $cd2a6142c550da69$export$bb646b20bb93d339(a, b) {
    return a[0] * b[1] - a[1] * b[0];
}
function $cd2a6142c550da69$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
}
function $cd2a6142c550da69$export$b732428d73874bfc(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
}
function $cd2a6142c550da69$export$3e55bc4b3707dfd3(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $cd2a6142c550da69$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
}
function $cd2a6142c550da69$export$5ffbd13800309d59(out, a, m) {
    let x = a[0];
    let y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
}
function $cd2a6142c550da69$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}


class $fee929fe6b903205$export$ac4bca90992eed1 extends Array {
    constructor(x = 0, y = x){
        super(x, y);
        return this;
    }
    get x() {
        return this[0];
    }
    get y() {
        return this[1];
    }
    set x(v) {
        this[0] = v;
    }
    set y(v) {
        this[1] = v;
    }
    set(x, y = x) {
        if (x.length) return this.copy(x);
        $cd2a6142c550da69$export$adaa4cf7ef1b65be(this, x, y);
        return this;
    }
    copy(v) {
        $cd2a6142c550da69$export$784d13d8ee351f07(this, v);
        return this;
    }
    add(va, vb) {
        if (vb) $cd2a6142c550da69$export$e16d8520af44a096(this, va, vb);
        else $cd2a6142c550da69$export$e16d8520af44a096(this, this, va);
        return this;
    }
    sub(va, vb) {
        if (vb) $cd2a6142c550da69$export$4e2d2ead65e5f7e3(this, va, vb);
        else $cd2a6142c550da69$export$4e2d2ead65e5f7e3(this, this, va);
        return this;
    }
    multiply(v) {
        if (v.length) $cd2a6142c550da69$export$2060d2db72cce88f(this, this, v);
        else $cd2a6142c550da69$export$dcdf75081b88279d(this, this, v);
        return this;
    }
    divide(v) {
        if (v.length) $cd2a6142c550da69$export$cd007d971a5a2143(this, this, v);
        else $cd2a6142c550da69$export$dcdf75081b88279d(this, this, 1 / v);
        return this;
    }
    inverse(v = this) {
        $cd2a6142c550da69$export$70ae2c07e401031b(this, v);
        return this;
    }
    // Can't use 'length' as Array.prototype uses it
    len() {
        return $cd2a6142c550da69$export$f24224f1c91d8156(this);
    }
    distance(v) {
        if (v) return $cd2a6142c550da69$export$9f17032d917177de(this, v);
        else return $cd2a6142c550da69$export$f24224f1c91d8156(this);
    }
    squaredLen() {
        return this.squaredDistance();
    }
    squaredDistance(v) {
        if (v) return $cd2a6142c550da69$export$88e6ebb4fe54f538(this, v);
        else return $cd2a6142c550da69$export$ab44e1323ffc8376(this);
    }
    negate(v = this) {
        $cd2a6142c550da69$export$aef51622e549b8b0(this, v);
        return this;
    }
    cross(va, vb) {
        if (vb) return $cd2a6142c550da69$export$bb646b20bb93d339(va, vb);
        return $cd2a6142c550da69$export$bb646b20bb93d339(this, va);
    }
    scale(v) {
        $cd2a6142c550da69$export$dcdf75081b88279d(this, this, v);
        return this;
    }
    normalize() {
        $cd2a6142c550da69$export$a3295358bff77e(this, this);
        return this;
    }
    dot(v) {
        return $cd2a6142c550da69$export$94132a0e348806d4(this, v);
    }
    equals(v) {
        return $cd2a6142c550da69$export$f2599a5cf1109d8(this, v);
    }
    applyMatrix3(mat3) {
        $cd2a6142c550da69$export$f0bfa0a0024626ee(this, this, mat3);
        return this;
    }
    applyMatrix4(mat4) {
        $cd2a6142c550da69$export$5ffbd13800309d59(this, this, mat4);
        return this;
    }
    lerp(v, a) {
        $cd2a6142c550da69$export$3a89f8d6f6bf6c9f(this, this, v, a);
        return this;
    }
    clone() {
        return new $fee929fe6b903205$export$ac4bca90992eed1(this[0], this[1]);
    }
    fromArray(a, o = 0) {
        this[0] = a[o];
        this[1] = a[o + 1];
        return this;
    }
    toArray(a = [], o = 0) {
        a[o] = this[0];
        a[o + 1] = this[1];
        return a;
    }
}




class $d18992236fb6bd2f$export$b973696b5f65b53b extends Array {
    constructor(x = 0, y = x, z = x, w = x){
        super(x, y, z, w);
        return this;
    }
    get x() {
        return this[0];
    }
    get y() {
        return this[1];
    }
    get z() {
        return this[2];
    }
    get w() {
        return this[3];
    }
    set x(v) {
        this[0] = v;
    }
    set y(v) {
        this[1] = v;
    }
    set z(v) {
        this[2] = v;
    }
    set w(v) {
        this[3] = v;
    }
    set(x, y = x, z = x, w = x) {
        if (x.length) return this.copy(x);
        $faaca60ecfc6315f$export$adaa4cf7ef1b65be(this, x, y, z, w);
        return this;
    }
    copy(v) {
        $faaca60ecfc6315f$export$784d13d8ee351f07(this, v);
        return this;
    }
    normalize() {
        $faaca60ecfc6315f$export$a3295358bff77e(this, this);
        return this;
    }
    multiply(v) {
        $faaca60ecfc6315f$export$dcdf75081b88279d(this, this, v);
        return this;
    }
    dot(v) {
        return $faaca60ecfc6315f$export$94132a0e348806d4(this, v);
    }
    fromArray(a, o = 0) {
        this[0] = a[o];
        this[1] = a[o + 1];
        this[2] = a[o + 2];
        this[3] = a[o + 3];
        return this;
    }
    toArray(a = [], o = 0) {
        a[o] = this[0];
        a[o + 1] = this[1];
        a[o + 2] = this[2];
        a[o + 3] = this[3];
        return a;
    }
}



class $ed2396ef893a267e$export$7ff5ac152ef991b0 extends (0, $38f0c9db74b3b35f$export$2db6c17465f94a2) {
    constructor(gl, { width: width = 1, height: height = 1, widthSegments: widthSegments = 1, heightSegments: heightSegments = 1, attributes: attributes = {} } = {}){
        const wSegs = widthSegments;
        const hSegs = heightSegments;
        // Determine length of arrays
        const num = (wSegs + 1) * (hSegs + 1);
        const numIndices = wSegs * hSegs * 6;
        // Generate empty arrays once
        const position = new Float32Array(num * 3);
        const normal = new Float32Array(num * 3);
        const uv = new Float32Array(num * 2);
        const index = numIndices > 65536 ? new Uint32Array(numIndices) : new Uint16Array(numIndices);
        $ed2396ef893a267e$export$7ff5ac152ef991b0.buildPlane(position, normal, uv, index, width, height, 0, wSegs, hSegs);
        Object.assign(attributes, {
            position: {
                size: 3,
                data: position
            },
            normal: {
                size: 3,
                data: normal
            },
            uv: {
                size: 2,
                data: uv
            },
            index: {
                data: index
            }
        });
        super(gl, attributes);
    }
    static buildPlane(position, normal, uv, index, width, height, depth, wSegs, hSegs, u = 0, v = 1, w = 2, uDir = 1, vDir = -1, i = 0, ii = 0) {
        const io = i;
        const segW = width / wSegs;
        const segH = height / hSegs;
        for(let iy = 0; iy <= hSegs; iy++){
            let y = iy * segH - height / 2;
            for(let ix = 0; ix <= wSegs; ix++, i++){
                let x = ix * segW - width / 2;
                position[i * 3 + u] = x * uDir;
                position[i * 3 + v] = y * vDir;
                position[i * 3 + w] = depth / 2;
                normal[i * 3 + u] = 0;
                normal[i * 3 + v] = 0;
                normal[i * 3 + w] = depth >= 0 ? 1 : -1;
                uv[i * 2] = ix / wSegs;
                uv[i * 2 + 1] = 1 - iy / hSegs;
                if (iy === hSegs || ix === wSegs) continue;
                let a = io + ix + iy * (wSegs + 1);
                let b = io + ix + (iy + 1) * (wSegs + 1);
                let c = io + ix + (iy + 1) * (wSegs + 1) + 1;
                let d = io + ix + iy * (wSegs + 1) + 1;
                index[ii * 6] = a;
                index[ii * 6 + 1] = b;
                index[ii * 6 + 2] = d;
                index[ii * 6 + 3] = b;
                index[ii * 6 + 4] = c;
                index[ii * 6 + 5] = d;
                ii++;
            }
        }
    }
}




class $cdf84c44dd96d576$export$e71c4d32a2263218 extends (0, $38f0c9db74b3b35f$export$2db6c17465f94a2) {
    constructor(gl, { width: width = 1, height: height = 1, depth: depth = 1, widthSegments: widthSegments = 1, heightSegments: heightSegments = 1, depthSegments: depthSegments = 1, attributes: attributes = {} } = {}){
        const wSegs = widthSegments;
        const hSegs = heightSegments;
        const dSegs = depthSegments;
        const num = (wSegs + 1) * (hSegs + 1) * 2 + (wSegs + 1) * (dSegs + 1) * 2 + (hSegs + 1) * (dSegs + 1) * 2;
        const numIndices = (wSegs * hSegs * 2 + wSegs * dSegs * 2 + hSegs * dSegs * 2) * 6;
        const position = new Float32Array(num * 3);
        const normal = new Float32Array(num * 3);
        const uv = new Float32Array(num * 2);
        const index = num > 65536 ? new Uint32Array(numIndices) : new Uint16Array(numIndices);
        let i = 0;
        let ii = 0;
        // left, right
        (0, $ed2396ef893a267e$export$7ff5ac152ef991b0).buildPlane(position, normal, uv, index, depth, height, width, dSegs, hSegs, 2, 1, 0, -1, -1, i, ii);
        i += (dSegs + 1) * (hSegs + 1);
        ii += dSegs * hSegs;
        (0, $ed2396ef893a267e$export$7ff5ac152ef991b0).buildPlane(position, normal, uv, index, depth, height, -width, dSegs, hSegs, 2, 1, 0, 1, -1, i, ii);
        i += (dSegs + 1) * (hSegs + 1);
        ii += dSegs * hSegs;
        // top, bottom
        (0, $ed2396ef893a267e$export$7ff5ac152ef991b0).buildPlane(position, normal, uv, index, width, depth, height, dSegs, wSegs, 0, 2, 1, 1, 1, i, ii);
        i += (wSegs + 1) * (dSegs + 1);
        ii += wSegs * dSegs;
        (0, $ed2396ef893a267e$export$7ff5ac152ef991b0).buildPlane(position, normal, uv, index, width, depth, -height, dSegs, wSegs, 0, 2, 1, 1, -1, i, ii);
        i += (wSegs + 1) * (dSegs + 1);
        ii += wSegs * dSegs;
        // front, back
        (0, $ed2396ef893a267e$export$7ff5ac152ef991b0).buildPlane(position, normal, uv, index, width, height, -depth, wSegs, hSegs, 0, 1, 2, -1, -1, i, ii);
        i += (wSegs + 1) * (hSegs + 1);
        ii += wSegs * hSegs;
        (0, $ed2396ef893a267e$export$7ff5ac152ef991b0).buildPlane(position, normal, uv, index, width, height, depth, wSegs, hSegs, 0, 1, 2, 1, -1, i, ii);
        Object.assign(attributes, {
            position: {
                size: 3,
                data: position
            },
            normal: {
                size: 3,
                data: normal
            },
            uv: {
                size: 2,
                data: uv
            },
            index: {
                data: index
            }
        });
        super(gl, attributes);
    }
}




class $3647107fbebbd6ae$export$805e8b72413ccaba extends (0, $38f0c9db74b3b35f$export$2db6c17465f94a2) {
    constructor(gl, { radius: radius = 0.5, widthSegments: widthSegments = 16, heightSegments: heightSegments = Math.ceil(widthSegments * 0.5), phiStart: phiStart = 0, phiLength: phiLength = Math.PI * 2, thetaStart: thetaStart = 0, thetaLength: thetaLength = Math.PI, attributes: attributes = {} } = {}){
        const wSegs = widthSegments;
        const hSegs = heightSegments;
        const pStart = phiStart;
        const pLength = phiLength;
        const tStart = thetaStart;
        const tLength = thetaLength;
        const num = (wSegs + 1) * (hSegs + 1);
        const numIndices = wSegs * hSegs * 6;
        const position = new Float32Array(num * 3);
        const normal = new Float32Array(num * 3);
        const uv = new Float32Array(num * 2);
        const index = num > 65536 ? new Uint32Array(numIndices) : new Uint16Array(numIndices);
        let i = 0;
        let iv = 0;
        let ii = 0;
        let te = tStart + tLength;
        const grid = [];
        let n = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
        for(let iy = 0; iy <= hSegs; iy++){
            let vRow = [];
            let v = iy / hSegs;
            for(let ix = 0; ix <= wSegs; ix++, i++){
                let u = ix / wSegs;
                let x = -radius * Math.cos(pStart + u * pLength) * Math.sin(tStart + v * tLength);
                let y = radius * Math.cos(tStart + v * tLength);
                let z = radius * Math.sin(pStart + u * pLength) * Math.sin(tStart + v * tLength);
                position[i * 3] = x;
                position[i * 3 + 1] = y;
                position[i * 3 + 2] = z;
                n.set(x, y, z).normalize();
                normal[i * 3] = n.x;
                normal[i * 3 + 1] = n.y;
                normal[i * 3 + 2] = n.z;
                uv[i * 2] = u;
                uv[i * 2 + 1] = 1 - v;
                vRow.push(iv++);
            }
            grid.push(vRow);
        }
        for(let iy = 0; iy < hSegs; iy++)for(let ix = 0; ix < wSegs; ix++){
            let a = grid[iy][ix + 1];
            let b = grid[iy][ix];
            let c = grid[iy + 1][ix];
            let d = grid[iy + 1][ix + 1];
            if (iy !== 0 || tStart > 0) {
                index[ii * 3] = a;
                index[ii * 3 + 1] = b;
                index[ii * 3 + 2] = d;
                ii++;
            }
            if (iy !== hSegs - 1 || te < Math.PI) {
                index[ii * 3] = b;
                index[ii * 3 + 1] = c;
                index[ii * 3 + 2] = d;
                ii++;
            }
        }
        Object.assign(attributes, {
            position: {
                size: 3,
                data: position
            },
            normal: {
                size: 3,
                data: normal
            },
            uv: {
                size: 2,
                data: uv
            },
            index: {
                data: index
            }
        });
        super(gl, attributes);
    }
}




class $9b723eca2ba2a5eb$export$665c37f020fe48f9 extends (0, $38f0c9db74b3b35f$export$2db6c17465f94a2) {
    constructor(gl, { radiusTop: radiusTop = 0.5, radiusBottom: radiusBottom = 0.5, height: height = 1, radialSegments: radialSegments = 8, heightSegments: heightSegments = 1, openEnded: openEnded = false, thetaStart: thetaStart = 0, thetaLength: thetaLength = Math.PI * 2, attributes: attributes = {} } = {}){
        const rSegs = radialSegments;
        const hSegs = heightSegments;
        const tStart = thetaStart;
        const tLength = thetaLength;
        const numCaps = openEnded ? 0 : radiusBottom && radiusTop ? 2 : 1;
        const num = (rSegs + 1) * (hSegs + 1 + numCaps) + numCaps;
        const numIndices = rSegs * hSegs * 6 + numCaps * rSegs * 3;
        const position = new Float32Array(num * 3);
        const normal = new Float32Array(num * 3);
        const uv = new Float32Array(num * 2);
        const index = num > 65536 ? new Uint32Array(numIndices) : new Uint16Array(numIndices);
        let i = 0;
        let ii = 0;
        const indexArray = [];
        addHeight();
        if (!openEnded) {
            if (radiusTop) addCap(true);
            if (radiusBottom) addCap(false);
        }
        function addHeight() {
            let x, y;
            const n = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
            const slope = (radiusBottom - radiusTop) / height;
            for(y = 0; y <= hSegs; y++){
                const indexRow = [];
                const v = y / hSegs;
                const r = v * (radiusBottom - radiusTop) + radiusTop;
                for(x = 0; x <= rSegs; x++){
                    const u = x / rSegs;
                    const theta = u * tLength + tStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    position.set([
                        r * sinTheta,
                        (0.5 - v) * height,
                        r * cosTheta
                    ], i * 3);
                    n.set(sinTheta, slope, cosTheta).normalize();
                    normal.set([
                        n.x,
                        n.y,
                        n.z
                    ], i * 3);
                    uv.set([
                        u,
                        1 - v
                    ], i * 2);
                    indexRow.push(i++);
                }
                indexArray.push(indexRow);
            }
            for(x = 0; x < rSegs; x++)for(y = 0; y < hSegs; y++){
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                index.set([
                    a,
                    b,
                    d,
                    b,
                    c,
                    d
                ], ii * 3);
                ii += 2;
            }
        }
        function addCap(isTop) {
            let x;
            const r = isTop === true ? radiusTop : radiusBottom;
            const sign = isTop === true ? 1 : -1;
            const centerIndex = i;
            position.set([
                0,
                0.5 * height * sign,
                0
            ], i * 3);
            normal.set([
                0,
                sign,
                0
            ], i * 3);
            uv.set([
                0.5,
                0.5
            ], i * 2);
            i++;
            for(x = 0; x <= rSegs; x++){
                const u = x / rSegs;
                const theta = u * tLength + tStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                position.set([
                    r * sinTheta,
                    0.5 * height * sign,
                    r * cosTheta
                ], i * 3);
                normal.set([
                    0,
                    sign,
                    0
                ], i * 3);
                uv.set([
                    cosTheta * 0.5 + 0.5,
                    sinTheta * 0.5 * sign + 0.5
                ], i * 2);
                i++;
            }
            for(x = 0; x < rSegs; x++){
                const j = centerIndex + x + 1;
                if (isTop) index.set([
                    j,
                    j + 1,
                    centerIndex
                ], ii * 3);
                else index.set([
                    j + 1,
                    j,
                    centerIndex
                ], ii * 3);
                ii++;
            }
        }
        Object.assign(attributes, {
            position: {
                size: 3,
                data: position
            },
            normal: {
                size: 3,
                data: normal
            },
            uv: {
                size: 2,
                data: uv
            },
            index: {
                data: index
            }
        });
        super(gl, attributes);
    }
}



class $7993b287887390f8$export$5a465592bfe74b48 extends (0, $38f0c9db74b3b35f$export$2db6c17465f94a2) {
    constructor(gl, { attributes: attributes = {} } = {}){
        Object.assign(attributes, {
            position: {
                size: 2,
                data: new Float32Array([
                    -1,
                    -1,
                    3,
                    -1,
                    -1,
                    3
                ])
            },
            uv: {
                size: 2,
                data: new Float32Array([
                    0,
                    0,
                    2,
                    0,
                    0,
                    2
                ])
            }
        });
        super(gl, attributes);
    }
}


// https://github.com/mrdoob/three.js/blob/master/src/geometries/TorusGeometry.js


class $57900e85ca0cf592$export$c12afe8512859f29 extends (0, $38f0c9db74b3b35f$export$2db6c17465f94a2) {
    constructor(gl, { radius: radius = 0.5, tube: tube = 0.2, radialSegments: radialSegments = 8, tubularSegments: tubularSegments = 6, arc: arc = Math.PI * 2, attributes: attributes = {} } = {}){
        const num = (radialSegments + 1) * (tubularSegments + 1);
        const numIndices = radialSegments * tubularSegments * 6;
        const vertices = new Float32Array(num * 3);
        const normals = new Float32Array(num * 3);
        const uvs = new Float32Array(num * 2);
        const indices = num > 65536 ? new Uint32Array(numIndices) : new Uint16Array(numIndices);
        const center = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
        const vertex = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
        const normal = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
        // generate vertices, normals and uvs
        let idx = 0;
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++, idx++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.set([
                vertex.x,
                vertex.y,
                vertex.z
            ], idx * 3);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.sub(vertex, center).normalize();
            normals.set([
                normal.x,
                normal.y,
                normal.z
            ], idx * 3);
            // uv
            uvs.set([
                i / tubularSegments,
                j / radialSegments
            ], idx * 2);
        }
        // generate indices
        idx = 0;
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++, idx++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.set([
                a,
                b,
                d,
                b,
                c,
                d
            ], idx * 6);
        }
        Object.assign(attributes, {
            position: {
                size: 3,
                data: vertices
            },
            normal: {
                size: 3,
                data: normals
            },
            uv: {
                size: 2,
                data: uvs
            },
            index: {
                data: indices
            }
        });
        super(gl, attributes);
    }
}


// Based from ThreeJS' OrbitControls class, rewritten using es6 with some additions and subtractions.
// TODO: abstract event handlers so can be fed from other sources
// TODO: make scroll zoom more accurate than just >/< zero
// TODO: be able to pass in new camera position


const $f352064a22a95511$var$STATE = {
    NONE: -1,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2,
    DOLLY_PAN: 3
};
const $f352064a22a95511$var$tempVec3 = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $f352064a22a95511$var$tempVec2a = /* @__PURE__ */ new (0, $fee929fe6b903205$export$ac4bca90992eed1)();
const $f352064a22a95511$var$tempVec2b = /* @__PURE__ */ new (0, $fee929fe6b903205$export$ac4bca90992eed1)();
function $f352064a22a95511$export$439358b35042ae9f(object, { element: element = document, enabled: enabled = true, target: target = new (0, $77acc528c45f5d37$export$838423f3adec30fa)(), ease: ease = 0.25, inertia: inertia = 0.85, enableRotate: enableRotate = true, rotateSpeed: rotateSpeed = 0.1, autoRotate: autoRotate = false, autoRotateSpeed: autoRotateSpeed = 1.0, enableZoom: enableZoom = true, zoomSpeed: zoomSpeed = 1, zoomStyle: zoomStyle = "dolly", enablePan: enablePan = true, panSpeed: panSpeed = 0.1, minPolarAngle: minPolarAngle = 0, maxPolarAngle: maxPolarAngle = Math.PI, minAzimuthAngle: minAzimuthAngle = -Infinity, maxAzimuthAngle: maxAzimuthAngle = Infinity, minDistance: minDistance = 0, maxDistance: maxDistance = Infinity } = {}) {
    this.enabled = enabled;
    this.target = target;
    this.zoomStyle = zoomStyle;
    // Catch attempts to disable - set to 1 so has no effect
    ease = ease || 1;
    inertia = inertia || 0;
    this.minDistance = minDistance;
    this.maxDistance = maxDistance;
    // current position in sphericalTarget coordinates
    const sphericalDelta = {
        radius: 1,
        phi: 0,
        theta: 0
    };
    const sphericalTarget = {
        radius: 1,
        phi: 0,
        theta: 0
    };
    const spherical = {
        radius: 1,
        phi: 0,
        theta: 0
    };
    const panDelta = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
    // Grab initial position values
    const offset = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
    offset.copy(object.position).sub(this.target);
    spherical.radius = sphericalTarget.radius = offset.distance();
    spherical.theta = sphericalTarget.theta = Math.atan2(offset.x, offset.z);
    spherical.phi = sphericalTarget.phi = Math.acos(Math.min(Math.max(offset.y / sphericalTarget.radius, -1), 1));
    this.offset = offset;
    this.update = ()=>{
        if (autoRotate) handleAutoRotate();
        // apply delta
        sphericalTarget.radius *= sphericalDelta.radius;
        sphericalTarget.theta += sphericalDelta.theta;
        sphericalTarget.phi += sphericalDelta.phi;
        // apply boundaries
        sphericalTarget.theta = Math.max(minAzimuthAngle, Math.min(maxAzimuthAngle, sphericalTarget.theta));
        sphericalTarget.phi = Math.max(minPolarAngle, Math.min(maxPolarAngle, sphericalTarget.phi));
        sphericalTarget.radius = Math.max(this.minDistance, Math.min(this.maxDistance, sphericalTarget.radius));
        // ease values
        spherical.phi += (sphericalTarget.phi - spherical.phi) * ease;
        spherical.theta += (sphericalTarget.theta - spherical.theta) * ease;
        spherical.radius += (sphericalTarget.radius - spherical.radius) * ease;
        // apply pan to target. As offset is relative to target, it also shifts
        this.target.add(panDelta);
        // apply rotation to offset
        let sinPhiRadius = spherical.radius * Math.sin(Math.max(0.000001, spherical.phi));
        offset.x = sinPhiRadius * Math.sin(spherical.theta);
        offset.y = spherical.radius * Math.cos(spherical.phi);
        offset.z = sinPhiRadius * Math.cos(spherical.theta);
        // Apply updated values to object
        object.position.copy(this.target).add(offset);
        object.lookAt(this.target);
        // Apply inertia to values
        sphericalDelta.theta *= inertia;
        sphericalDelta.phi *= inertia;
        panDelta.multiply(inertia);
        // Reset scale every frame to avoid applying scale multiple times
        sphericalDelta.radius = 1;
    };
    // Updates internals with new position
    this.forcePosition = ()=>{
        offset.copy(object.position).sub(this.target);
        spherical.radius = sphericalTarget.radius = offset.distance();
        spherical.theta = sphericalTarget.theta = Math.atan2(offset.x, offset.z);
        spherical.phi = sphericalTarget.phi = Math.acos(Math.min(Math.max(offset.y / sphericalTarget.radius, -1), 1));
        object.lookAt(this.target);
    };
    // Everything below here just updates panDelta and sphericalDelta
    // Using those two objects' values, the orbit is calculated
    const rotateStart = new (0, $fee929fe6b903205$export$ac4bca90992eed1)();
    const panStart = new (0, $fee929fe6b903205$export$ac4bca90992eed1)();
    const dollyStart = new (0, $fee929fe6b903205$export$ac4bca90992eed1)();
    let state = $f352064a22a95511$var$STATE.NONE;
    this.mouseButtons = {
        ORBIT: 0,
        ZOOM: 1,
        PAN: 2
    };
    function getZoomScale() {
        return Math.pow(0.95, zoomSpeed);
    }
    function panLeft(distance, m) {
        $f352064a22a95511$var$tempVec3.set(m[0], m[1], m[2]);
        $f352064a22a95511$var$tempVec3.multiply(-distance);
        panDelta.add($f352064a22a95511$var$tempVec3);
    }
    function panUp(distance, m) {
        $f352064a22a95511$var$tempVec3.set(m[4], m[5], m[6]);
        $f352064a22a95511$var$tempVec3.multiply(distance);
        panDelta.add($f352064a22a95511$var$tempVec3);
    }
    const pan = (deltaX, deltaY)=>{
        let el = element === document ? document.body : element;
        $f352064a22a95511$var$tempVec3.copy(object.position).sub(this.target);
        let targetDistance = $f352064a22a95511$var$tempVec3.distance();
        targetDistance *= Math.tan((object.fov || 45) / 2 * Math.PI / 180.0);
        panLeft(2 * deltaX * targetDistance / el.clientHeight, object.matrix);
        panUp(2 * deltaY * targetDistance / el.clientHeight, object.matrix);
    };
    const dolly = (dollyScale)=>{
        if (this.zoomStyle === "dolly") sphericalDelta.radius /= dollyScale;
        else {
            object.fov /= dollyScale;
            if (object.type === "orthographic") object.orthographic();
            else object.perspective();
        }
    };
    function handleAutoRotate() {
        const angle = 2 * Math.PI / 60 / 60 * autoRotateSpeed;
        sphericalDelta.theta -= angle;
    }
    function handleMoveRotate(x, y) {
        $f352064a22a95511$var$tempVec2a.set(x, y);
        $f352064a22a95511$var$tempVec2b.sub($f352064a22a95511$var$tempVec2a, rotateStart).multiply(rotateSpeed);
        let el = element === document ? document.body : element;
        sphericalDelta.theta -= 2 * Math.PI * $f352064a22a95511$var$tempVec2b.x / el.clientHeight;
        sphericalDelta.phi -= 2 * Math.PI * $f352064a22a95511$var$tempVec2b.y / el.clientHeight;
        rotateStart.copy($f352064a22a95511$var$tempVec2a);
    }
    function handleMouseMoveDolly(e) {
        $f352064a22a95511$var$tempVec2a.set(e.clientX, e.clientY);
        $f352064a22a95511$var$tempVec2b.sub($f352064a22a95511$var$tempVec2a, dollyStart);
        if ($f352064a22a95511$var$tempVec2b.y > 0) dolly(getZoomScale());
        else if ($f352064a22a95511$var$tempVec2b.y < 0) dolly(1 / getZoomScale());
        dollyStart.copy($f352064a22a95511$var$tempVec2a);
    }
    function handleMovePan(x, y) {
        $f352064a22a95511$var$tempVec2a.set(x, y);
        $f352064a22a95511$var$tempVec2b.sub($f352064a22a95511$var$tempVec2a, panStart).multiply(panSpeed);
        pan($f352064a22a95511$var$tempVec2b.x, $f352064a22a95511$var$tempVec2b.y);
        panStart.copy($f352064a22a95511$var$tempVec2a);
    }
    function handleTouchStartDollyPan(e) {
        if (enableZoom) {
            let dx = e.touches[0].pageX - e.touches[1].pageX;
            let dy = e.touches[0].pageY - e.touches[1].pageY;
            let distance = Math.sqrt(dx * dx + dy * dy);
            dollyStart.set(0, distance);
        }
        if (enablePan) {
            let x = 0.5 * (e.touches[0].pageX + e.touches[1].pageX);
            let y = 0.5 * (e.touches[0].pageY + e.touches[1].pageY);
            panStart.set(x, y);
        }
    }
    function handleTouchMoveDollyPan(e) {
        if (enableZoom) {
            let dx = e.touches[0].pageX - e.touches[1].pageX;
            let dy = e.touches[0].pageY - e.touches[1].pageY;
            let distance = Math.sqrt(dx * dx + dy * dy);
            $f352064a22a95511$var$tempVec2a.set(0, distance);
            $f352064a22a95511$var$tempVec2b.set(0, Math.pow($f352064a22a95511$var$tempVec2a.y / dollyStart.y, zoomSpeed));
            dolly($f352064a22a95511$var$tempVec2b.y);
            dollyStart.copy($f352064a22a95511$var$tempVec2a);
        }
        if (enablePan) {
            let x = 0.5 * (e.touches[0].pageX + e.touches[1].pageX);
            let y = 0.5 * (e.touches[0].pageY + e.touches[1].pageY);
            handleMovePan(x, y);
        }
    }
    const onMouseDown = (e)=>{
        if (!this.enabled) return;
        switch(e.button){
            case this.mouseButtons.ORBIT:
                if (enableRotate === false) return;
                rotateStart.set(e.clientX, e.clientY);
                state = $f352064a22a95511$var$STATE.ROTATE;
                break;
            case this.mouseButtons.ZOOM:
                if (enableZoom === false) return;
                dollyStart.set(e.clientX, e.clientY);
                state = $f352064a22a95511$var$STATE.DOLLY;
                break;
            case this.mouseButtons.PAN:
                if (enablePan === false) return;
                panStart.set(e.clientX, e.clientY);
                state = $f352064a22a95511$var$STATE.PAN;
                break;
        }
        if (state !== $f352064a22a95511$var$STATE.NONE) {
            window.addEventListener("mousemove", onMouseMove, false);
            window.addEventListener("mouseup", onMouseUp, false);
        }
    };
    const onMouseMove = (e)=>{
        if (!this.enabled) return;
        switch(state){
            case $f352064a22a95511$var$STATE.ROTATE:
                if (enableRotate === false) return;
                handleMoveRotate(e.clientX, e.clientY);
                break;
            case $f352064a22a95511$var$STATE.DOLLY:
                if (enableZoom === false) return;
                handleMouseMoveDolly(e);
                break;
            case $f352064a22a95511$var$STATE.PAN:
                if (enablePan === false) return;
                handleMovePan(e.clientX, e.clientY);
                break;
        }
    };
    const onMouseUp = ()=>{
        window.removeEventListener("mousemove", onMouseMove, false);
        window.removeEventListener("mouseup", onMouseUp, false);
        state = $f352064a22a95511$var$STATE.NONE;
    };
    const onMouseWheel = (e)=>{
        if (!this.enabled || !enableZoom || state !== $f352064a22a95511$var$STATE.NONE && state !== $f352064a22a95511$var$STATE.ROTATE) return;
        e.stopPropagation();
        e.preventDefault();
        if (e.deltaY < 0) dolly(1 / getZoomScale());
        else if (e.deltaY > 0) dolly(getZoomScale());
    };
    const onTouchStart = (e)=>{
        if (!this.enabled) return;
        e.preventDefault();
        switch(e.touches.length){
            case 1:
                if (enableRotate === false) return;
                rotateStart.set(e.touches[0].pageX, e.touches[0].pageY);
                state = $f352064a22a95511$var$STATE.ROTATE;
                break;
            case 2:
                if (enableZoom === false && enablePan === false) return;
                handleTouchStartDollyPan(e);
                state = $f352064a22a95511$var$STATE.DOLLY_PAN;
                break;
            default:
                state = $f352064a22a95511$var$STATE.NONE;
        }
    };
    const onTouchMove = (e)=>{
        if (!this.enabled) return;
        e.preventDefault();
        e.stopPropagation();
        switch(e.touches.length){
            case 1:
                if (enableRotate === false) return;
                handleMoveRotate(e.touches[0].pageX, e.touches[0].pageY);
                break;
            case 2:
                if (enableZoom === false && enablePan === false) return;
                handleTouchMoveDollyPan(e);
                break;
            default:
                state = $f352064a22a95511$var$STATE.NONE;
        }
    };
    const onTouchEnd = ()=>{
        if (!this.enabled) return;
        state = $f352064a22a95511$var$STATE.NONE;
    };
    const onContextMenu = (e)=>{
        if (!this.enabled) return;
        e.preventDefault();
    };
    function addHandlers() {
        element.addEventListener("contextmenu", onContextMenu, false);
        element.addEventListener("mousedown", onMouseDown, false);
        element.addEventListener("wheel", onMouseWheel, {
            passive: false
        });
        element.addEventListener("touchstart", onTouchStart, {
            passive: false
        });
        element.addEventListener("touchend", onTouchEnd, false);
        element.addEventListener("touchmove", onTouchMove, {
            passive: false
        });
    }
    this.remove = function() {
        element.removeEventListener("contextmenu", onContextMenu);
        element.removeEventListener("mousedown", onMouseDown);
        element.removeEventListener("wheel", onMouseWheel);
        element.removeEventListener("touchstart", onTouchStart);
        element.removeEventListener("touchend", onTouchEnd);
        element.removeEventListener("touchmove", onTouchMove);
        window.removeEventListener("mousemove", onMouseMove);
        window.removeEventListener("mouseup", onMouseUp);
    };
    addHandlers();
}


// TODO: barycentric code shouldn't be here, but where?
// TODO: SphereCast?



const $3467b0bfa99284a2$var$tempVec2a = /* @__PURE__ */ new (0, $fee929fe6b903205$export$ac4bca90992eed1)();
const $3467b0bfa99284a2$var$tempVec2b = /* @__PURE__ */ new (0, $fee929fe6b903205$export$ac4bca90992eed1)();
const $3467b0bfa99284a2$var$tempVec2c = /* @__PURE__ */ new (0, $fee929fe6b903205$export$ac4bca90992eed1)();
const $3467b0bfa99284a2$var$tempVec3a = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $3467b0bfa99284a2$var$tempVec3b = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $3467b0bfa99284a2$var$tempVec3c = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $3467b0bfa99284a2$var$tempVec3d = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $3467b0bfa99284a2$var$tempVec3e = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $3467b0bfa99284a2$var$tempVec3f = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $3467b0bfa99284a2$var$tempVec3g = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $3467b0bfa99284a2$var$tempVec3h = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $3467b0bfa99284a2$var$tempVec3i = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $3467b0bfa99284a2$var$tempVec3j = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $3467b0bfa99284a2$var$tempVec3k = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $3467b0bfa99284a2$var$tempMat4 = /* @__PURE__ */ new (0, $6b06e593d6b503e3$export$21c0e3d5e995d7e1)();
class $3467b0bfa99284a2$export$ff2d1de6a335cd2e {
    constructor(){
        this.origin = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
        this.direction = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
    }
    // Set ray from mouse unprojection
    castMouse(camera, mouse = [
        0,
        0
    ]) {
        if (camera.type === "orthographic") {
            // Set origin
            // Since camera is orthographic, origin is not the camera position
            const { left: left, right: right, bottom: bottom, top: top, zoom: zoom } = camera;
            const x = left / zoom + (right - left) / zoom * (mouse[0] * 0.5 + 0.5);
            const y = bottom / zoom + (top - bottom) / zoom * (mouse[1] * 0.5 + 0.5);
            this.origin.set(x, y, 0);
            this.origin.applyMatrix4(camera.worldMatrix);
            // Set direction
            // https://community.khronos.org/t/get-direction-from-transformation-matrix-or-quat/65502/2
            this.direction.x = -camera.worldMatrix[8];
            this.direction.y = -camera.worldMatrix[9];
            this.direction.z = -camera.worldMatrix[10];
        } else {
            // Set origin
            camera.worldMatrix.getTranslation(this.origin);
            // Set direction
            this.direction.set(mouse[0], mouse[1], 0.5);
            camera.unproject(this.direction);
            this.direction.sub(this.origin).normalize();
        }
    }
    intersectBounds(meshes, { maxDistance: maxDistance, output: output = [] } = {}) {
        if (!Array.isArray(meshes)) meshes = [
            meshes
        ];
        const invWorldMat4 = $3467b0bfa99284a2$var$tempMat4;
        const origin = $3467b0bfa99284a2$var$tempVec3a;
        const direction = $3467b0bfa99284a2$var$tempVec3b;
        const hits = output;
        hits.length = 0;
        meshes.forEach((mesh)=>{
            // Create bounds
            if (!mesh.geometry.bounds || mesh.geometry.bounds.radius === Infinity) mesh.geometry.computeBoundingSphere();
            const bounds = mesh.geometry.bounds;
            invWorldMat4.inverse(mesh.worldMatrix);
            // Get max distance locally
            let localMaxDistance;
            if (maxDistance) {
                direction.copy(this.direction).scaleRotateMatrix4(invWorldMat4);
                localMaxDistance = maxDistance * direction.len();
            }
            // Take world space ray and make it object space to align with bounding box
            origin.copy(this.origin).applyMatrix4(invWorldMat4);
            direction.copy(this.direction).transformDirection(invWorldMat4);
            // Break out early if bounds too far away from origin
            if (maxDistance) {
                if (origin.distance(bounds.center) - bounds.radius > localMaxDistance) return;
            }
            let localDistance = 0;
            // Check origin isn't inside bounds before testing intersection
            if (mesh.geometry.raycast === "sphere") {
                if (origin.distance(bounds.center) > bounds.radius) {
                    localDistance = this.intersectSphere(bounds, origin, direction);
                    if (!localDistance) return;
                }
            } else if (origin.x < bounds.min.x || origin.x > bounds.max.x || origin.y < bounds.min.y || origin.y > bounds.max.y || origin.z < bounds.min.z || origin.z > bounds.max.z) {
                localDistance = this.intersectBox(bounds, origin, direction);
                if (!localDistance) return;
            }
            if (maxDistance && localDistance > localMaxDistance) return;
            // Create object on mesh to avoid generating lots of objects
            if (!mesh.hit) mesh.hit = {
                localPoint: new (0, $77acc528c45f5d37$export$838423f3adec30fa)(),
                point: new (0, $77acc528c45f5d37$export$838423f3adec30fa)()
            };
            mesh.hit.localPoint.copy(direction).multiply(localDistance).add(origin);
            mesh.hit.point.copy(mesh.hit.localPoint).applyMatrix4(mesh.worldMatrix);
            mesh.hit.distance = mesh.hit.point.distance(this.origin);
            hits.push(mesh);
        });
        hits.sort((a, b)=>a.hit.distance - b.hit.distance);
        return hits;
    }
    intersectMeshes(meshes, { cullFace: cullFace = true, maxDistance: maxDistance, includeUV: includeUV = true, includeNormal: includeNormal = true, output: output = [] } = {}) {
        // Test bounds first before testing geometry
        const hits = this.intersectBounds(meshes, {
            maxDistance: maxDistance,
            output: output
        });
        if (!hits.length) return hits;
        const invWorldMat4 = $3467b0bfa99284a2$var$tempMat4;
        const origin = $3467b0bfa99284a2$var$tempVec3a;
        const direction = $3467b0bfa99284a2$var$tempVec3b;
        const a = $3467b0bfa99284a2$var$tempVec3c;
        const b = $3467b0bfa99284a2$var$tempVec3d;
        const c = $3467b0bfa99284a2$var$tempVec3e;
        const closestFaceNormal = $3467b0bfa99284a2$var$tempVec3f;
        const faceNormal = $3467b0bfa99284a2$var$tempVec3g;
        const barycoord = $3467b0bfa99284a2$var$tempVec3h;
        const uvA = $3467b0bfa99284a2$var$tempVec2a;
        const uvB = $3467b0bfa99284a2$var$tempVec2b;
        const uvC = $3467b0bfa99284a2$var$tempVec2c;
        for(let i = hits.length - 1; i >= 0; i--){
            const mesh = hits[i];
            invWorldMat4.inverse(mesh.worldMatrix);
            // Get max distance locally
            let localMaxDistance;
            if (maxDistance) {
                direction.copy(this.direction).scaleRotateMatrix4(invWorldMat4);
                localMaxDistance = maxDistance * direction.len();
            }
            // Take world space ray and make it object space to align with bounding box
            origin.copy(this.origin).applyMatrix4(invWorldMat4);
            direction.copy(this.direction).transformDirection(invWorldMat4);
            let localDistance = 0;
            let closestA, closestB, closestC;
            const geometry = mesh.geometry;
            const attributes = geometry.attributes;
            const index = attributes.index;
            const position = attributes.position;
            const start = Math.max(0, geometry.drawRange.start);
            const end = Math.min(index ? index.count : position.count, geometry.drawRange.start + geometry.drawRange.count);
            // Data loaded shouldn't haave stride, only buffers
            // const stride = position.stride ? position.stride / position.data.BYTES_PER_ELEMENT : position.size;
            const stride = position.size;
            for(let j = start; j < end; j += 3){
                // Position attribute indices for each triangle
                const ai = index ? index.data[j] : j;
                const bi = index ? index.data[j + 1] : j + 1;
                const ci = index ? index.data[j + 2] : j + 2;
                a.fromArray(position.data, ai * stride);
                b.fromArray(position.data, bi * stride);
                c.fromArray(position.data, ci * stride);
                const distance = this.intersectTriangle(a, b, c, cullFace, origin, direction, faceNormal);
                if (!distance) continue;
                // Too far away
                if (maxDistance && distance > localMaxDistance) continue;
                if (!localDistance || distance < localDistance) {
                    localDistance = distance;
                    closestA = ai;
                    closestB = bi;
                    closestC = ci;
                    closestFaceNormal.copy(faceNormal);
                }
            }
            if (!localDistance) hits.splice(i, 1);
            // Update hit values from bounds-test
            mesh.hit.localPoint.copy(direction).multiply(localDistance).add(origin);
            mesh.hit.point.copy(mesh.hit.localPoint).applyMatrix4(mesh.worldMatrix);
            mesh.hit.distance = mesh.hit.point.distance(this.origin);
            // Add unique hit objects on mesh to avoid generating lots of objects
            if (!mesh.hit.faceNormal) {
                mesh.hit.localFaceNormal = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
                mesh.hit.faceNormal = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
                mesh.hit.uv = new (0, $fee929fe6b903205$export$ac4bca90992eed1)();
                mesh.hit.localNormal = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
                mesh.hit.normal = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
            }
            // Add face normal data which is already computed
            mesh.hit.localFaceNormal.copy(closestFaceNormal);
            mesh.hit.faceNormal.copy(mesh.hit.localFaceNormal).transformDirection(mesh.worldMatrix);
            // Optional data, opt out to optimise a bit if necessary
            if (includeUV || includeNormal) {
                // Calculate barycoords to find uv values at hit point
                a.fromArray(position.data, closestA * 3);
                b.fromArray(position.data, closestB * 3);
                c.fromArray(position.data, closestC * 3);
                this.getBarycoord(mesh.hit.localPoint, a, b, c, barycoord);
            }
            if (includeUV && attributes.uv) {
                uvA.fromArray(attributes.uv.data, closestA * 2);
                uvB.fromArray(attributes.uv.data, closestB * 2);
                uvC.fromArray(attributes.uv.data, closestC * 2);
                mesh.hit.uv.set(uvA.x * barycoord.x + uvB.x * barycoord.y + uvC.x * barycoord.z, uvA.y * barycoord.x + uvB.y * barycoord.y + uvC.y * barycoord.z);
            }
            if (includeNormal && attributes.normal) {
                a.fromArray(attributes.normal.data, closestA * 3);
                b.fromArray(attributes.normal.data, closestB * 3);
                c.fromArray(attributes.normal.data, closestC * 3);
                mesh.hit.localNormal.set(a.x * barycoord.x + b.x * barycoord.y + c.x * barycoord.z, a.y * barycoord.x + b.y * barycoord.y + c.y * barycoord.z, a.z * barycoord.x + b.z * barycoord.y + c.z * barycoord.z);
                mesh.hit.normal.copy(mesh.hit.localNormal).transformDirection(mesh.worldMatrix);
            }
        }
        hits.sort((a, b)=>a.hit.distance - b.hit.distance);
        return hits;
    }
    intersectPlane(plane, origin = this.origin, direction = this.direction) {
        const xminp = $3467b0bfa99284a2$var$tempVec3a;
        xminp.sub(plane.origin, origin);
        const a = xminp.dot(plane.normal);
        const b = direction.dot(plane.normal);
        // Assuming we don't want to count a ray parallel to the plane as intersecting
        if (b == 0) return 0;
        const delta = a / b;
        if (delta <= 0) return 0;
        return origin.add(direction.scale(delta));
    }
    intersectSphere(sphere, origin = this.origin, direction = this.direction) {
        const ray = $3467b0bfa99284a2$var$tempVec3c;
        ray.sub(sphere.center, origin);
        const tca = ray.dot(direction);
        const d2 = ray.dot(ray) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return 0;
        const thc = Math.sqrt(radius2 - d2);
        const t0 = tca - thc;
        const t1 = tca + thc;
        if (t0 < 0 && t1 < 0) return 0;
        if (t0 < 0) return t1;
        return t0;
    }
    // Ray AABB - Ray Axis aligned bounding box testing
    intersectBox(box, origin = this.origin, direction = this.direction) {
        let tmin, tmax, tYmin, tYmax, tZmin, tZmax;
        const invdirx = 1 / direction.x;
        const invdiry = 1 / direction.y;
        const invdirz = 1 / direction.z;
        const min = box.min;
        const max = box.max;
        tmin = ((invdirx >= 0 ? min.x : max.x) - origin.x) * invdirx;
        tmax = ((invdirx >= 0 ? max.x : min.x) - origin.x) * invdirx;
        tYmin = ((invdiry >= 0 ? min.y : max.y) - origin.y) * invdiry;
        tYmax = ((invdiry >= 0 ? max.y : min.y) - origin.y) * invdiry;
        if (tmin > tYmax || tYmin > tmax) return 0;
        if (tYmin > tmin) tmin = tYmin;
        if (tYmax < tmax) tmax = tYmax;
        tZmin = ((invdirz >= 0 ? min.z : max.z) - origin.z) * invdirz;
        tZmax = ((invdirz >= 0 ? max.z : min.z) - origin.z) * invdirz;
        if (tmin > tZmax || tZmin > tmax) return 0;
        if (tZmin > tmin) tmin = tZmin;
        if (tZmax < tmax) tmax = tZmax;
        if (tmax < 0) return 0;
        return tmin >= 0 ? tmin : tmax;
    }
    intersectTriangle(a, b, c, backfaceCulling = true, origin = this.origin, direction = this.direction, normal = $3467b0bfa99284a2$var$tempVec3g) {
        // from https://github.com/mrdoob/three.js/blob/master/src/math/Ray.js
        // which is from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        const edge1 = $3467b0bfa99284a2$var$tempVec3h;
        const edge2 = $3467b0bfa99284a2$var$tempVec3i;
        const diff = $3467b0bfa99284a2$var$tempVec3j;
        edge1.sub(b, a);
        edge2.sub(c, a);
        normal.cross(edge1, edge2);
        let DdN = direction.dot(normal);
        if (!DdN) return 0;
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return 0;
            sign = 1;
        } else {
            sign = -1;
            DdN = -DdN;
        }
        diff.sub(origin, a);
        let DdQxE2 = sign * direction.dot(edge2.cross(diff, edge2));
        if (DdQxE2 < 0) return 0;
        let DdE1xQ = sign * direction.dot(edge1.cross(diff));
        if (DdE1xQ < 0) return 0;
        if (DdQxE2 + DdE1xQ > DdN) return 0;
        let QdN = -sign * diff.dot(normal);
        if (QdN < 0) return 0;
        return QdN / DdN;
    }
    getBarycoord(point, a, b, c, target = $3467b0bfa99284a2$var$tempVec3h) {
        // From https://github.com/mrdoob/three.js/blob/master/src/math/Triangle.js
        // static/instance method to calculate barycentric coordinates
        // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
        const v0 = $3467b0bfa99284a2$var$tempVec3i;
        const v1 = $3467b0bfa99284a2$var$tempVec3j;
        const v2 = $3467b0bfa99284a2$var$tempVec3k;
        v0.sub(c, a);
        v1.sub(b, a);
        v2.sub(point, a);
        const dot00 = v0.dot(v0);
        const dot01 = v0.dot(v1);
        const dot02 = v0.dot(v2);
        const dot11 = v1.dot(v1);
        const dot12 = v1.dot(v2);
        const denom = dot00 * dot11 - dot01 * dot01;
        if (denom === 0) return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        return target.set(1 - u - v, v, u);
    }
}



const $5c8ac76e429def4f$var$CATMULLROM = "catmullrom";
const $5c8ac76e429def4f$var$CUBICBEZIER = "cubicbezier";
const $5c8ac76e429def4f$var$QUADRATICBEZIER = "quadraticbezier";
// temp
const $5c8ac76e429def4f$var$_a0 = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)(), $5c8ac76e429def4f$var$_a1 = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)(), $5c8ac76e429def4f$var$_a2 = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)(), $5c8ac76e429def4f$var$_a3 = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
/**
 * Get the control points of cubic bezier curve.
 * @param {*} i
 * @param {*} a
 * @param {*} b
 */ function $5c8ac76e429def4f$var$getCtrlPoint(points, i, a = 0.168, b = 0.168) {
    if (i < 1) $5c8ac76e429def4f$var$_a0.sub(points[1], points[0]).scale(a).add(points[0]);
    else $5c8ac76e429def4f$var$_a0.sub(points[i + 1], points[i - 1]).scale(a).add(points[i]);
    if (i > points.length - 3) {
        const last = points.length - 1;
        $5c8ac76e429def4f$var$_a1.sub(points[last - 1], points[last]).scale(b).add(points[last]);
    } else $5c8ac76e429def4f$var$_a1.sub(points[i], points[i + 2]).scale(b).add(points[i + 1]);
    return [
        $5c8ac76e429def4f$var$_a0.clone(),
        $5c8ac76e429def4f$var$_a1.clone()
    ];
}
function $5c8ac76e429def4f$var$getQuadraticBezierPoint(t, p0, c0, p1) {
    const k = 1 - t;
    $5c8ac76e429def4f$var$_a0.copy(p0).scale(k ** 2);
    $5c8ac76e429def4f$var$_a1.copy(c0).scale(2 * k * t);
    $5c8ac76e429def4f$var$_a2.copy(p1).scale(t ** 2);
    const ret = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
    ret.add($5c8ac76e429def4f$var$_a0, $5c8ac76e429def4f$var$_a1).add($5c8ac76e429def4f$var$_a2);
    return ret;
}
function $5c8ac76e429def4f$var$getCubicBezierPoint(t, p0, c0, c1, p1) {
    const k = 1 - t;
    $5c8ac76e429def4f$var$_a0.copy(p0).scale(k ** 3);
    $5c8ac76e429def4f$var$_a1.copy(c0).scale(3 * k ** 2 * t);
    $5c8ac76e429def4f$var$_a2.copy(c1).scale(3 * k * t ** 2);
    $5c8ac76e429def4f$var$_a3.copy(p1).scale(t ** 3);
    const ret = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
    ret.add($5c8ac76e429def4f$var$_a0, $5c8ac76e429def4f$var$_a1).add($5c8ac76e429def4f$var$_a2).add($5c8ac76e429def4f$var$_a3);
    return ret;
}
class $5c8ac76e429def4f$export$b0e83c3ef8d2db1 {
    constructor({ points: points = [
        new (0, $77acc528c45f5d37$export$838423f3adec30fa)(0, 0, 0),
        new (0, $77acc528c45f5d37$export$838423f3adec30fa)(0, 1, 0),
        new (0, $77acc528c45f5d37$export$838423f3adec30fa)(1, 1, 0),
        new (0, $77acc528c45f5d37$export$838423f3adec30fa)(1, 0, 0)
    ], divisions: divisions = 12, type: type = $5c8ac76e429def4f$var$CATMULLROM } = {}){
        this.points = points;
        this.divisions = divisions;
        this.type = type;
    }
    _getQuadraticBezierPoints(divisions = this.divisions) {
        const points = [];
        const count = this.points.length;
        if (count < 3) return [];
        const p0 = this.points[0];
        let c0 = this.points[1], p1 = this.points[2];
        for(let i = 0; i <= divisions; i++){
            const p = $5c8ac76e429def4f$var$getQuadraticBezierPoint(i / divisions, p0, c0, p1);
            points.push(p);
        }
        let offset = 3;
        while(count - offset > 0){
            p0.copy(p1);
            c0 = p1.scale(2).sub(c0);
            p1 = this.points[offset];
            for(let i = 1; i <= divisions; i++){
                const p = $5c8ac76e429def4f$var$getQuadraticBezierPoint(i / divisions, p0, c0, p1);
                points.push(p);
            }
            offset++;
        }
        return points;
    }
    _getCubicBezierPoints(divisions = this.divisions) {
        const points = [];
        const count = this.points.length;
        if (count < 4) return [];
        let p0 = this.points[0], c0 = this.points[1], c1 = this.points[2], p1 = this.points[3];
        for(let i = 0; i <= divisions; i++){
            const p = $5c8ac76e429def4f$var$getCubicBezierPoint(i / divisions, p0, c0, c1, p1);
            points.push(p);
        }
        let offset = 4;
        while(count - offset > 1){
            p0.copy(p1);
            c0 = p1.scale(2).sub(c1);
            c1 = this.points[offset];
            p1 = this.points[offset + 1];
            for(let i = 1; i <= divisions; i++){
                const p = $5c8ac76e429def4f$var$getCubicBezierPoint(i / divisions, p0, c0, c1, p1);
                points.push(p);
            }
            offset += 2;
        }
        return points;
    }
    _getCatmullRomPoints(divisions = this.divisions, a = 0.168, b = 0.168) {
        const points = [];
        const count = this.points.length;
        if (count <= 2) return this.points;
        let p0;
        this.points.forEach((p, i)=>{
            if (i === 0) p0 = p;
            else {
                const [c0, c1] = $5c8ac76e429def4f$var$getCtrlPoint(this.points, i - 1, a, b);
                const c = new $5c8ac76e429def4f$export$b0e83c3ef8d2db1({
                    points: [
                        p0,
                        c0,
                        c1,
                        p
                    ],
                    type: $5c8ac76e429def4f$var$CUBICBEZIER
                });
                points.pop();
                points.push(...c.getPoints(divisions));
                p0 = p;
            }
        });
        return points;
    }
    getPoints(divisions = this.divisions, a = 0.168, b = 0.168) {
        const type = this.type;
        if (type === $5c8ac76e429def4f$var$QUADRATICBEZIER) return this._getQuadraticBezierPoints(divisions);
        if (type === $5c8ac76e429def4f$var$CUBICBEZIER) return this._getCubicBezierPoints(divisions);
        if (type === $5c8ac76e429def4f$var$CATMULLROM) return this._getCatmullRomPoints(divisions, a, b);
        return this.points;
    }
}
$5c8ac76e429def4f$export$b0e83c3ef8d2db1.CATMULLROM = $5c8ac76e429def4f$var$CATMULLROM;
$5c8ac76e429def4f$export$b0e83c3ef8d2db1.CUBICBEZIER = $5c8ac76e429def4f$var$CUBICBEZIER;
$5c8ac76e429def4f$export$b0e83c3ef8d2db1.QUADRATICBEZIER = $5c8ac76e429def4f$var$QUADRATICBEZIER;




/**
 * Abstract base class for path segments.
 * This class contains common methods for all segments types.
 */ class $363979b2cfc609e2$export$2e2bcd8739ae039 {
    constructor(){
        this._len = -1;
        this.tiltStart = 0;
        this.tiltEnd = 0;
    }
    /**
   * Get segment length.
   * @returns {number} segment length
   */ getLength() {
        if (this._len < 0) this.updateLength();
        return this._len;
    }
    /**
   * Get tilt angle at t
   * @param {number} t Distance at time t in range [0 .. 1]
   * @returns {number} Tilt angle at t
   */ getTiltAt(t) {
        return this.tiltStart * (1 - t) * this.tiltEnd * t;
    }
    /**
   * Creates a clone of this instance
   * @returns {BaseSegment} cloned instance
   */ clone() {
        return new this.constructor().copy(this);
    }
    /**
   * Copies another segment object to this instance.
   * @param {BaseSegment} source reference object
   * @returns {BaseSegment} copy of source object
   */ copy(source) {
        this._len = source._len;
        this.tiltStart = source.tiltStart;
        this.tiltEnd = source.tiltEnd;
        return this;
    }
}



// from https://github.com/Pomax/bezierjs/blob/d19695f3cc3ce383cf38ce4643f467deca7edb92/src/utils.js#L26
// Legendre-Gauss abscissae with n=24 (x_i values, defined at i=n as the roots of the nth order Legendre polynomial Pn(x))
const $5d4963343957c73b$export$cef27f7ab8f7e07b = [
    -0.06405689286260563,
    0.0640568928626056260850430826247450385909,
    -0.1911188674736163,
    0.1911188674736163091586398207570696318404,
    -0.3150426796961634,
    0.3150426796961633743867932913198102407864,
    -0.4337935076260451,
    0.4337935076260451384870842319133497124524,
    -0.5454214713888396,
    0.5454214713888395356583756172183723700107,
    -0.6480936519369755,
    0.6480936519369755692524957869107476266696,
    -0.7401241915785544,
    0.7401241915785543642438281030999784255232,
    -0.820001985973903,
    0.8200019859739029219539498726697452080761,
    -0.8864155270044011,
    0.8864155270044010342131543419821967550873,
    -0.9382745520027328,
    0.9382745520027327585236490017087214496548,
    -0.9747285559713095,
    0.9747285559713094981983919930081690617411,
    -0.9951872199970213,
    0.9951872199970213601799974097007368118745
];
const $5d4963343957c73b$export$a939288492d20f40 = [
    0.1279381953467521569740561652246953718517,
    0.1279381953467521569740561652246953718517,
    0.1258374563468282961213753825111836887264,
    0.1258374563468282961213753825111836887264,
    0.121670472927803391204463153476262425607,
    0.121670472927803391204463153476262425607,
    0.1155056680537256013533444839067835598622,
    0.1155056680537256013533444839067835598622,
    0.1074442701159656347825773424466062227946,
    0.1074442701159656347825773424466062227946,
    0.0976186521041138882698806644642471544279,
    0.0976186521041138882698806644642471544279,
    0.086190161531953275917185202983742667185,
    0.086190161531953275917185202983742667185,
    0.0733464814110803057340336152531165181193,
    0.0733464814110803057340336152531165181193,
    0.0592985849154367807463677585001085845412,
    0.0592985849154367807463677585001085845412,
    0.0442774388174198061686027482113382288593,
    0.0442774388174198061686027482113382288593,
    0.0285313886289336631813078159518782864491,
    0.0285313886289336631813078159518782864491,
    0.0123412297999871995468056670700372915759,
    0.0123412297999871995468056670700372915759
];
const $5d4963343957c73b$export$408b8ee5959eefd5 = (a)=>a * Math.PI / 180;
const $5d4963343957c73b$export$56cb859c01fa134d = (a)=>180 * a / Math.PI;
const $5d4963343957c73b$export$7d15b64cf5a3a4c4 = (val, min, max)=>Math.max(min, Math.min(val, max));
const $5d4963343957c73b$export$3a89f8d6f6bf6c9f = (t, v0, v1)=>v0 * (t - 1) + v1 * t;
function $5d4963343957c73b$export$f6fcd93c9a4e57c2(out, axis, sin, cos) {
    const x = axis[0];
    const y = axis[1];
    const z = axis[2];
    const t = 1 - cos;
    out[0] = x * x * t + cos;
    out[1] = y * x * t + z * sin;
    out[2] = z * x * t - y * sin;
    out[3] = 0;
    out[4] = x * y * t - z * sin;
    out[5] = y * y * t + cos;
    out[6] = z * y * t + x * sin;
    out[7] = 0;
    out[8] = x * z * t + y * sin;
    out[9] = y * z * t - x * sin;
    out[10] = z * z * t + cos;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $5d4963343957c73b$export$ebd0c6188c56c240(angle, norm, binorm, outNorm = norm, outBinorm = binorm) {
    const s = Math.sin(angle);
    const c = Math.cos(angle);
    const nx = c * norm.x + s * binorm.x;
    const ny = c * norm.y + s * binorm.y;
    const nz = c * norm.z + s * binorm.z;
    const bx = c * binorm.x - s * norm.x;
    const by = c * binorm.y - s * norm.y;
    const bz = c * binorm.z - s * norm.z;
    outNorm.set(nx, ny, nz);
    outBinorm.set(bx, by, bz);
}


const $cd35a7f6ac555f04$var$tempVec3 = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
function $cd35a7f6ac555f04$var$cubicBezier(t, p0, p1, p2, p3) {
    const k = 1 - t;
    // prettier-ignore
    return k * k * k * p0 + 3 * k * k * t * p1 + 3 * k * t * t * p2 + t * t * t * p3;
}
function $cd35a7f6ac555f04$var$cubicBezierDeriv(t, p0, p1, p2, p3) {
    const k = 1 - t;
    // prettier-ignore
    return 3 * k * k * (p1 - p0) + 6 * k * t * (p2 - p1) + 3 * t * t * (p3 - p2);
}
class $cd35a7f6ac555f04$export$2e2bcd8739ae039 extends (0, $363979b2cfc609e2$export$2e2bcd8739ae039) {
    constructor(p0, p1, p2, p3, tiltStart = 0, tiltEnd = 0){
        super();
        this.p0 = p0;
        this.p1 = p1;
        this.p2 = p2;
        this.p3 = p3;
        this.tiltStart = tiltStart;
        this.tiltEnd = tiltEnd;
        this._len = -1;
    }
    /**
   * Updates the segment length. You must call this method every time you change the curve's control points.
   */ updateLength() {
        // from https://github.com/Pomax/bezierjs/blob/d19695f3cc3ce383cf38ce4643f467deca7edb92/src/utils.js#L265
        const z = 0.5;
        const len = (0, $5d4963343957c73b$export$cef27f7ab8f7e07b).length;
        let sum = 0;
        for(let i = 0, t; i < len; i++){
            t = z * (0, $5d4963343957c73b$export$cef27f7ab8f7e07b)[i] + z;
            sum += (0, $5d4963343957c73b$export$a939288492d20f40)[i] * this.getDerivativeAt(t, $cd35a7f6ac555f04$var$tempVec3).len();
        }
        this._len = z * sum;
    }
    /**
   * Get point at relative position in curve according to segment length.
   * @param {number} t Distance at time t in range [0 .. 1]
   * @param {Vec3} out Optional Vec3 to output
   * @returns {Vec3} Point at relative position
   */ getPointAt(t, out = new (0, $77acc528c45f5d37$export$838423f3adec30fa)()) {
        out.x = $cd35a7f6ac555f04$var$cubicBezier(t, this.p0.x, this.p1.x, this.p2.x, this.p3.x);
        out.y = $cd35a7f6ac555f04$var$cubicBezier(t, this.p0.y, this.p1.y, this.p2.y, this.p3.y);
        out.z = $cd35a7f6ac555f04$var$cubicBezier(t, this.p0.z, this.p1.z, this.p2.z, this.p3.z);
        return out;
    }
    getDerivativeAt(t, out = new (0, $77acc528c45f5d37$export$838423f3adec30fa)()) {
        out.x = $cd35a7f6ac555f04$var$cubicBezierDeriv(t, this.p0.x, this.p1.x, this.p2.x, this.p3.x);
        out.y = $cd35a7f6ac555f04$var$cubicBezierDeriv(t, this.p0.y, this.p1.y, this.p2.y, this.p3.y);
        out.z = $cd35a7f6ac555f04$var$cubicBezierDeriv(t, this.p0.z, this.p1.z, this.p2.z, this.p3.z);
        return out;
    }
    /**
   * Returns a unit vector tangent at t
   * @param {number} t Distance at time t in range [0 .. 1]
   * @param {Vec3} out Optional Vec3 to output
   * @returns {Vec3} A unit vector
   */ getTangentAt(t, out = new (0, $77acc528c45f5d37$export$838423f3adec30fa)()) {
        return this.getDerivativeAt(t, out).normalize();
    }
    lastPoint() {
        return this.p3;
    }
}





const $3cb51952ee70b2ff$var$tempVec3 = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
function $3cb51952ee70b2ff$var$quadraticBezier(t, p0, p1, p2) {
    const k = 1 - t;
    return k * k * p0 + 2 * k * t * p1 + t * t * p2;
}
function $3cb51952ee70b2ff$var$quadraticBezierDeriv(t, p0, p1, p2) {
    const k = 1 - t;
    return 2 * k * (p1 - p0) + 2 * t * (p2 - p1);
}
class $3cb51952ee70b2ff$export$2e2bcd8739ae039 extends (0, $363979b2cfc609e2$export$2e2bcd8739ae039) {
    constructor(p0, p1, p2, tiltStart = 0, tiltEnd = 0){
        super();
        this.p0 = p0;
        this.p1 = p1;
        this.p2 = p2;
        this.tiltStart = tiltStart;
        this.tiltEnd = tiltEnd;
        this._len = -1;
    }
    /**
   * Updates the segment length. You must call this method every time you change the curve's control points.
   */ updateLength() {
        // from https://github.com/Pomax/bezierjs/blob/d19695f3cc3ce383cf38ce4643f467deca7edb92/src/utils.js#L265
        const z = 0.5;
        const len = (0, $5d4963343957c73b$export$cef27f7ab8f7e07b).length;
        let sum = 0;
        for(let i = 0, t; i < len; i++){
            t = z * (0, $5d4963343957c73b$export$cef27f7ab8f7e07b)[i] + z;
            sum += (0, $5d4963343957c73b$export$a939288492d20f40)[i] * this.getDerivativeAt(t, $3cb51952ee70b2ff$var$tempVec3).len();
        }
        this._len = z * sum;
    }
    /**
   * Get point at relative position in curve according to segment length.
   * @param {number} t Distance at time t in range [0 .. 1]
   * @param {Vec3} out Optional Vec3 to output
   * @returns {Vec3} Point at relative position
   */ getPointAt(t, out = new (0, $77acc528c45f5d37$export$838423f3adec30fa)()) {
        out.x = $3cb51952ee70b2ff$var$quadraticBezier(t, this.p0.x, this.p1.x, this.p2.x);
        out.y = $3cb51952ee70b2ff$var$quadraticBezier(t, this.p0.y, this.p1.y, this.p2.y);
        out.z = $3cb51952ee70b2ff$var$quadraticBezier(t, this.p0.z, this.p1.z, this.p2.z);
        return out;
    }
    getDerivativeAt(t, out = new (0, $77acc528c45f5d37$export$838423f3adec30fa)()) {
        out.x = $3cb51952ee70b2ff$var$quadraticBezierDeriv(t, this.p0.x, this.p1.x, this.p2.x);
        out.y = $3cb51952ee70b2ff$var$quadraticBezierDeriv(t, this.p0.y, this.p1.y, this.p2.y);
        out.z = $3cb51952ee70b2ff$var$quadraticBezierDeriv(t, this.p0.z, this.p1.z, this.p2.z);
        return out;
    }
    /**
   * Returns a unit vector tangent at t
   * @param {number} t Distance at time t in range [0 .. 1]
   * @param {Vec3} out Optional Vec3 to output
   * @returns {Vec3} A unit vector
   */ getTangentAt(t, out = new (0, $77acc528c45f5d37$export$838423f3adec30fa)()) {
        return this.getDerivativeAt(t, out).normalize();
    }
    lastPoint() {
        return this.p2;
    }
}





const $295009f3f9834aab$var$tempVec3 = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
class $295009f3f9834aab$export$2e2bcd8739ae039 extends (0, $363979b2cfc609e2$export$2e2bcd8739ae039) {
    constructor(p0, p1, tiltStart = 0, tiltEnd = 0){
        super();
        this.p0 = p0;
        this.p1 = p1;
        this.tiltStart = tiltStart;
        this.tiltEnd = tiltEnd;
        this._len = -1;
    }
    /**
   * Updates the segment length. You must call this method every time you change the curve's control points.
   */ updateLength() {
        this._len = $295009f3f9834aab$var$tempVec3.sub(this.p1, this.p0).len();
    }
    /**
   * Get point at relative position in curve according to segment length.
   * @param {number} t Distance at time t in range [0 .. 1]
   * @param {Vec3} out Optional Vec3 to output
   * @returns {Vec3} Point at relative position
   */ getPointAt(t, out = new (0, $77acc528c45f5d37$export$838423f3adec30fa)()) {
        (0, $fdb9d1061c642aaf$export$3a89f8d6f6bf6c9f)(out, this.p0, this.p1, t);
        return out;
    }
    /**
   * Returns a unit vector tangent at t
   * @param {number} t Distance at time t in range [0 .. 1]
   * @param {Vec3} out Optional Vec3 to output
   * @returns {Vec3} A unit vector
   */ getTangentAt(t, out = new (0, $77acc528c45f5d37$export$838423f3adec30fa)()) {
        return out.sub(this.p1, this.p0).normalize();
    }
    lastPoint() {
        return this.p1;
    }
}



const $6b22eed8c08b8498$var$tempVec3 = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $6b22eed8c08b8498$var$tempMat4 = /* @__PURE__ */ new (0, $6b06e593d6b503e3$export$21c0e3d5e995d7e1)();
function $6b22eed8c08b8498$var$throwIfNullProperty(property, message) {
    if (this[property] == null) throw new Error(message);
}
class $6b22eed8c08b8498$export$4b2950bdac9b6ee9 {
    constructor(){
        this._segments = [];
        this._lengthOffsets = null;
        this._totalLength = -1;
        this._lastPoint = null;
        this._lastTilt = 0;
        this._assertLastPoint = $6b22eed8c08b8498$var$throwIfNullProperty.bind(this, "_lastPoint", "Can`t get previous point of curve. Did you forget moveTo command?");
        this.tiltFunction = null;
    }
    moveTo(p, tilt = 0) {
        this._totalLength = -1;
        this._lastPoint = p;
        this._lastTilt = tilt;
    }
    bezierCurveTo(cp1, cp2, p, tilt = 0) {
        this._assertLastPoint();
        const seg = new (0, $cd35a7f6ac555f04$export$2e2bcd8739ae039)(this._lastPoint, cp1, cp2, p, this._lastTilt, tilt);
        this.addSegment(seg);
        return this;
    }
    quadraticCurveTo(cp, p, tilt = 0) {
        this._assertLastPoint();
        const seg = new (0, $3cb51952ee70b2ff$export$2e2bcd8739ae039)(this._lastPoint, cp, p, this._lastTilt, tilt);
        this.addSegment(seg);
        return this;
    }
    lineTo(p, tilt = 0) {
        this._assertLastPoint();
        const seg = new (0, $295009f3f9834aab$export$2e2bcd8739ae039)(this._lastPoint, p, this._lastTilt, tilt);
        this.addSegment(seg);
        return this;
    }
    addSegment(segment) {
        this._totalLength = -1;
        this._lastPoint = segment.lastPoint();
        this._lastTilt = segment.tiltEnd;
        this._segments.push(segment);
        return this;
    }
    getSegments() {
        return this._segments;
    }
    updateLength() {
        const n = this._segments.length;
        this._lengthOffsets = new Array(n);
        let offset = 0;
        for(let i = 0; i < n; i++){
            this._lengthOffsets[i] = offset;
            offset += this._segments[i].getLength();
        }
        this._totalLength = offset;
    }
    getLength() {
        if (this._totalLength < 0) this.updateLength();
        return this._totalLength;
    }
    /**
   * Finding a path segment at a given absolute length distance
   * @param {number} len absolute length distance
   * @returns {[number, number]} [_segment index_, _relative segment distance_]
   */ findSegmentIndexAtLength(len) {
        const totalLength = this.getLength();
        if (len <= 0) return [
            0,
            0
        ];
        if (len >= totalLength) return [
            this._segments.length - 1,
            1
        ];
        let start = 0;
        let end = this._lengthOffsets.length - 1;
        let index = -1;
        let mid;
        while(start <= end){
            mid = Math.ceil((start + end) / 2);
            if (mid === 0 || mid === this._lengthOffsets.length - 1 || len >= this._lengthOffsets[mid] && len < this._lengthOffsets[mid + 1]) {
                index = mid;
                break;
            } else if (len < this._lengthOffsets[mid]) end = mid - 1;
            else start = mid + 1;
        }
        const seg = this._segments[index];
        const segLen = seg.getLength();
        const t = (len - this._lengthOffsets[index]) / segLen;
        return [
            index,
            t
        ];
    }
    getPointAtLength(len, out = new (0, $77acc528c45f5d37$export$838423f3adec30fa)()) {
        const [i, t] = this.findSegmentIndexAtLength(len);
        return this._segments[i].getPointAt(t, out);
    }
    getPointAt(t, out = new (0, $77acc528c45f5d37$export$838423f3adec30fa)()) {
        const totalLength = this.getLength();
        return this.getPointAtLength(t * totalLength, out);
    }
    getTangentAtLength(len, out = new (0, $77acc528c45f5d37$export$838423f3adec30fa)()) {
        const [i, t] = this.findSegmentIndexAtLength(len);
        return this._segments[i].getTangentAt(t, out);
    }
    getTangentAt(t, out = new (0, $77acc528c45f5d37$export$838423f3adec30fa)()) {
        const totalLength = this.getLength();
        return this.getTangentAtLength(t * totalLength, out);
    }
    getTiltAtLength(len) {
        const [i, t] = this.findSegmentIndexAtLength(len);
        return this._segments[i].getTiltAt(t);
    }
    getTiltAt(t) {
        const totalLength = this.getLength();
        return this.getTiltAtLength(t * totalLength);
    }
    /**
   * Get sequence of points using `getPointAt(t)`
   * @param {number} divisions number of subdivisions
   * @returns {Vec3[]} array of points
   */ getPoints(divisions = 64) {
        const points = new Array(divisions + 1);
        for(let i = 0; i <= divisions; i++)points[i] = this.getPointAt(i / divisions);
        return points;
    }
    /**
   * Generates the Frenet Frames.
   * See http://www.cs.indiana.edu/pub/techreports/TR425.pdf
   * @param {number} divisions number of subdivisions
   * @returns {{tangents: Vec3[], normals: Vec3[], binormals: Vec3[]}} Object with tangents, normals and binormals arrays
   */ computeFrenetFrames(divisions = 64, closed = false) {
        const tangents = new Array(divisions + 1);
        const tilts = new Array(divisions + 1);
        const tiltFunction = this.tiltFunction ?? ((a)=>a);
        // compute the tangent vectors and tilt for each segment on the curve
        const totalLength = this.getLength();
        for(let i = 0; i <= divisions; i++){
            const [si, st] = this.findSegmentIndexAtLength(totalLength * i / divisions);
            const segment = this._segments[si];
            tangents[i] = segment.getTangentAt(st);
            tilts[i] = tiltFunction(segment.getTiltAt(st), i / divisions, this);
        }
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        const normal = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
        if (tx < ty && tx < tz) normal.set(1, 0, 0);
        else if (ty < tx && ty < tz) normal.set(0, 1, 0);
        else normal.set(0, 0, 1);
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        const normals = new Array(divisions + 1);
        const binormals = new Array(divisions + 1);
        normals[0] = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
        binormals[0] = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
        $6b22eed8c08b8498$var$tempVec3.cross(tangents[0], normal).normalize();
        normals[0].cross(tangents[0], $6b22eed8c08b8498$var$tempVec3);
        binormals[0].cross(tangents[0], normals[0]);
        // compute the slowly-varying normal vector for each segment on the curve
        for(let i = 1; i < tangents.length; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
            $6b22eed8c08b8498$var$tempVec3.cross(tangents[i - 1], tangents[i]);
            const crossLen = $6b22eed8c08b8498$var$tempVec3.len();
            if (crossLen > Number.EPSILON) {
                $6b22eed8c08b8498$var$tempVec3.scale(1 / crossLen); // nomalize
                const cosTheta = (0, $5d4963343957c73b$export$7d15b64cf5a3a4c4)(tangents[i - 1].dot(tangents[i]), -1, 1); // clamp for floating pt errors
                const sinTheta = (0, $5d4963343957c73b$export$7d15b64cf5a3a4c4)(crossLen, -1, 1);
                (0, $5d4963343957c73b$export$f6fcd93c9a4e57c2)($6b22eed8c08b8498$var$tempMat4, $6b22eed8c08b8498$var$tempVec3, sinTheta, cosTheta);
                normals[i].applyMatrix4($6b22eed8c08b8498$var$tempMat4);
            }
            binormals[i].cross(tangents[i], normals[i]);
        }
        // add tilt twisting
        for(let i = 0; i < tilts.length; i++)(0, $5d4963343957c73b$export$ebd0c6188c56c240)((0, $5d4963343957c73b$export$408b8ee5959eefd5)(tilts[i]), normals[i], binormals[i]);
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            const normalLast = normals[normals.length - 1];
            let step = Math.acos((0, $5d4963343957c73b$export$7d15b64cf5a3a4c4)(normals[0].dot(normalLast), -1, 1)) / (normals.length - 1);
            if (tangents[0].dot($6b22eed8c08b8498$var$tempVec3.cross(normals[0], normalLast)) > 0) step = -step;
            for(let i = 1; i < normals.length - 1; i++){
                const angle = step * i;
                (0, $5d4963343957c73b$export$ebd0c6188c56c240)(angle, normals[i], binormals[i]);
                tilts[i] += (0, $5d4963343957c73b$export$56cb859c01fa134d)(angle);
            }
            normals[normals.length - 1] = normals[0].clone();
            binormals[binormals.length - 1] = binormals[0].clone();
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals,
            tilts: tilts
        };
    }
}





// helper variables
const $538a4449078e5467$var$vertex = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $538a4449078e5467$var$normal = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $538a4449078e5467$var$uv = /* @__PURE__ */ new (0, $fee929fe6b903205$export$ac4bca90992eed1)();
const $538a4449078e5467$var$point = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
class $538a4449078e5467$export$36626c6004503f2d extends (0, $38f0c9db74b3b35f$export$2db6c17465f94a2) {
    constructor(gl, { path: path, radius: radius = 1, tubularSegments: tubularSegments = 64, radialSegments: radialSegments = 8, closed: closed = false, attributes: attributes = {} } = {}){
        super(gl, attributes);
        this.path = path;
        this.radius = radius;
        this.tubularSegments = tubularSegments;
        this.radialSegments = radialSegments;
        this.closed = closed;
        this.frenetFrames = path.computeFrenetFrames(tubularSegments, closed);
        const numVertices = (tubularSegments + 1) * (radialSegments + 1);
        const numIndices = tubularSegments * radialSegments * 6;
        this.positions = new Float32Array(numVertices * 3);
        this.normals = new Float32Array(numVertices * 3);
        this.uvs = new Float32Array(numVertices * 2);
        this.indices = numVertices > 65536 ? new Uint32Array(numIndices) : new Uint16Array(numIndices);
        // create buffer data
        this._generateAttributes();
        this._generateIndices();
        this.addAttribute("position", {
            size: 3,
            data: this.positions
        });
        this.addAttribute("normal", {
            size: 3,
            data: this.normals
        });
        this.addAttribute("uv", {
            size: 2,
            data: this.uvs
        });
        this.setIndex({
            data: this.indices
        });
    }
    _generateAttributes() {
        for(let i = 0; i <= this.tubularSegments; i++){
            let ci = i;
            if (i === this.tubularSegments) // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            ci = this.closed ? 0 : this.tubularSegments;
            this.path.getPointAt(ci / this.tubularSegments, $538a4449078e5467$var$point);
            // retrieve corresponding normal and binormal
            const N = this.frenetFrames.normals[ci];
            const B = this.frenetFrames.binormals[ci];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= this.radialSegments; j++){
                const v = j / this.radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                const idx = i * (this.radialSegments + 1) + j;
                // normal
                $538a4449078e5467$var$normal.x = cos * N.x + sin * B.x;
                $538a4449078e5467$var$normal.y = cos * N.y + sin * B.y;
                $538a4449078e5467$var$normal.z = cos * N.z + sin * B.z;
                // normal.normalize(); // ???
                this.normals.set($538a4449078e5467$var$normal, idx * 3);
                // vertex
                $538a4449078e5467$var$vertex.x = $538a4449078e5467$var$point.x + this.radius * $538a4449078e5467$var$normal.x;
                $538a4449078e5467$var$vertex.y = $538a4449078e5467$var$point.y + this.radius * $538a4449078e5467$var$normal.y;
                $538a4449078e5467$var$vertex.z = $538a4449078e5467$var$point.z + this.radius * $538a4449078e5467$var$normal.z;
                this.positions.set($538a4449078e5467$var$vertex, idx * 3);
                // uv
                $538a4449078e5467$var$uv.x = i / this.tubularSegments;
                $538a4449078e5467$var$uv.y = j / this.radialSegments;
                this.uvs.set($538a4449078e5467$var$uv, idx * 2);
            }
        }
    }
    _generateIndices() {
        for(let j = 1; j <= this.tubularSegments; j++)for(let i = 1; i <= this.radialSegments; i++){
            const a = (this.radialSegments + 1) * (j - 1) + (i - 1);
            const b = (this.radialSegments + 1) * j + (i - 1);
            const c = (this.radialSegments + 1) * j + i;
            const d = (this.radialSegments + 1) * (j - 1) + i;
            const idx = (j - 1) * this.radialSegments + (i - 1);
            this.indices.set([
                a,
                b,
                d,
                b,
                c,
                d
            ], idx * 6);
        }
    }
}






class $bd1a4acd529d85cb$export$e3cb9ef4a0c00f93 {
    constructor(gl, { width: width, height: height, dpr: dpr, wrapS: wrapS = gl.CLAMP_TO_EDGE, wrapT: wrapT = gl.CLAMP_TO_EDGE, minFilter: minFilter = gl.LINEAR, magFilter: magFilter = gl.LINEAR, geometry: geometry = new (0, $7993b287887390f8$export$5a465592bfe74b48)(gl), targetOnly: targetOnly = null } = {}){
        this.gl = gl;
        this.passes = [];
        this.geometry = geometry;
        this.uniform = {
            value: null
        };
        this.targetOnly = targetOnly;
        if (dpr) this.dpr = dpr;
        if (width) this.width = width;
        if (height) this.height = height;
        dpr = this.dpr || this.gl.renderer.dpr;
        this.resolutionWidth = Math.floor(this.width || this.gl.renderer.width * dpr);
        this.resolutionHeight = Math.floor(this.height || this.gl.renderer.height * dpr);
        let options = {
            dpr: this.dpr,
            width: this.resolutionWidth,
            height: this.resolutionHeight,
            wrapS: wrapS,
            wrapT: wrapT,
            minFilter: minFilter,
            magFilter: magFilter
        };
        const fbo = this.fbo = {
            read: new (0, $4f246b9cc5d577eb$export$efcb1f8bf367cbfb)(this.gl, options),
            write: new (0, $4f246b9cc5d577eb$export$efcb1f8bf367cbfb)(this.gl, options),
            swap: ()=>{
                let temp = fbo.read;
                fbo.read = fbo.write;
                fbo.write = temp;
            }
        };
    }
    addPass({ vertex: vertex = $bd1a4acd529d85cb$var$defaultVertex, fragment: fragment = $bd1a4acd529d85cb$var$defaultFragment, uniforms: uniforms = {}, textureUniform: textureUniform = "tMap", enabled: enabled = true } = {}) {
        uniforms[textureUniform] = {
            value: this.fbo.read.texture
        };
        const program = new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(this.gl, {
            vertex: vertex,
            fragment: fragment,
            uniforms: uniforms
        });
        const mesh = new (0, $ce267c790a189d7e$export$e176487c05830cc5)(this.gl, {
            geometry: this.geometry,
            program: program
        });
        const pass = {
            mesh: mesh,
            program: program,
            uniforms: uniforms,
            enabled: enabled,
            textureUniform: textureUniform
        };
        this.passes.push(pass);
        return pass;
    }
    resize({ width: width, height: height, dpr: dpr } = {}) {
        if (dpr) this.dpr = dpr;
        if (width) this.width = width;
        if (height) this.height = height;
        dpr = this.dpr || this.gl.renderer.dpr;
        this.resolutionWidth = Math.floor(this.width || this.gl.renderer.width * dpr);
        this.resolutionHeight = Math.floor(this.height || this.gl.renderer.height * dpr);
        this.fbo.read.setSize(this.resolutionWidth, this.resolutionHeight);
        this.fbo.write.setSize(this.resolutionWidth, this.resolutionHeight);
    }
    // Uses same arguments as renderer.render, with addition of optional texture passed in to avoid scene render
    render({ scene: scene, camera: camera, texture: texture, target: target = null, update: update = true, sort: sort = true, frustumCull: frustumCull = true, beforePostCallbacks: beforePostCallbacks }) {
        const enabledPasses = this.passes.filter((pass)=>pass.enabled);
        if (!texture) {
            this.gl.renderer.render({
                scene: scene,
                camera: camera,
                target: enabledPasses.length || !target && this.targetOnly ? this.fbo.write : target,
                update: update,
                sort: sort,
                frustumCull: frustumCull
            });
            this.fbo.swap();
            // Callback after rendering scene, but before post effects
            if (beforePostCallbacks) beforePostCallbacks.forEach((f)=>f && f());
        }
        enabledPasses.forEach((pass, i)=>{
            pass.mesh.program.uniforms[pass.textureUniform].value = !i && texture ? texture : this.fbo.read.texture;
            this.gl.renderer.render({
                scene: pass.mesh,
                target: i === enabledPasses.length - 1 && (target || !this.targetOnly) ? target : this.fbo.write,
                clear: true
            });
            this.fbo.swap();
        });
        this.uniform.value = this.fbo.read.texture;
    }
}
const $bd1a4acd529d85cb$var$defaultVertex = /* glsl */ `
    attribute vec2 uv;
    attribute vec2 position;

    varying vec2 vUv;

    void main() {
        vUv = uv;
        gl_Position = vec4(position, 0, 1);
    }
`;
const $bd1a4acd529d85cb$var$defaultFragment = /* glsl */ `
    precision highp float;

    uniform sampler2D tMap;
    varying vec2 vUv;

    void main() {
        gl_FragColor = texture2D(tMap, vUv);
    }
`;








const $4946e47d0d2eaa00$var$prevPos = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $4946e47d0d2eaa00$var$prevRot = /* @__PURE__ */ new (0, $8bba1ae865bec56b$export$5edfe12bb88684c8)();
const $4946e47d0d2eaa00$var$prevScl = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $4946e47d0d2eaa00$var$nextPos = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $4946e47d0d2eaa00$var$nextRot = /* @__PURE__ */ new (0, $8bba1ae865bec56b$export$5edfe12bb88684c8)();
const $4946e47d0d2eaa00$var$nextScl = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
class $4946e47d0d2eaa00$export$c35d437ae5945fcd {
    constructor({ objects: objects, data: data }){
        this.objects = objects;
        this.data = data;
        this.elapsed = 0;
        this.weight = 1;
        this.duration = data.frames.length - 1;
    }
    update(totalWeight = 1, isSet) {
        const weight = isSet ? 1 : this.weight / totalWeight;
        const elapsed = this.elapsed % this.duration;
        const floorFrame = Math.floor(elapsed);
        const blend = elapsed - floorFrame;
        const prevKey = this.data.frames[floorFrame];
        const nextKey = this.data.frames[(floorFrame + 1) % this.duration];
        this.objects.forEach((object, i)=>{
            $4946e47d0d2eaa00$var$prevPos.fromArray(prevKey.position, i * 3);
            $4946e47d0d2eaa00$var$prevRot.fromArray(prevKey.quaternion, i * 4);
            $4946e47d0d2eaa00$var$prevScl.fromArray(prevKey.scale, i * 3);
            $4946e47d0d2eaa00$var$nextPos.fromArray(nextKey.position, i * 3);
            $4946e47d0d2eaa00$var$nextRot.fromArray(nextKey.quaternion, i * 4);
            $4946e47d0d2eaa00$var$nextScl.fromArray(nextKey.scale, i * 3);
            $4946e47d0d2eaa00$var$prevPos.lerp($4946e47d0d2eaa00$var$nextPos, blend);
            $4946e47d0d2eaa00$var$prevRot.slerp($4946e47d0d2eaa00$var$nextRot, blend);
            $4946e47d0d2eaa00$var$prevScl.lerp($4946e47d0d2eaa00$var$nextScl, blend);
            object.position.lerp($4946e47d0d2eaa00$var$prevPos, weight);
            object.quaternion.slerp($4946e47d0d2eaa00$var$prevRot, weight);
            object.scale.lerp($4946e47d0d2eaa00$var$prevScl, weight);
        });
    }
}


const $f780061061085378$var$tempMat4 = /* @__PURE__ */ new (0, $6b06e593d6b503e3$export$21c0e3d5e995d7e1)();
class $f780061061085378$export$b8e0f93a76772233 extends (0, $ce267c790a189d7e$export$e176487c05830cc5) {
    constructor(gl, { rig: rig, geometry: geometry, program: program, mode: mode = gl.TRIANGLES } = {}){
        super(gl, {
            geometry: geometry,
            program: program,
            mode: mode
        });
        this.createBones(rig);
        this.createBoneTexture();
        this.animations = [];
        Object.assign(this.program.uniforms, {
            boneTexture: {
                value: this.boneTexture
            },
            boneTextureSize: {
                value: this.boneTextureSize
            }
        });
    }
    createBones(rig) {
        // Create root so that can simply update world matrix of whole skeleton
        this.root = new (0, $7f271013d8caa07e$export$563a914cafbdc389)();
        // Create bones
        this.bones = [];
        if (!rig.bones || !rig.bones.length) return;
        for(let i = 0; i < rig.bones.length; i++){
            const bone = new (0, $7f271013d8caa07e$export$563a914cafbdc389)();
            // Set initial values (bind pose)
            bone.position.fromArray(rig.bindPose.position, i * 3);
            bone.quaternion.fromArray(rig.bindPose.quaternion, i * 4);
            bone.scale.fromArray(rig.bindPose.scale, i * 3);
            this.bones.push(bone);
        }
        // Once created, set the hierarchy
        rig.bones.forEach((data, i)=>{
            this.bones[i].name = data.name;
            if (data.parent === -1) return this.bones[i].setParent(this.root);
            this.bones[i].setParent(this.bones[data.parent]);
        });
        // Then update to calculate world matrices
        this.root.updateMatrixWorld(true);
        // Store inverse of bind pose to calculate differences
        this.bones.forEach((bone)=>{
            bone.bindInverse = new (0, $6b06e593d6b503e3$export$21c0e3d5e995d7e1)(...bone.worldMatrix).inverse();
        });
    }
    createBoneTexture() {
        if (!this.bones.length) return;
        const size = Math.max(4, Math.pow(2, Math.ceil(Math.log(Math.sqrt(this.bones.length * 4)) / Math.LN2)));
        this.boneMatrices = new Float32Array(size * size * 4);
        this.boneTextureSize = size;
        this.boneTexture = new (0, $456587f66521e022$export$5431306cf43de24a)(this.gl, {
            image: this.boneMatrices,
            generateMipmaps: false,
            type: this.gl.FLOAT,
            internalFormat: this.gl.renderer.isWebgl2 ? this.gl.RGBA32F : this.gl.RGBA,
            minFilter: this.gl.NEAREST,
            magFilter: this.gl.NEAREST,
            flipY: false,
            width: size
        });
    }
    addAnimation(data) {
        const animation = new (0, $4946e47d0d2eaa00$export$c35d437ae5945fcd)({
            objects: this.bones,
            data: data
        });
        this.animations.push(animation);
        return animation;
    }
    update() {
        // Calculate combined animation weight
        let total = 0;
        this.animations.forEach((animation)=>total += animation.weight);
        this.animations.forEach((animation, i)=>{
            // force first animation to set in order to reset frame
            animation.update(total, i === 0);
        });
    }
    draw({ camera: camera } = {}) {
        // Update world matrices manually, as not part of scene graph
        this.root.updateMatrixWorld(true);
        // Update bone texture
        this.bones.forEach((bone, i)=>{
            // Find difference between current and bind pose
            $f780061061085378$var$tempMat4.multiply(bone.worldMatrix, bone.bindInverse);
            this.boneMatrices.set($f780061061085378$var$tempMat4, i * 16);
        });
        if (this.boneTexture) this.boneTexture.needsUpdate = true;
        super.draw({
            camera: camera
        });
    }
}



function $96cf17b52389af5f$export$5f1af8db9871e1d6({ font: font, text: text, width: width = Infinity, align: align = "left", size: size = 1, letterSpacing: letterSpacing = 0, lineHeight: lineHeight = 1.4, wordSpacing: wordSpacing = 0, wordBreak: wordBreak = false }) {
    const _this = this;
    let glyphs, buffers;
    let fontHeight, baseline, scale;
    const newline = /\n/;
    const whitespace = /\s/;
    parseFont();
    createGeometry();
    function parseFont() {
        glyphs = {};
        font.chars.forEach((d)=>glyphs[d.char] = d);
    }
    function createGeometry() {
        fontHeight = font.common.lineHeight;
        baseline = font.common.base;
        // Use baseline so that actual text height is as close to 'size' value as possible
        scale = size / baseline;
        // Strip spaces and newlines to get actual character length for buffers
        let chars = text.replace(/[ \n]/g, "");
        let numChars = chars.length;
        // Create output buffers
        buffers = {
            position: new Float32Array(numChars * 12),
            uv: new Float32Array(numChars * 8),
            id: new Float32Array(numChars * 4),
            index: new Uint16Array(numChars * 6)
        };
        // Set values for buffers that don't require calculation
        for(let i = 0; i < numChars; i++){
            buffers.id.set([
                i,
                i,
                i,
                i
            ], i * 4);
            buffers.index.set([
                i * 4,
                i * 4 + 2,
                i * 4 + 1,
                i * 4 + 1,
                i * 4 + 2,
                i * 4 + 3
            ], i * 6);
        }
        layout();
    }
    function layout() {
        const lines = [];
        let cursor = 0;
        let wordCursor = 0;
        let wordWidth = 0;
        let line = newLine();
        function newLine() {
            const line = {
                width: 0,
                glyphs: []
            };
            lines.push(line);
            wordCursor = cursor;
            wordWidth = 0;
            return line;
        }
        let maxTimes = 100;
        let count = 0;
        while(cursor < text.length && count < maxTimes){
            count++;
            const char = text[cursor];
            // Skip whitespace at start of line
            if (!line.width && whitespace.test(char)) {
                cursor++;
                wordCursor = cursor;
                wordWidth = 0;
                continue;
            }
            // If newline char, skip to next line
            if (newline.test(char)) {
                cursor++;
                line = newLine();
                continue;
            }
            const glyph = glyphs[char] || glyphs[" "];
            // Find any applicable kern pairs
            if (line.glyphs.length) {
                const prevGlyph = line.glyphs[line.glyphs.length - 1][0];
                let kern = getKernPairOffset(glyph.id, prevGlyph.id) * scale;
                line.width += kern;
                wordWidth += kern;
            }
            // add char to line
            line.glyphs.push([
                glyph,
                line.width
            ]);
            // calculate advance for next glyph
            let advance = 0;
            // If whitespace, update location of current word for line breaks
            if (whitespace.test(char)) {
                wordCursor = cursor;
                wordWidth = 0;
                // Add wordspacing
                advance += wordSpacing * size;
            } else // Add letterspacing
            advance += letterSpacing * size;
            advance += glyph.xadvance * scale;
            line.width += advance;
            wordWidth += advance;
            // If width defined
            if (line.width > width) {
                // If can break words, undo latest glyph if line not empty and create new line
                if (wordBreak && line.glyphs.length > 1) {
                    line.width -= advance;
                    line.glyphs.pop();
                    line = newLine();
                    continue;
                // If not first word, undo current word and cursor and create new line
                } else if (!wordBreak && wordWidth !== line.width) {
                    let numGlyphs = cursor - wordCursor + 1;
                    line.glyphs.splice(-numGlyphs, numGlyphs);
                    cursor = wordCursor;
                    line.width -= wordWidth;
                    line = newLine();
                    continue;
                }
            }
            cursor++;
            // Reset infinite loop catch
            count = 0;
        }
        // Remove last line if empty
        if (!line.width) lines.pop();
        populateBuffers(lines);
    }
    function populateBuffers(lines) {
        const texW = font.common.scaleW;
        const texH = font.common.scaleH;
        // For all fonts tested, a little offset was needed to be right on the baseline, hence 0.07.
        let y = 0.07 * size;
        let j = 0;
        for(let lineIndex = 0; lineIndex < lines.length; lineIndex++){
            let line = lines[lineIndex];
            for(let i = 0; i < line.glyphs.length; i++){
                const glyph = line.glyphs[i][0];
                let x = line.glyphs[i][1];
                if (align === "center") x -= line.width * 0.5;
                else if (align === "right") x -= line.width;
                // If space, don't add to geometry
                if (whitespace.test(glyph.char)) continue;
                // Apply char sprite offsets
                x += glyph.xoffset * scale;
                y -= glyph.yoffset * scale;
                // each letter is a quad. axis bottom left
                let w = glyph.width * scale;
                let h = glyph.height * scale;
                buffers.position.set([
                    x,
                    y - h,
                    0,
                    x,
                    y,
                    0,
                    x + w,
                    y - h,
                    0,
                    x + w,
                    y,
                    0
                ], j * 12);
                let u = glyph.x / texW;
                let uw = glyph.width / texW;
                let v = 1.0 - glyph.y / texH;
                let vh = glyph.height / texH;
                buffers.uv.set([
                    u,
                    v - vh,
                    u,
                    v,
                    u + uw,
                    v - vh,
                    u + uw,
                    v
                ], j * 8);
                // Reset cursor to baseline
                y += glyph.yoffset * scale;
                j++;
            }
            y -= size * lineHeight;
        }
        _this.buffers = buffers;
        _this.numLines = lines.length;
        _this.height = _this.numLines * size * lineHeight;
        _this.width = Math.max(...lines.map((line)=>line.width));
    }
    function getKernPairOffset(id1, id2) {
        for(let i = 0; i < font.kernings.length; i++){
            let k = font.kernings[i];
            if (k.first < id1) continue;
            if (k.second < id2) continue;
            if (k.first > id1) return 0;
            if (k.first === id1 && k.second > id2) return 0;
            return k.amount;
        }
        return 0;
    }
    // Update buffers to layout with new layout
    this.resize = function(options) {
        ({ width: width } = options);
        layout();
    };
    // Completely change text (like creating new Text)
    this.update = function(options) {
        ({ text: text } = options);
        createGeometry();
    };
}



const $494112e16127e8b6$var$vertex = /* glsl */ `
    precision highp float;
    precision highp int;

    attribute vec3 position;
    attribute vec3 normal;

    uniform mat3 normalMatrix;
    uniform mat4 modelViewMatrix;
    uniform mat4 projectionMatrix;

    varying vec3 vNormal;

    void main() {
        vNormal = normalize(normalMatrix * normal);
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
`;
const $494112e16127e8b6$var$fragment = /* glsl */ `
    precision highp float;
    precision highp int;

    varying vec3 vNormal;

    void main() {
        gl_FragColor.rgb = normalize(vNormal);
        gl_FragColor.a = 1.0;
    }
`;
function $494112e16127e8b6$export$2135f87dba422f95(gl) {
    return new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(gl, {
        vertex: $494112e16127e8b6$var$vertex,
        fragment: $494112e16127e8b6$var$fragment,
        cullFace: false
    });
}







class $f53674a75e23fbc8$export$b30894c9a40f6b81 {
    constructor(gl, { size: size = 128, falloff: // default size of the render targets
    falloff = 0.3, alpha: // size of the stamp, percentage of the size
    alpha = 1, dissipation: // opacity of the stamp
    dissipation = 0.98, type: // affects the speed that the stamp fades. Closer to 1 is slower
    type // Pass in gl.FLOAT to force it, defaults to gl.HALF_FLOAT
     } = {}){
        const _this = this;
        this.gl = gl;
        // output uniform containing render target textures
        this.uniform = {
            value: null
        };
        this.mask = {
            read: null,
            write: null,
            // Helper function to ping pong the render targets and update the uniform
            swap: ()=>{
                let temp = _this.mask.read;
                _this.mask.read = _this.mask.write;
                _this.mask.write = temp;
                _this.uniform.value = _this.mask.read.texture;
            }
        };
        createFBOs();
        this.aspect = 1;
        this.mouse = new (0, $fee929fe6b903205$export$ac4bca90992eed1)();
        this.velocity = new (0, $fee929fe6b903205$export$ac4bca90992eed1)();
        this.mesh = initProgram();
        function createFBOs() {
            // Requested type not supported, fall back to half float
            if (!type) type = gl.HALF_FLOAT || gl.renderer.extensions["OES_texture_half_float"].HALF_FLOAT_OES;
            let minFilter = (()=>{
                if (gl.renderer.isWebgl2) return gl.LINEAR;
                if (gl.renderer.extensions[`OES_texture_${type === gl.FLOAT ? "" : "half_"}float_linear`]) return gl.LINEAR;
                return gl.NEAREST;
            })();
            const options = {
                width: size,
                height: size,
                type: type,
                format: gl.RGBA,
                internalFormat: gl.renderer.isWebgl2 ? type === gl.FLOAT ? gl.RGBA32F : gl.RGBA16F : gl.RGBA,
                minFilter: minFilter,
                depth: false
            };
            _this.mask.read = new (0, $4f246b9cc5d577eb$export$efcb1f8bf367cbfb)(gl, options);
            _this.mask.write = new (0, $4f246b9cc5d577eb$export$efcb1f8bf367cbfb)(gl, options);
            _this.mask.swap();
        }
        function initProgram() {
            return new (0, $ce267c790a189d7e$export$e176487c05830cc5)(gl, {
                // Triangle that includes -1 to 1 range for 'position', and 0 to 1 range for 'uv'.
                geometry: new (0, $7993b287887390f8$export$5a465592bfe74b48)(gl),
                program: new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(gl, {
                    vertex: $f53674a75e23fbc8$var$vertex,
                    fragment: $f53674a75e23fbc8$var$fragment,
                    uniforms: {
                        tMap: _this.uniform,
                        uFalloff: {
                            value: falloff * 0.5
                        },
                        uAlpha: {
                            value: alpha
                        },
                        uDissipation: {
                            value: dissipation
                        },
                        // User needs to update these
                        uAspect: {
                            value: 1
                        },
                        uMouse: {
                            value: _this.mouse
                        },
                        uVelocity: {
                            value: _this.velocity
                        }
                    },
                    depthTest: false
                })
            });
        }
    }
    update() {
        this.mesh.program.uniforms.uAspect.value = this.aspect;
        this.gl.renderer.render({
            scene: this.mesh,
            target: this.mask.write,
            clear: false
        });
        this.mask.swap();
    }
}
const $f53674a75e23fbc8$var$vertex = /* glsl */ `
    attribute vec2 uv;
    attribute vec2 position;

    varying vec2 vUv;

    void main() {
        vUv = uv;
        gl_Position = vec4(position, 0, 1);
    }
`;
const $f53674a75e23fbc8$var$fragment = /* glsl */ `
    precision highp float;

    uniform sampler2D tMap;

    uniform float uFalloff;
    uniform float uAlpha;
    uniform float uDissipation;
    
    uniform float uAspect;
    uniform vec2 uMouse;
    uniform vec2 uVelocity;

    varying vec2 vUv;

    void main() {
        vec4 color = texture2D(tMap, vUv) * uDissipation;

        vec2 cursor = vUv - uMouse;
        cursor.x *= uAspect;

        vec3 stamp = vec3(uVelocity * vec2(1, -1), 1.0 - pow(1.0 - min(1.0, length(uVelocity)), 3.0));
        float falloff = smoothstep(uFalloff, 0.0, length(cursor)) * uAlpha;

        color.rgb = mix(color.rgb, stamp, vec3(falloff));

        gl_FragColor = color;
    }
`;







class $021b0ab1cb5b206a$export$ba3d7deec56faa05 {
    constructor(gl, { data: // Always pass in array of vec4s (RGBA values within texture)
    data = new Float32Array(16), geometry: geometry = new (0, $7993b287887390f8$export$5a465592bfe74b48)(gl), type: type // Pass in gl.FLOAT to force it, defaults to gl.HALF_FLOAT
     }){
        this.gl = gl;
        const initialData = data;
        this.passes = [];
        this.geometry = geometry;
        this.dataLength = initialData.length / 4;
        // Windows and iOS only like power of 2 textures
        // Find smallest PO2 that fits data
        this.size = Math.pow(2, Math.ceil(Math.log(Math.ceil(Math.sqrt(this.dataLength))) / Math.LN2));
        // Create coords for output texture
        this.coords = new Float32Array(this.dataLength * 2);
        for(let i = 0; i < this.dataLength; i++){
            const x = i % this.size / this.size; // to add 0.5 to be center pixel ?
            const y = Math.floor(i / this.size) / this.size;
            this.coords.set([
                x,
                y
            ], i * 2);
        }
        // Use original data if already correct length of PO2 texture, else copy to new array of correct length
        const floatArray = (()=>{
            if (initialData.length === this.size * this.size * 4) return initialData;
            else {
                const a = new Float32Array(this.size * this.size * 4);
                a.set(initialData);
                return a;
            }
        })();
        // Create output texture uniform using input float texture with initial data
        this.uniform = {
            value: new (0, $456587f66521e022$export$5431306cf43de24a)(gl, {
                image: floatArray,
                target: gl.TEXTURE_2D,
                type: gl.FLOAT,
                format: gl.RGBA,
                internalFormat: gl.renderer.isWebgl2 ? gl.RGBA32F : gl.RGBA,
                wrapS: gl.CLAMP_TO_EDGE,
                wrapT: gl.CLAMP_TO_EDGE,
                generateMipmaps: false,
                minFilter: gl.NEAREST,
                magFilter: gl.NEAREST,
                width: this.size,
                flipY: false
            })
        };
        // Create FBOs
        const options = {
            width: this.size,
            height: this.size,
            type: type || gl.HALF_FLOAT || gl.renderer.extensions["OES_texture_half_float"].HALF_FLOAT_OES,
            format: gl.RGBA,
            internalFormat: gl.renderer.isWebgl2 ? type === gl.FLOAT ? gl.RGBA32F : gl.RGBA16F : gl.RGBA,
            minFilter: gl.NEAREST,
            depth: false,
            unpackAlignment: 1
        };
        this.fbo = {
            read: new (0, $4f246b9cc5d577eb$export$efcb1f8bf367cbfb)(gl, options),
            write: new (0, $4f246b9cc5d577eb$export$efcb1f8bf367cbfb)(gl, options),
            swap: ()=>{
                let temp = this.fbo.read;
                this.fbo.read = this.fbo.write;
                this.fbo.write = temp;
                this.uniform.value = this.fbo.read.texture;
            }
        };
    }
    addPass({ vertex: vertex = $021b0ab1cb5b206a$var$defaultVertex, fragment: fragment = $021b0ab1cb5b206a$var$defaultFragment, uniforms: uniforms = {}, textureUniform: textureUniform = "tMap", enabled: enabled = true } = {}) {
        uniforms[textureUniform] = this.uniform;
        const program = new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(this.gl, {
            vertex: vertex,
            fragment: fragment,
            uniforms: uniforms
        });
        const mesh = new (0, $ce267c790a189d7e$export$e176487c05830cc5)(this.gl, {
            geometry: this.geometry,
            program: program
        });
        const pass = {
            mesh: mesh,
            program: program,
            uniforms: uniforms,
            enabled: enabled,
            textureUniform: textureUniform
        };
        this.passes.push(pass);
        return pass;
    }
    render() {
        const enabledPasses = this.passes.filter((pass)=>pass.enabled);
        enabledPasses.forEach((pass, i)=>{
            this.gl.renderer.render({
                scene: pass.mesh,
                target: this.fbo.write,
                clear: false
            });
            this.fbo.swap();
        });
    }
}
const $021b0ab1cb5b206a$var$defaultVertex = /* glsl */ `
    attribute vec2 uv;
    attribute vec2 position;

    varying vec2 vUv;

    void main() {
        vUv = uv;
        gl_Position = vec4(position, 0, 1);
    }
`;
const $021b0ab1cb5b206a$var$defaultFragment = /* glsl */ `
    precision highp float;

    uniform sampler2D tMap;
    varying vec2 vUv;

    void main() {
        gl_FragColor = texture2D(tMap, vUv);
    }
`;








const $19303088b2d5af7a$var$tmp = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
class $19303088b2d5af7a$export$79f3ee03e63e7073 {
    constructor(gl, { points: points, vertex: // Array of Vec3s
    vertex = $19303088b2d5af7a$var$defaultVertex, fragment: fragment = $19303088b2d5af7a$var$defaultFragment, uniforms: uniforms = {}, attributes: attributes = {} // For passing in custom attribs
     }){
        this.gl = gl;
        this.points = points;
        this.count = points.length;
        // Create buffers
        this.position = new Float32Array(this.count * 6);
        this.prev = new Float32Array(this.count * 6);
        this.next = new Float32Array(this.count * 6);
        const side = new Float32Array(this.count * 2);
        const uv = new Float32Array(this.count * 4);
        const index = new Uint16Array((this.count - 1) * 6);
        // Set static buffers
        for(let i = 0; i < this.count; i++){
            side.set([
                -1,
                1
            ], i * 2);
            const v = i / (this.count - 1);
            uv.set([
                0,
                v,
                1,
                v
            ], i * 4);
            if (i === this.count - 1) continue;
            const ind = i * 2;
            index.set([
                ind + 0,
                ind + 1,
                ind + 2
            ], (ind + 0) * 3);
            index.set([
                ind + 2,
                ind + 1,
                ind + 3
            ], (ind + 1) * 3);
        }
        const geometry = this.geometry = new (0, $38f0c9db74b3b35f$export$2db6c17465f94a2)(gl, Object.assign(attributes, {
            position: {
                size: 3,
                data: this.position
            },
            prev: {
                size: 3,
                data: this.prev
            },
            next: {
                size: 3,
                data: this.next
            },
            side: {
                size: 1,
                data: side
            },
            uv: {
                size: 2,
                data: uv
            },
            index: {
                size: 1,
                data: index
            }
        }));
        // Populate dynamic buffers
        this.updateGeometry();
        if (!uniforms.uResolution) this.resolution = uniforms.uResolution = {
            value: new (0, $fee929fe6b903205$export$ac4bca90992eed1)()
        };
        if (!uniforms.uDPR) this.dpr = uniforms.uDPR = {
            value: 1
        };
        if (!uniforms.uThickness) this.thickness = uniforms.uThickness = {
            value: 1
        };
        if (!uniforms.uColor) this.color = uniforms.uColor = {
            value: new (0, $b48d3797a6f93803$export$892596cec99bc70e)("#000")
        };
        if (!uniforms.uMiter) this.miter = uniforms.uMiter = {
            value: 1
        };
        // Set size uniforms' values
        this.resize();
        const program = this.program = new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(gl, {
            vertex: vertex,
            fragment: fragment,
            uniforms: uniforms
        });
        this.mesh = new (0, $ce267c790a189d7e$export$e176487c05830cc5)(gl, {
            geometry: geometry,
            program: program
        });
    }
    updateGeometry() {
        this.points.forEach((p, i)=>{
            p.toArray(this.position, i * 6);
            p.toArray(this.position, i * 6 + 3);
            if (!i) {
                // If first point, calculate prev using the distance to 2nd point
                $19303088b2d5af7a$var$tmp.copy(p).sub(this.points[i + 1]).add(p);
                $19303088b2d5af7a$var$tmp.toArray(this.prev, i * 6);
                $19303088b2d5af7a$var$tmp.toArray(this.prev, i * 6 + 3);
            } else {
                p.toArray(this.next, (i - 1) * 6);
                p.toArray(this.next, (i - 1) * 6 + 3);
            }
            if (i === this.points.length - 1) {
                // If last point, calculate next using distance to 2nd last point
                $19303088b2d5af7a$var$tmp.copy(p).sub(this.points[i - 1]).add(p);
                $19303088b2d5af7a$var$tmp.toArray(this.next, i * 6);
                $19303088b2d5af7a$var$tmp.toArray(this.next, i * 6 + 3);
            } else {
                p.toArray(this.prev, (i + 1) * 6);
                p.toArray(this.prev, (i + 1) * 6 + 3);
            }
        });
        this.geometry.attributes.position.needsUpdate = true;
        this.geometry.attributes.prev.needsUpdate = true;
        this.geometry.attributes.next.needsUpdate = true;
    }
    // Only need to call if not handling resolution uniforms manually
    resize() {
        // Update automatic uniforms if not overridden
        if (this.resolution) this.resolution.value.set(this.gl.canvas.width, this.gl.canvas.height);
        if (this.dpr) this.dpr.value = this.gl.renderer.dpr;
    }
}
const $19303088b2d5af7a$var$defaultVertex = /* glsl */ `
    precision highp float;

    attribute vec3 position;
    attribute vec3 next;
    attribute vec3 prev;
    attribute vec2 uv;
    attribute float side;

    uniform mat4 modelViewMatrix;
    uniform mat4 projectionMatrix;
    uniform vec2 uResolution;
    uniform float uDPR;
    uniform float uThickness;
    uniform float uMiter;

    varying vec2 vUv;

    vec4 getPosition() {
        mat4 mvp = projectionMatrix * modelViewMatrix;
        vec4 current = mvp * vec4(position, 1);
        vec4 nextPos = mvp * vec4(next, 1);
        vec4 prevPos = mvp * vec4(prev, 1);

        vec2 aspect = vec2(uResolution.x / uResolution.y, 1);    
        vec2 currentScreen = current.xy / current.w * aspect;
        vec2 nextScreen = nextPos.xy / nextPos.w * aspect;
        vec2 prevScreen = prevPos.xy / prevPos.w * aspect;
    
        vec2 dir1 = normalize(currentScreen - prevScreen);
        vec2 dir2 = normalize(nextScreen - currentScreen);
        vec2 dir = normalize(dir1 + dir2);
    
        vec2 normal = vec2(-dir.y, dir.x);
        normal /= mix(1.0, max(0.3, dot(normal, vec2(-dir1.y, dir1.x))), uMiter);
        normal /= aspect;

        float pixelWidthRatio = 1.0 / (uResolution.y / uDPR);
        float pixelWidth = current.w * pixelWidthRatio;
        normal *= pixelWidth * uThickness;
        current.xy -= normal * side;
    
        return current;
    }

    void main() {
        vUv = uv;
        gl_Position = getPosition();
    }
`;
const $19303088b2d5af7a$var$defaultFragment = /* glsl */ `
    precision highp float;

    uniform vec3 uColor;
    
    varying vec2 vUv;

    void main() {
        gl_FragColor.rgb = uColor;
        gl_FragColor.a = 1.0;
    }
`;





class $986c06555354908f$export$a24c14443968327c {
    constructor(gl, { light: light = new (0, $6a03d990fd9755d9$export$79f141de891a5fed)(gl), width: width = 1024, height: height = width }){
        this.gl = gl;
        this.light = light;
        this.target = new (0, $4f246b9cc5d577eb$export$efcb1f8bf367cbfb)(gl, {
            width: width,
            height: height
        });
        this.targetUniform = {
            value: this.target.texture
        };
        this.depthProgram = new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(gl, {
            vertex: $986c06555354908f$var$defaultVertex,
            fragment: $986c06555354908f$var$defaultFragment,
            cullFace: false
        });
        this.castMeshes = [];
    }
    add({ mesh: mesh, receive: receive = true, cast: cast = true, vertex: vertex = $986c06555354908f$var$defaultVertex, fragment: fragment = $986c06555354908f$var$defaultFragment, uniformProjection: uniformProjection = "shadowProjectionMatrix", uniformView: uniformView = "shadowViewMatrix", uniformTexture: uniformTexture = "tShadow" }) {
        // Add uniforms to existing program
        if (receive && !mesh.program.uniforms[uniformProjection]) {
            mesh.program.uniforms[uniformProjection] = {
                value: this.light.projectionMatrix
            };
            mesh.program.uniforms[uniformView] = {
                value: this.light.viewMatrix
            };
            mesh.program.uniforms[uniformTexture] = this.targetUniform;
        }
        if (!cast) return;
        this.castMeshes.push(mesh);
        // Store program for when switching between depth override
        mesh.colorProgram = mesh.program;
        // Check if depth program already attached
        if (mesh.depthProgram) return;
        // Use global depth override if nothing custom passed in
        if (vertex === $986c06555354908f$var$defaultVertex && fragment === $986c06555354908f$var$defaultFragment) {
            mesh.depthProgram = this.depthProgram;
            return;
        }
        // Create custom override program
        mesh.depthProgram = new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(this.gl, {
            vertex: vertex,
            fragment: fragment,
            cullFace: false
        });
    }
    setSize({ width: width = 1024, height: height = width }) {
        this.target = new (0, $4f246b9cc5d577eb$export$efcb1f8bf367cbfb)(this.gl, {
            width: width,
            height: height
        });
        this.targetUniform.value = this.target.texture;
    }
    render({ scene: scene }) {
        // For depth render, replace program with depth override.
        // Hide meshes not casting shadows.
        scene.traverse((node)=>{
            if (!node.draw) return;
            if (!!~this.castMeshes.indexOf(node)) node.program = node.depthProgram;
            else {
                node.isForceVisibility = node.visible;
                node.visible = false;
            }
        });
        // Render the depth shadow map using the light as the camera
        this.gl.renderer.render({
            scene: scene,
            camera: this.light,
            target: this.target
        });
        // Then switch the program back to the normal one
        scene.traverse((node)=>{
            if (!node.draw) return;
            if (!!~this.castMeshes.indexOf(node)) node.program = node.colorProgram;
            else node.visible = node.isForceVisibility;
        });
    }
}
const $986c06555354908f$var$defaultVertex = /* glsl */ `
    attribute vec3 position;
    attribute vec2 uv;

    uniform mat4 modelViewMatrix;
    uniform mat4 projectionMatrix;

    void main() {
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
`;
const $986c06555354908f$var$defaultFragment = /* glsl */ `
    precision highp float;

    vec4 packRGBA (float v) {
        vec4 pack = fract(vec4(1.0, 255.0, 65025.0, 16581375.0) * v);
        pack -= pack.yzww * vec2(1.0 / 255.0, 0.0).xxxy;
        return pack;
    }

    void main() {
        gl_FragColor = packRGBA(gl_FragCoord.z);
    }
`;



class $86871a2734c9e8e1$export$b87f39ce98cbd816 extends (0, $456587f66521e022$export$5431306cf43de24a) {
    constructor(gl, { buffer: buffer, wrapS: wrapS = gl.CLAMP_TO_EDGE, wrapT: wrapT = gl.CLAMP_TO_EDGE, anisotropy: anisotropy = 0, minFilter: minFilter, magFilter: magFilter } = {}){
        super(gl, {
            generateMipmaps: false,
            wrapS: wrapS,
            wrapT: wrapT,
            anisotropy: anisotropy,
            minFilter: minFilter,
            magFilter: magFilter
        });
        if (buffer) return this.parseBuffer(buffer);
    }
    parseBuffer(buffer) {
        const ktx = new $86871a2734c9e8e1$var$KhronosTextureContainer(buffer);
        ktx.mipmaps.isCompressedTexture = true;
        // Update texture
        this.image = ktx.mipmaps;
        this.internalFormat = ktx.glInternalFormat;
        if (ktx.numberOfMipmapLevels > 1) {
            if (this.minFilter === this.gl.LINEAR) this.minFilter = this.gl.NEAREST_MIPMAP_LINEAR;
        } else if (this.minFilter === this.gl.NEAREST_MIPMAP_LINEAR) this.minFilter = this.gl.LINEAR;
    // TODO: support cube maps
    // ktx.numberOfFaces
    }
}
function $86871a2734c9e8e1$var$KhronosTextureContainer(buffer) {
    const idCheck = [
        0xab,
        0x4b,
        0x54,
        0x58,
        0x20,
        0x31,
        0x31,
        0xbb,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ];
    const id = new Uint8Array(buffer, 0, 12);
    for(let i = 0; i < id.length; i++)if (id[i] !== idCheck[i]) return void 0;
    // TODO: Is this always 4? Tested: [android, macos]
    const size = Uint32Array.BYTES_PER_ELEMENT;
    const head = new DataView(buffer, 12, 13 * size);
    const littleEndian = head.getUint32(0, true) === 0x04030201;
    const glType = head.getUint32(1 * size, littleEndian);
    if (glType !== 0) return void 0;
    this.glInternalFormat = head.getUint32(4 * size, littleEndian);
    let width = head.getUint32(6 * size, littleEndian);
    let height = head.getUint32(7 * size, littleEndian);
    this.numberOfFaces = head.getUint32(10 * size, littleEndian);
    this.numberOfMipmapLevels = Math.max(1, head.getUint32(11 * size, littleEndian));
    const bytesOfKeyValueData = head.getUint32(12 * size, littleEndian);
    this.mipmaps = [];
    let offset = 64 + bytesOfKeyValueData;
    for(let level = 0; level < this.numberOfMipmapLevels; level++){
        const levelSize = new Int32Array(buffer, offset, 1)[0]; // size per face, since not supporting array cubemaps
        offset += 4; // levelSize field
        for(let face = 0; face < this.numberOfFaces; face++){
            const data = new Uint8Array(buffer, offset, levelSize);
            this.mipmaps.push({
                data: data,
                width: width,
                height: height
            });
            offset += levelSize;
            offset += 3 - (levelSize + 3) % 4; // add padding for odd sized image
        }
        width = width >> 1;
        height = height >> 1;
    }
}




// For compressed textures, generate using https://github.com/TimvanScherpenzeel/texture-compressor
let $b10d74bb0fdfec59$var$cache = {};
const $b10d74bb0fdfec59$var$supportedExtensions = [];
class $b10d74bb0fdfec59$export$fd1bfc71f64c538c {
    static load(gl, { src: src, wrapS: // string or object of extension:src key-values
    // {
    //     pvrtc: '...ktx',
    //     s3tc: '...ktx',
    //     etc: '...ktx',
    //     etc1: '...ktx',
    //     astc: '...ktx',
    //     webp: '...webp',
    //     jpg: '...jpg',
    //     png: '...png',
    // }
    // Only props relevant to KTXTexture
    wrapS = gl.CLAMP_TO_EDGE, wrapT: wrapT = gl.CLAMP_TO_EDGE, anisotropy: anisotropy = 0, format: // For regular images
    format = gl.RGBA, internalFormat: internalFormat = format, generateMipmaps: generateMipmaps = true, minFilter: minFilter = generateMipmaps ? gl.NEAREST_MIPMAP_LINEAR : gl.LINEAR, magFilter: magFilter = gl.LINEAR, premultiplyAlpha: premultiplyAlpha = false, unpackAlignment: unpackAlignment = 4, flipY: flipY = true } = {}) {
        const support = this.getSupportedExtensions(gl);
        let ext = "none";
        // If src is string, determine which format from the extension
        if (typeof src === "string") ext = src.split(".").pop().split("?")[0].toLowerCase();
        // If src is object, use supported extensions and provided list to choose best option
        // Get first supported match, so put in order of preference
        if (typeof src === "object") {
            for(const prop in src)if (support.includes(prop.toLowerCase())) {
                ext = prop.toLowerCase();
                src = src[prop];
                break;
            }
        }
        // Stringify props
        const cacheID = src + wrapS + wrapT + anisotropy + format + internalFormat + generateMipmaps + minFilter + magFilter + premultiplyAlpha + unpackAlignment + flipY + gl.renderer.id;
        // Check cache for existing texture
        if ($b10d74bb0fdfec59$var$cache[cacheID]) return $b10d74bb0fdfec59$var$cache[cacheID];
        let texture;
        switch(ext){
            case "ktx":
            case "pvrtc":
            case "s3tc":
            case "etc":
            case "etc1":
            case "astc":
                // Load compressed texture using KTX format
                texture = new (0, $86871a2734c9e8e1$export$b87f39ce98cbd816)(gl, {
                    src: src,
                    wrapS: wrapS,
                    wrapT: wrapT,
                    anisotropy: anisotropy,
                    minFilter: minFilter,
                    magFilter: magFilter
                });
                texture.loaded = this.loadKTX(src, texture);
                break;
            case "webp":
            case "jpg":
            case "jpeg":
            case "png":
                texture = new (0, $456587f66521e022$export$5431306cf43de24a)(gl, {
                    wrapS: wrapS,
                    wrapT: wrapT,
                    anisotropy: anisotropy,
                    format: format,
                    internalFormat: internalFormat,
                    generateMipmaps: generateMipmaps,
                    minFilter: minFilter,
                    magFilter: magFilter,
                    premultiplyAlpha: premultiplyAlpha,
                    unpackAlignment: unpackAlignment,
                    flipY: flipY
                });
                texture.loaded = this.loadImage(gl, src, texture, flipY);
                break;
            default:
                texture = new (0, $456587f66521e022$export$5431306cf43de24a)(gl);
        }
        texture.ext = ext;
        $b10d74bb0fdfec59$var$cache[cacheID] = texture;
        return texture;
    }
    static getSupportedExtensions(gl) {
        if ($b10d74bb0fdfec59$var$supportedExtensions.length) return $b10d74bb0fdfec59$var$supportedExtensions;
        const extensions = {
            pvrtc: gl.renderer.getExtension("WEBGL_compressed_texture_pvrtc") || gl.renderer.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
            s3tc: gl.renderer.getExtension("WEBGL_compressed_texture_s3tc"),
            // etc: gl.renderer.getExtension('WEBGL_compressed_texture_etc'),
            etc1: gl.renderer.getExtension("WEBGL_compressed_texture_etc1"),
            astc: gl.renderer.getExtension("WEBGL_compressed_texture_astc"),
            bc7: gl.renderer.getExtension("EXT_texture_compression_bptc")
        };
        for(const ext in extensions)if (extensions[ext]) $b10d74bb0fdfec59$var$supportedExtensions.push(ext);
        // Formats supported by all
        $b10d74bb0fdfec59$var$supportedExtensions.push("png", "jpg", "webp");
        return $b10d74bb0fdfec59$var$supportedExtensions;
    }
    static loadKTX(src, texture) {
        return fetch(src).then((res)=>res.arrayBuffer()).then((buffer)=>texture.parseBuffer(buffer));
    }
    static loadImage(gl, src, texture, flipY) {
        return $b10d74bb0fdfec59$var$decodeImage(src, flipY).then((imgBmp)=>{
            // Catch non POT textures for WebGL1 and update params to avoid errors
            if (!gl.renderer.isWebgl2 && (!$b10d74bb0fdfec59$var$powerOfTwo(imgBmp.width) || !$b10d74bb0fdfec59$var$powerOfTwo(imgBmp.height))) {
                if (texture.generateMipmaps) texture.generateMipmaps = false;
                if (texture.minFilter === gl.NEAREST_MIPMAP_LINEAR) texture.minFilter = gl.LINEAR;
                if (texture.wrapS === gl.REPEAT) texture.wrapS = texture.wrapT = gl.CLAMP_TO_EDGE;
            }
            texture.image = imgBmp;
            // For createImageBitmap, close once uploaded
            texture.onUpdate = ()=>{
                if (imgBmp.close) imgBmp.close();
                texture.onUpdate = null;
            };
            return imgBmp;
        });
    }
    static clearCache() {
        $b10d74bb0fdfec59$var$cache = {};
    }
}
function $b10d74bb0fdfec59$var$powerOfTwo(value) {
    // (width & (width - 1)) !== 0
    return Math.log2(value) % 1 === 0;
}
function $b10d74bb0fdfec59$var$decodeImage(src, flipY) {
    return new Promise((resolve)=>{
        if ($b10d74bb0fdfec59$var$isCreateImageBitmap()) fetch(src, {
            mode: "cors"
        }).then((r)=>r.blob()).then((b)=>createImageBitmap(b, {
                imageOrientation: flipY ? "flipY" : "none",
                premultiplyAlpha: "none"
            })).then(resolve);
        else {
            const img = new Image();
            img.crossOrigin = "";
            img.src = src;
            img.onload = ()=>resolve(img);
        }
    });
}
function $b10d74bb0fdfec59$var$isCreateImageBitmap() {
    const isChrome = navigator.userAgent.toLowerCase().includes("chrome");
    if (!isChrome) return false;
    try {
        createImageBitmap;
    } catch (e) {
        return false;
    }
    return true;
}








const $19a4997961ce63f8$var$tmpVec3A = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $19a4997961ce63f8$var$tmpVec3B = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $19a4997961ce63f8$var$tmpVec3C = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $19a4997961ce63f8$var$tmpVec3D = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $19a4997961ce63f8$var$tmpQuatA = /* @__PURE__ */ new (0, $8bba1ae865bec56b$export$5edfe12bb88684c8)();
const $19a4997961ce63f8$var$tmpQuatB = /* @__PURE__ */ new (0, $8bba1ae865bec56b$export$5edfe12bb88684c8)();
const $19a4997961ce63f8$var$tmpQuatC = /* @__PURE__ */ new (0, $8bba1ae865bec56b$export$5edfe12bb88684c8)();
const $19a4997961ce63f8$var$tmpQuatD = /* @__PURE__ */ new (0, $8bba1ae865bec56b$export$5edfe12bb88684c8)();
class $19a4997961ce63f8$export$1be3b913f1890f40 {
    constructor(data, weight = 1){
        this.data = data;
        this.elapsed = 0;
        this.weight = weight;
        // Set to false to not apply modulo to elapsed against duration
        this.loop = true;
        // Find starting time as exports from blender (perhaps others too) don't always start from 0
        this.startTime = data.reduce((a, { times: times })=>Math.min(a, times[0]), Infinity);
        // Get largest final time in all channels to calculate duration
        this.endTime = data.reduce((a, { times: times })=>Math.max(a, times[times.length - 1]), 0);
        this.duration = this.endTime - this.startTime;
    }
    update(totalWeight = 1, isSet) {
        const weight = isSet ? 1 : this.weight / totalWeight;
        const elapsed = !this.duration ? 0 : (this.loop ? this.elapsed % this.duration : Math.min(this.elapsed, this.duration - 0.001)) + this.startTime;
        this.data.forEach(({ node: node, transform: transform, interpolation: interpolation, times: times, values: values })=>{
            if (!this.duration) {
                let val = $19a4997961ce63f8$var$tmpVec3A;
                let size = 3;
                if (transform === "quaternion") {
                    val = $19a4997961ce63f8$var$tmpQuatA;
                    size = 4;
                }
                val.fromArray(values, 0);
                if (size === 4) node[transform].slerp(val, weight);
                else node[transform].lerp(val, weight);
                return;
            }
            // Get index of two time values elapsed is between
            const prevIndex = Math.max(1, times.findIndex((t)=>t > elapsed)) - 1;
            const nextIndex = prevIndex + 1;
            // Get linear blend/alpha between the two
            let alpha = (elapsed - times[prevIndex]) / (times[nextIndex] - times[prevIndex]);
            if (interpolation === "STEP") alpha = 0;
            let prevVal = $19a4997961ce63f8$var$tmpVec3A;
            let prevTan = $19a4997961ce63f8$var$tmpVec3B;
            let nextTan = $19a4997961ce63f8$var$tmpVec3C;
            let nextVal = $19a4997961ce63f8$var$tmpVec3D;
            let size = 3;
            if (transform === "quaternion") {
                prevVal = $19a4997961ce63f8$var$tmpQuatA;
                prevTan = $19a4997961ce63f8$var$tmpQuatB;
                nextTan = $19a4997961ce63f8$var$tmpQuatC;
                nextVal = $19a4997961ce63f8$var$tmpQuatD;
                size = 4;
            }
            if (interpolation === "CUBICSPLINE") {
                // Get the prev and next values from the indices
                prevVal.fromArray(values, prevIndex * size * 3 + size * 1);
                prevTan.fromArray(values, prevIndex * size * 3 + size * 2);
                nextTan.fromArray(values, nextIndex * size * 3 + size * 0);
                nextVal.fromArray(values, nextIndex * size * 3 + size * 1);
                // interpolate for final value
                prevVal = this.cubicSplineInterpolate(alpha, prevVal, prevTan, nextTan, nextVal);
                if (size === 4) prevVal.normalize();
            } else {
                // Get the prev and next values from the indices
                prevVal.fromArray(values, prevIndex * size);
                nextVal.fromArray(values, nextIndex * size);
                // interpolate for final value
                if (size === 4) prevVal.slerp(nextVal, alpha);
                else prevVal.lerp(nextVal, alpha);
            }
            // interpolate between multiple possible animations
            if (size === 4) node[transform].slerp(prevVal, weight);
            else node[transform].lerp(prevVal, weight);
        });
    }
    cubicSplineInterpolate(t, prevVal, prevTan, nextTan, nextVal) {
        const t2 = t * t;
        const t3 = t2 * t;
        const s2 = 3 * t2 - 2 * t3;
        const s3 = t3 - t2;
        const s0 = 1 - s2;
        const s1 = s3 - t2 + t;
        for(let i = 0; i < prevVal.length; i++)prevVal[i] = s0 * prevVal[i] + s1 * (1 - t) * prevTan[i] + s2 * nextVal[i] + s3 * t * nextTan[i];
        return prevVal;
    }
}





const $cbbc914ab5afecfb$var$tempMat4 = /* @__PURE__ */ new (0, $6b06e593d6b503e3$export$21c0e3d5e995d7e1)();
const $cbbc914ab5afecfb$var$identity = /* @__PURE__ */ new (0, $6b06e593d6b503e3$export$21c0e3d5e995d7e1)();
class $cbbc914ab5afecfb$export$163a251c2b28e649 extends (0, $ce267c790a189d7e$export$e176487c05830cc5) {
    constructor(gl, { skeleton: skeleton, geometry: geometry, program: program, mode: mode = gl.TRIANGLES } = {}){
        super(gl, {
            geometry: geometry,
            program: program,
            mode: mode
        });
        this.skeleton = skeleton;
        this.program = program;
        this.createBoneTexture();
    }
    createBoneTexture() {
        if (!this.skeleton.joints.length) return;
        const size = Math.max(4, Math.pow(2, Math.ceil(Math.log(Math.sqrt(this.skeleton.joints.length * 4)) / Math.LN2)));
        this.boneMatrices = new Float32Array(size * size * 4);
        this.boneTextureSize = size;
        this.boneTexture = new (0, $456587f66521e022$export$5431306cf43de24a)(this.gl, {
            image: this.boneMatrices,
            generateMipmaps: false,
            type: this.gl.FLOAT,
            internalFormat: this.gl.renderer.isWebgl2 ? this.gl.RGBA32F : this.gl.RGBA,
            minFilter: this.gl.NEAREST,
            magFilter: this.gl.NEAREST,
            flipY: false,
            width: size
        });
    }
    updateUniforms() {
        // Update bone texture
        this.skeleton.joints.forEach((bone, i)=>{
            // Find difference between current and bind pose
            $cbbc914ab5afecfb$var$tempMat4.multiply(bone.worldMatrix, bone.bindInverse);
            this.boneMatrices.set($cbbc914ab5afecfb$var$tempMat4, i * 16);
        });
        this.boneTexture.needsUpdate = true;
        // Reset for programs shared between multiple skins
        this.program.uniforms.boneTexture.value = this.boneTexture;
        this.program.uniforms.boneTextureSize.value = this.boneTextureSize;
    }
    draw({ camera: camera } = {}) {
        if (!this.program.uniforms.boneTexture) Object.assign(this.program.uniforms, {
            boneTexture: {
                value: this.boneTexture
            },
            boneTextureSize: {
                value: this.boneTextureSize
            }
        });
        this.updateUniforms();
        // Switch the world matrix with identity to ignore any transforms
        // on the mesh itself - only use skeleton's transforms
        const _worldMatrix = this.worldMatrix;
        this.worldMatrix = $cbbc914ab5afecfb$var$identity;
        super.draw({
            camera: camera
        });
        // Switch back to leave identity untouched
        this.worldMatrix = _worldMatrix;
    }
}








class $2bc7364bc78f80e9$export$f3c979c331175ad7 extends (0, $ce267c790a189d7e$export$e176487c05830cc5) {
    constructor(...args){
        super(...args);
        // Skip renderer frustum culling
        this.frustumCulled = false;
        this.isInstancedMesh = true;
    }
    addFrustumCull() {
        this.instanceTransforms = null;
        this.instanceLightmapScaleOffset = null;
        this.totalInstanceCount = 0;
        this.frustumCullFunction = null;
        this.instanceRenderList = null;
        // Get instanced mesh
        this.geometry.attributes.instanceMatrix;
        // Make list of transforms from instanceMatrix
        const matrixData = this.geometry.attributes.instanceMatrix.data;
        this.instanceTransforms = [];
        for(let i = 0, j = 0; i < matrixData.length; i += 16, j++){
            const transform = new (0, $7f271013d8caa07e$export$563a914cafbdc389)();
            transform.index = j;
            transform.matrix.fromArray(matrixData, i);
            transform.decompose();
            this.instanceTransforms.push(transform);
            // Add transforms to parent to update world matrices
            transform.setParent(this.parent);
        }
        this.totalInstanceCount = this.instanceTransforms.length;
        // Check for lightmap attributes - attach to transform
        if (!!this.geometry.attributes.lightmapScaleOffset) {
            const lightmapData = this.geometry.attributes.lightmapScaleOffset.data;
            for(let i = 0, j = 0; i < lightmapData.length; i += 4, j++)this.instanceTransforms[j].lightmapData = new (0, $d18992236fb6bd2f$export$b973696b5f65b53b)().fromArray(lightmapData, i);
        }
        this.frustumCullFunction = ({ camera: camera })=>{
            // frustum cull transforms each frame - pass world matrix
            this.instanceRenderList = [];
            this.instanceTransforms.forEach((transform)=>{
                if (!camera.frustumIntersectsMesh(this, transform.worldMatrix)) return;
                this.instanceRenderList.push(transform);
            });
            // update instanceMatrix and instancedCount with visible
            this.instanceRenderList.forEach((transform, i)=>{
                transform.matrix.toArray(this.geometry.attributes.instanceMatrix.data, i * 16);
                // Update lightmap attr
                if (transform.lightmapData) {
                    transform.lightmapData.toArray(this.geometry.attributes.lightmapScaleOffset.data, i * 4);
                    this.geometry.attributes.lightmapScaleOffset.needsUpdate = true;
                }
            });
            this.geometry.instancedCount = this.instanceRenderList.length;
            this.geometry.attributes.instanceMatrix.needsUpdate = true;
        };
        this.onBeforeRender(this.frustumCullFunction);
    }
    removeFrustumCull() {
        this.offBeforeRender(this.frustumCullFunction);
        this.geometry.instancedCount = this.totalInstanceCount;
        this.instanceTransforms.forEach((transform, i)=>{
            transform.matrix.toArray(this.geometry.attributes.instanceMatrix.data, i * 16);
            // Update lightmap attr
            if (transform.lightmapData) {
                transform.lightmapData.toArray(this.geometry.attributes.lightmapScaleOffset.data, i * 4);
                this.geometry.attributes.lightmapScaleOffset.needsUpdate = true;
            }
        });
        this.geometry.attributes.instanceMatrix.needsUpdate = true;
    }
}


// Supports
// [x] glb
// [x] Geometry
// [x] Nodes and Hierarchy
// [x] Instancing
// [x] Skins
// [x] Textures
// [x] Animation
// [x] GLB support
// [x] Basis/ktx2
// [x] KHR_lights_punctual lights
// [ ] Morph Targets
// [ ] Materials
// [ ] Cameras
// TODO: Sparse accessor packing? For morph targets basically
// TODO: init accessor missing bufferView with 0s
// TODO: morph target animations
// TODO: option to turn off GPU instancing
const $ae1d5be282cf8b6e$var$TYPE_ARRAY = {
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array,
    "image/jpeg": Uint8Array,
    "image/png": Uint8Array
};
const $ae1d5be282cf8b6e$var$TYPE_SIZE = {
    SCALAR: 1,
    VEC2: 2,
    VEC3: 3,
    VEC4: 4,
    MAT2: 4,
    MAT3: 9,
    MAT4: 16
};
const $ae1d5be282cf8b6e$var$ATTRIBUTES = {
    POSITION: "position",
    NORMAL: "normal",
    TANGENT: "tangent",
    TEXCOORD_0: "uv",
    TEXCOORD_1: "uv2",
    COLOR_0: "color",
    WEIGHTS_0: "skinWeight",
    JOINTS_0: "skinIndex"
};
const $ae1d5be282cf8b6e$var$TRANSFORMS = {
    translation: "position",
    rotation: "quaternion",
    scale: "scale"
};
class $ae1d5be282cf8b6e$export$aa93f11e7884f0f4 {
    static setBasisManager(manager) {
        this.basisManager = manager;
    }
    static async load(gl, src) {
        const dir = src.split("/").slice(0, -1).join("/") + "/";
        // load main description json
        const desc = await this.parseDesc(src);
        return this.parse(gl, desc, dir);
    }
    static async parse(gl, desc, dir) {
        desc.asset === undefined || desc.asset.version[0];
        desc.extensionsRequired?.includes("KHR_texture_basisu") && this.basisManager;
        // Load buffers async
        const buffers = await this.loadBuffers(desc, dir);
        // Unbind current VAO so that new buffers don't get added to active mesh
        gl.renderer.bindVertexArray(null);
        // Create gl buffers from bufferViews
        const bufferViews = this.parseBufferViews(gl, desc, buffers);
        // Create images from either bufferViews or separate image files
        const images = await this.parseImages(gl, desc, dir, bufferViews);
        const textures = this.parseTextures(gl, desc, images);
        // Just pass through material data for now
        const materials = this.parseMaterials(gl, desc, textures);
        // Fetch the inverse bind matrices for skeleton joints
        const skins = this.parseSkins(gl, desc, bufferViews);
        // Create geometries for each mesh primitive
        const meshes = this.parseMeshes(gl, desc, bufferViews, materials, skins);
        // Create transforms, meshes and hierarchy
        const nodes = this.parseNodes(gl, desc, meshes, skins, images);
        // Place nodes in skeletons
        this.populateSkins(skins, nodes);
        // Create animation handlers
        const animations = this.parseAnimations(gl, desc, nodes, bufferViews);
        // Get top level nodes for each scene
        const scenes = this.parseScenes(desc, nodes);
        const scene = scenes[desc.scene];
        // Create uniforms for scene lights (TODO: light linking?)
        const lights = this.parseLights(gl, desc, nodes, scenes);
        // Remove null nodes (instanced transforms)
        for(let i = nodes.length; i >= 0; i--)if (!nodes[i]) nodes.splice(i, 1);
        return {
            json: desc,
            buffers: buffers,
            bufferViews: bufferViews,
            images: images,
            textures: textures,
            materials: materials,
            meshes: meshes,
            nodes: nodes,
            lights: lights,
            animations: animations,
            scenes: scenes,
            scene: scene
        };
    }
    static parseDesc(src) {
        if (!src.match(/\.glb/)) return fetch(src).then((res)=>res.json());
        else return fetch(src).then((res)=>res.arrayBuffer()).then((glb)=>this.unpackGLB(glb));
    }
    // From https://github.com/donmccurdy/glTF-Transform/blob/e4108cc/packages/core/src/io/io.ts#L32
    static unpackGLB(glb) {
        // Decode and verify GLB header.
        const header = new Uint32Array(glb, 0, 3);
        if (header[0] !== 0x46546c67) throw new Error("Invalid glTF asset.");
        else if (header[1] !== 2) throw new Error(`Unsupported glTF binary version, "${header[1]}".`);
        // Decode and verify chunk headers.
        const jsonChunkHeader = new Uint32Array(glb, 12, 2);
        const jsonByteOffset = 20;
        const jsonByteLength = jsonChunkHeader[0];
        if (jsonChunkHeader[1] !== 0x4e4f534a) throw new Error("Unexpected GLB layout.");
        // Decode JSON.
        const jsonText = new TextDecoder().decode(glb.slice(jsonByteOffset, jsonByteOffset + jsonByteLength));
        const json = JSON.parse(jsonText);
        // JSON only
        if (jsonByteOffset + jsonByteLength === glb.byteLength) return json;
        const binaryChunkHeader = new Uint32Array(glb, jsonByteOffset + jsonByteLength, 2);
        if (binaryChunkHeader[1] !== 0x004e4942) throw new Error("Unexpected GLB layout.");
        // Decode content.
        const binaryByteOffset = jsonByteOffset + jsonByteLength + 8;
        const binaryByteLength = binaryChunkHeader[0];
        const binary = glb.slice(binaryByteOffset, binaryByteOffset + binaryByteLength);
        // Attach binary to buffer
        json.buffers[0].binary = binary;
        return json;
    }
    // Threejs GLTF Loader https://github.com/mrdoob/three.js/blob/master/examples/js/loaders/GLTFLoader.js#L1085
    static resolveURI(uri, dir) {
        // Invalid URI
        if (typeof uri !== "string" || uri === "") return "";
        // Host Relative URI
        if (/^https?:\/\//i.test(dir) && /^\//.test(uri)) dir = dir.replace(/(^https?:\/\/[^\/]+).*/i, "$1");
        // Absolute URI http://, https://, //
        if (/^(https?:)?\/\//i.test(uri)) return uri;
        // Data URI
        if (/^data:.*,.*$/i.test(uri)) return uri;
        // Blob URI
        if (/^blob:.*$/i.test(uri)) return uri;
        // Relative URI
        return dir + uri;
    }
    static loadBuffers(desc, dir) {
        if (!desc.buffers) return null;
        return Promise.all(desc.buffers.map((buffer)=>{
            // For GLB, binary buffer ready to go
            if (buffer.binary) return buffer.binary;
            const uri = this.resolveURI(buffer.uri, dir);
            return fetch(uri).then((res)=>res.arrayBuffer());
        }));
    }
    static parseBufferViews(gl, desc, buffers) {
        if (!desc.bufferViews) return null;
        // Clone to leave description pure
        const bufferViews = desc.bufferViews.map((o)=>Object.assign({}, o));
        desc.meshes && desc.meshes.forEach(({ primitives: primitives })=>{
            primitives.forEach(({ attributes: attributes, indices: indices })=>{
                // Flag bufferView as an attribute, so it knows to create a gl buffer
                for(let attr in attributes)bufferViews[desc.accessors[attributes[attr]].bufferView].isAttribute = true;
                if (indices === undefined) return;
                bufferViews[desc.accessors[indices].bufferView].isAttribute = true;
                // Make sure indices bufferView have a target property for gl buffer binding
                bufferViews[desc.accessors[indices].bufferView].target = gl.ELEMENT_ARRAY_BUFFER;
            });
        });
        // Get componentType of each bufferView from the accessors
        desc.accessors.forEach(({ bufferView: i, componentType: componentType })=>{
            bufferViews[i].componentType = componentType;
        });
        // Get mimetype of bufferView from images
        desc.images && desc.images.forEach(({ uri: uri, bufferView: i, mimeType: mimeType })=>{
            if (i === undefined) return;
            bufferViews[i].mimeType = mimeType;
        });
        // Push each bufferView to the GPU as a separate buffer
        bufferViews.forEach(({ buffer: bufferIndex, byteOffset: // required
        byteOffset = 0, byteLength: // optional
        byteLength, byteStride: // required
        byteStride, target: // optional
        target = gl.ARRAY_BUFFER, name: // optional, added above for elements
        name, extensions: // optional
        extensions, extras: // optional
        extras, componentType: // optional
        componentType, mimeType: // optional, added from accessor above
        mimeType, isAttribute: // optional, added from images above
        isAttribute }, i)=>{
            bufferViews[i].data = buffers[bufferIndex].slice(byteOffset, byteOffset + byteLength);
            if (!isAttribute) return;
            // Create gl buffers for the bufferView, pushing it to the GPU
            const buffer = gl.createBuffer();
            gl.bindBuffer(target, buffer);
            gl.renderer.state.boundBuffer = buffer;
            gl.bufferData(target, bufferViews[i].data, gl.STATIC_DRAW);
            bufferViews[i].buffer = buffer;
        });
        return bufferViews;
    }
    static parseImages(gl, desc, dir, bufferViews) {
        if (!desc.images) return null;
        return Promise.all(desc.images.map(async ({ uri: uri, bufferView: bufferViewIndex, mimeType: mimeType, name: name })=>{
            if (mimeType === "image/ktx2") {
                const { data: data } = bufferViews[bufferViewIndex];
                const image = await this.basisManager.parseTexture(data);
                return image;
            }
            // jpg / png
            const image = new Image();
            image.name = name;
            if (uri) image.src = this.resolveURI(uri, dir);
            else if (bufferViewIndex !== undefined) {
                const { data: data } = bufferViews[bufferViewIndex];
                const blob = new Blob([
                    data
                ], {
                    type: mimeType
                });
                image.src = URL.createObjectURL(blob);
            }
            image.ready = new Promise((res)=>{
                image.onload = ()=>res();
            });
            return image;
        }));
    }
    static parseTextures(gl, desc, images) {
        if (!desc.textures) return null;
        return desc.textures.map((textureInfo)=>this.createTexture(gl, desc, images, textureInfo));
    }
    static createTexture(gl, desc, images, { sampler: samplerIndex, source: sourceIndex, name: name, extensions: extensions, extras: extras }) {
        if (sourceIndex === undefined && !!extensions) // Basis extension source index
        {
            if (extensions.KHR_texture_basisu) sourceIndex = extensions.KHR_texture_basisu.source;
        }
        const image = images[sourceIndex];
        if (image.texture) return image.texture;
        const options = {
            flipY: false,
            wrapS: gl.REPEAT,
            // Repeat by default, opposed to OGL's clamp by default
            wrapT: gl.REPEAT
        };
        const sampler = samplerIndex !== undefined ? desc.samplers[samplerIndex] : null;
        if (sampler) [
            "magFilter",
            "minFilter",
            "wrapS",
            "wrapT"
        ].forEach((prop)=>{
            if (sampler[prop]) options[prop] = sampler[prop];
        });
        // For compressed textures
        if (image.isBasis) {
            options.image = image;
            options.internalFormat = image.internalFormat;
            if (image.isCompressedTexture) {
                options.generateMipmaps = false;
                if (image.length > 1) this.minFilter = gl.NEAREST_MIPMAP_LINEAR;
            }
            const texture = new (0, $456587f66521e022$export$5431306cf43de24a)(gl, options);
            texture.name = name;
            image.texture = texture;
            return texture;
        }
        const texture = new (0, $456587f66521e022$export$5431306cf43de24a)(gl, options);
        texture.name = name;
        image.texture = texture;
        image.ready.then(()=>{
            texture.image = image;
        });
        return texture;
    }
    static parseMaterials(gl, desc, textures) {
        if (!desc.materials) return null;
        return desc.materials.map(({ name: name, extensions: extensions, extras: extras, pbrMetallicRoughness: pbrMetallicRoughness = {}, normalTexture: normalTexture, occlusionTexture: occlusionTexture, emissiveTexture: emissiveTexture, emissiveFactor: emissiveFactor = [
            0,
            0,
            0
        ], alphaMode: alphaMode = "OPAQUE", alphaCutoff: alphaCutoff = 0.5, doubleSided: doubleSided = false })=>{
            const { baseColorFactor: baseColorFactor = [
                1,
                1,
                1,
                1
            ], baseColorTexture: baseColorTexture, metallicFactor: metallicFactor = 1, roughnessFactor: roughnessFactor = 1, metallicRoughnessTexture: metallicRoughnessTexture } = pbrMetallicRoughness;
            if (baseColorTexture) baseColorTexture.texture = textures[baseColorTexture.index];
            if (normalTexture) normalTexture.texture = textures[normalTexture.index];
            if (metallicRoughnessTexture) metallicRoughnessTexture.texture = textures[metallicRoughnessTexture.index];
            if (occlusionTexture) occlusionTexture.texture = textures[occlusionTexture.index];
            if (emissiveTexture) emissiveTexture.texture = textures[emissiveTexture.index];
            return {
                name: name,
                extensions: extensions,
                extras: extras,
                baseColorFactor: baseColorFactor,
                baseColorTexture: baseColorTexture,
                metallicFactor: metallicFactor,
                roughnessFactor: roughnessFactor,
                metallicRoughnessTexture: metallicRoughnessTexture,
                normalTexture: normalTexture,
                occlusionTexture: occlusionTexture,
                emissiveTexture: emissiveTexture,
                emissiveFactor: emissiveFactor,
                alphaMode: alphaMode,
                alphaCutoff: alphaCutoff,
                doubleSided: doubleSided
            };
        });
    }
    static parseSkins(gl, desc, bufferViews) {
        if (!desc.skins) return null;
        return desc.skins.map(({ inverseBindMatrices: inverseBindMatrices, skeleton: // optional
        skeleton, joints: // optional
        joints // required
         })=>{
            return {
                inverseBindMatrices: this.parseAccessor(inverseBindMatrices, desc, bufferViews),
                skeleton: skeleton,
                joints: joints
            };
        });
    }
    static parseMeshes(gl, desc, bufferViews, materials, skins) {
        if (!desc.meshes) return null;
        return desc.meshes.map(({ primitives: primitives, weights: // required
        weights, name: // optional
        name, extensions: // optional
        extensions, extras: // optional
        extras // optional
         }, meshIndex)=>{
            // TODO: weights stuff ?
            // Parse through nodes to see how many instances there are
            // and if there is a skin attached
            // If multiple instances of a skin, need to create each
            let numInstances = 0;
            let skinIndices = [];
            let isLightmap = false;
            desc.nodes && desc.nodes.forEach(({ mesh: mesh, skin: skin, extras: extras })=>{
                if (mesh === meshIndex) {
                    numInstances++;
                    if (skin !== undefined) skinIndices.push(skin);
                    if (extras && extras.lightmap_scale_offset) isLightmap = true;
                }
            });
            let isSkin = !!skinIndices.length;
            // For skins, return array of skin meshes to account for multiple instances
            if (isSkin) {
                primitives = skinIndices.map((skinIndex)=>{
                    return this.parsePrimitives(gl, primitives, desc, bufferViews, materials, 1, isLightmap).map(({ geometry: geometry, program: program, mode: mode })=>{
                        const mesh = new (0, $cbbc914ab5afecfb$export$163a251c2b28e649)(gl, {
                            skeleton: skins[skinIndex],
                            geometry: geometry,
                            program: program,
                            mode: mode
                        });
                        mesh.name = name;
                        // TODO: support skin frustum culling
                        mesh.frustumCulled = false;
                        return mesh;
                    });
                });
                // For retrieval to add to node
                primitives.instanceCount = 0;
                primitives.numInstances = numInstances;
            } else primitives = this.parsePrimitives(gl, primitives, desc, bufferViews, materials, numInstances, isLightmap).map(({ geometry: geometry, program: program, mode: mode })=>{
                // InstancedMesh class has custom frustum culling for instances
                const meshConstructor = geometry.attributes.instanceMatrix ? (0, $2bc7364bc78f80e9$export$f3c979c331175ad7) : (0, $ce267c790a189d7e$export$e176487c05830cc5);
                const mesh = new meshConstructor(gl, {
                    geometry: geometry,
                    program: program,
                    mode: mode
                });
                mesh.name = name;
                // Tag mesh so that nodes can add their transforms to the instance attribute
                mesh.numInstances = numInstances;
                return mesh;
            });
            return {
                primitives: primitives,
                weights: weights,
                name: name
            };
        });
    }
    static parsePrimitives(gl, primitives, desc, bufferViews, materials, numInstances, isLightmap) {
        return primitives.map(({ attributes: attributes, indices: // required
        indices, // optional
        material: materialIndex, mode: // optional
        mode = 4, targets: // optional
        targets, extensions: // optional
        extensions, extras: // optional
        extras // optional
         })=>{
            // TODO: materials
            const program = new (0, $494112e16127e8b6$export$2135f87dba422f95)(gl);
            if (materialIndex !== undefined) program.gltfMaterial = materials[materialIndex];
            const geometry = new (0, $38f0c9db74b3b35f$export$2db6c17465f94a2)(gl);
            // Add each attribute found in primitive
            for(let attr in attributes)geometry.addAttribute($ae1d5be282cf8b6e$var$ATTRIBUTES[attr], this.parseAccessor(attributes[attr], desc, bufferViews));
            // Add index attribute if found
            if (indices !== undefined) geometry.addAttribute("index", this.parseAccessor(indices, desc, bufferViews));
            // Add instanced transform attribute if multiple instances
            // Ignore if skin as we don't support instanced skins out of the box
            if (numInstances > 1) geometry.addAttribute("instanceMatrix", {
                instanced: 1,
                size: 16,
                data: new Float32Array(numInstances * 16)
            });
            // Always supply lightmapScaleOffset as an instanced attribute
            // Instanced skin lightmaps not supported
            if (isLightmap) geometry.addAttribute("lightmapScaleOffset", {
                instanced: 1,
                size: 4,
                data: new Float32Array(numInstances * 4)
            });
            return {
                geometry: geometry,
                program: program,
                mode: mode
            };
        });
    }
    static parseAccessor(index, desc, bufferViews) {
        // TODO: init missing bufferView with 0s
        // TODO: support sparse
        const { bufferView: bufferViewIndex, byteOffset: // optional
        byteOffset = 0, componentType: // optional
        componentType, normalized: // required
        normalized = false, count: // optional
        count, type: // required
        type, min: // required
        min, max: // optional
        max, sparse: // optional
        sparse // optional
         } = desc.accessors[index];
        const { data: data, buffer: // attached in parseBufferViews
        buffer, // replaced to be the actual GL buffer
        byteOffset: bufferByteOffset = 0, byteStride: // byteLength, // applied in parseBufferViews
        byteStride = 0, target: target } = bufferViews[bufferViewIndex];
        const size = $ae1d5be282cf8b6e$var$TYPE_SIZE[type];
        // Parse data from joined buffers
        const TypeArray = $ae1d5be282cf8b6e$var$TYPE_ARRAY[componentType];
        const elementBytes = TypeArray.BYTES_PER_ELEMENT;
        const componentStride = byteStride / elementBytes;
        const isInterleaved = !!byteStride && componentStride !== size;
        let filteredData;
        // Convert data to typed array for various uses (bounding boxes, raycasting, animation, merging etc)
        if (isInterleaved) {
            // First convert entire buffer to type
            const typedData = new TypeArray(data, byteOffset);
            // TODO: add length to not copy entire buffer if can help it
            // const typedData = new TypeArray(data, byteOffset, (count - 1) * componentStride)
            // Create output with length
            filteredData = new TypeArray(count * size);
            // Add element by element
            for(let i = 0; i < count; i++){
                const start = componentStride * i;
                const end = start + size;
                filteredData.set(typedData.slice(start, end), i * size);
            }
        } else // Simply a slice
        filteredData = new TypeArray(data, byteOffset, count * size);
        // Return attribute data
        return {
            data: filteredData,
            size: size,
            type: componentType,
            normalized: normalized,
            buffer: buffer,
            stride: byteStride,
            offset: byteOffset,
            count: count,
            min: min,
            max: max
        };
    }
    static parseNodes(gl, desc, meshes, skins, images) {
        if (!desc.nodes) return null;
        const nodes = desc.nodes.map(({ camera: camera, children: // optional
        children, // optional
        skin: skinIndex, matrix: // optional
        matrix, // optional
        mesh: meshIndex, rotation: // optional
        rotation, scale: // optional
        scale, translation: // optional
        translation, weights: // optional
        weights, name: // optional
        name, extensions: // optional
        extensions, extras: // optional
        extras // optional
         })=>{
            const node = new (0, $7f271013d8caa07e$export$563a914cafbdc389)();
            if (name) node.name = name;
            node.extras = extras;
            node.extensions = extensions;
            // Need to attach to node as may have same material but different lightmap
            if (extras && extras.lightmapTexture !== undefined) extras.lightmapTexture.texture = this.createTexture(gl, desc, images, {
                source: extras.lightmapTexture.index
            });
            // Apply transformations
            if (matrix) {
                node.matrix.copy(matrix);
                node.decompose();
            } else {
                if (rotation) node.quaternion.copy(rotation);
                if (scale) node.scale.copy(scale);
                if (translation) node.position.copy(translation);
                node.updateMatrix();
            }
            // Flags for avoiding duplicate transforms and removing unused instance nodes
            let isInstanced = false;
            let isFirstInstance = true;
            let isInstancedMatrix = false;
            let isSkin = skinIndex !== undefined;
            // add mesh if included
            if (meshIndex !== undefined) {
                if (isSkin) {
                    meshes[meshIndex].primitives[meshes[meshIndex].primitives.instanceCount].forEach((mesh)=>{
                        mesh.extras = extras;
                        mesh.setParent(node);
                    });
                    meshes[meshIndex].primitives.instanceCount++;
                    // Remove properties once all instances added
                    if (meshes[meshIndex].primitives.instanceCount === meshes[meshIndex].primitives.numInstances) {
                        delete meshes[meshIndex].primitives.numInstances;
                        delete meshes[meshIndex].primitives.instanceCount;
                    }
                } else meshes[meshIndex].primitives.forEach((mesh)=>{
                    mesh.extras = extras;
                    // instanced mesh might only have 1
                    if (mesh.geometry.isInstanced) {
                        isInstanced = true;
                        if (!mesh.instanceCount) mesh.instanceCount = 0;
                        else isFirstInstance = false;
                        if (mesh.geometry.attributes.instanceMatrix) {
                            isInstancedMatrix = true;
                            node.matrix.toArray(mesh.geometry.attributes.instanceMatrix.data, mesh.instanceCount * 16);
                        }
                        if (mesh.geometry.attributes.lightmapScaleOffset) mesh.geometry.attributes.lightmapScaleOffset.data.set(extras.lightmap_scale_offset, mesh.instanceCount * 4);
                        mesh.instanceCount++;
                        if (mesh.instanceCount === mesh.numInstances) {
                            // Remove properties once all instances added
                            delete mesh.numInstances;
                            delete mesh.instanceCount;
                            // Flag attribute as dirty
                            if (mesh.geometry.attributes.instanceMatrix) mesh.geometry.attributes.instanceMatrix.needsUpdate = true;
                            if (mesh.geometry.attributes.lightmapScaleOffset) mesh.geometry.attributes.lightmapScaleOffset.needsUpdate = true;
                        }
                    }
                    // For instances, only the first node will actually have the mesh
                    if (isInstanced) {
                        if (isFirstInstance) mesh.setParent(node);
                    } else mesh.setParent(node);
                });
            }
            // Reset node if instanced to not duplicate transforms
            if (isInstancedMatrix) {
                // Remove unused nodes just providing an instance transform
                if (!isFirstInstance) return null;
                // Avoid duplicate transform for node containing the instanced mesh
                node.matrix.identity();
                node.decompose();
            }
            return node;
        });
        desc.nodes.forEach(({ children: children = [] }, i)=>{
            // Set hierarchy now all nodes created
            children.forEach((childIndex)=>{
                if (!nodes[childIndex]) return;
                nodes[childIndex].setParent(nodes[i]);
            });
        });
        // Add frustum culling for instances now that instanceMatrix attribute is populated
        meshes.forEach(({ primitives: primitives }, i)=>{
            primitives.forEach((primitive, i)=>{
                if (primitive.isInstancedMesh) primitive.addFrustumCull();
            });
        });
        return nodes;
    }
    static populateSkins(skins, nodes) {
        if (!skins) return;
        skins.forEach((skin)=>{
            skin.joints = skin.joints.map((i, index)=>{
                const joint = nodes[i];
                joint.skin = skin;
                joint.bindInverse = new (0, $6b06e593d6b503e3$export$21c0e3d5e995d7e1)(...skin.inverseBindMatrices.data.slice(index * 16, (index + 1) * 16));
                return joint;
            });
            if (skin.skeleton) skin.skeleton = nodes[skin.skeleton];
        });
    }
    static parseAnimations(gl, desc, nodes, bufferViews) {
        if (!desc.animations) return null;
        return desc.animations.map(({ channels: channels, samplers: // required
        samplers, name: // required
        name // optional
         }, animationIndex)=>{
            const data = channels.map(({ sampler: samplerIndex, target: // required
            target // required
             })=>{
                const { input: inputIndex, interpolation: // required
                interpolation = "LINEAR", output: outputIndex // required
                 } = samplers[samplerIndex];
                const { node: nodeIndex, path: // optional - TODO: when is it not included?
                path // required
                 } = target;
                const node = nodes[nodeIndex];
                const transform = $ae1d5be282cf8b6e$var$TRANSFORMS[path];
                const times = this.parseAccessor(inputIndex, desc, bufferViews).data;
                const values = this.parseAccessor(outputIndex, desc, bufferViews).data;
                // Store reference on node for cyclical retrieval
                if (!node.animations) node.animations = [];
                if (!node.animations.includes(animationIndex)) node.animations.push(animationIndex);
                return {
                    node: node,
                    transform: transform,
                    interpolation: interpolation,
                    times: times,
                    values: values
                };
            });
            return {
                name: name,
                animation: new (0, $19a4997961ce63f8$export$1be3b913f1890f40)(data)
            };
        });
    }
    static parseScenes(desc, nodes) {
        if (!desc.scenes) return null;
        return desc.scenes.map(({ nodes: nodesIndices = [], name: name, extensions: // optional
        extensions, extras: extras })=>{
            const scene = nodesIndices.reduce((map, i)=>{
                // Don't add null nodes (instanced transforms)
                if (nodes[i]) map.push(nodes[i]);
                return map;
            }, []);
            scene.extras = extras;
            return scene;
        });
    }
    static parseLights(gl, desc, nodes, scenes) {
        const lights = {
            directional: [],
            point: [],
            spot: []
        };
        // Update matrices on root nodes
        scenes.forEach((scene)=>scene.forEach((node)=>node.updateMatrixWorld()));
        // uses KHR_lights_punctual extension
        const lightsDescArray = desc.extensions?.KHR_lights_punctual?.lights || [];
        // Need nodes for transforms
        nodes.forEach((node)=>{
            if (!node?.extensions?.KHR_lights_punctual) return;
            const lightIndex = node.extensions.KHR_lights_punctual.light;
            const lightDesc = lightsDescArray[lightIndex];
            const light = {
                name: lightDesc.name || "",
                color: {
                    value: new (0, $77acc528c45f5d37$export$838423f3adec30fa)().set(lightDesc.color || 1)
                }
            };
            // Apply intensity directly to color
            if (lightDesc.intensity !== undefined) light.color.value.multiply(lightDesc.intensity);
            switch(lightDesc.type){
                case "directional":
                    light.direction = {
                        value: new (0, $77acc528c45f5d37$export$838423f3adec30fa)(0, 0, 1).transformDirection(node.worldMatrix)
                    };
                    break;
                case "point":
                    light.position = {
                        value: new (0, $77acc528c45f5d37$export$838423f3adec30fa)().applyMatrix4(node.worldMatrix)
                    };
                    light.distance = {
                        value: lightDesc.range
                    };
                    light.decay = {
                        value: 2
                    };
                    break;
                case "spot":
                    // TODO: support spot uniforms
                    Object.assign(light, lightDesc);
                    break;
            }
            lights[lightDesc.type].push(light);
        });
        return lights;
    }
}




let $aa9fe7c754ab1664$var$supportedFormat;
let $aa9fe7c754ab1664$var$id = 0;
class $aa9fe7c754ab1664$export$5fbb6ec1e27a9e4a {
    constructor(workerSrc, gl){
        if (!$aa9fe7c754ab1664$var$supportedFormat) $aa9fe7c754ab1664$var$supportedFormat = this.getSupportedFormat(gl);
        this.onMessage = this.onMessage.bind(this);
        this.queue = new Map();
        this.initWorker(workerSrc);
    }
    getSupportedFormat(gl = document.createElement("canvas").getContext("webgl")) {
        /* if (!!gl.getExtension('WEBGL_compressed_texture_etc')) {
        return 'etc2';
    } else  */ if (!!gl.getExtension("WEBGL_compressed_texture_astc")) return "astc";
        else if (!!gl.getExtension("EXT_texture_compression_bptc")) return "bptc";
        else if (!!gl.getExtension("WEBGL_compressed_texture_s3tc")) return "s3tc";
        else if (!!gl.getExtension("WEBGL_compressed_texture_etc1")) return "etc1";
        else if (!!gl.getExtension("WEBGL_compressed_texture_pvrtc") || !!gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc")) return "pvrtc";
        return "none";
    }
    initWorker(workerSrc) {
        this.worker = new Worker(workerSrc);
        this.worker.onmessage = this.onMessage;
    }
    onMessage({ data: data }) {
        const { id: id, error: error, image: image } = data;
        if (error) return;
        const textureResolve = this.queue.get(id);
        this.queue.delete(id);
        image.isBasis = true;
        textureResolve(image);
    }
    parseTexture(buffer) {
        $aa9fe7c754ab1664$var$id++;
        this.worker.postMessage({
            id: $aa9fe7c754ab1664$var$id,
            buffer: buffer,
            supportedFormat: $aa9fe7c754ab1664$var$supportedFormat
        });
        let textureResolve;
        const promise = new Promise((res)=>textureResolve = res);
        this.queue.set($aa9fe7c754ab1664$var$id, textureResolve);
        return promise;
    }
}






class $3bee7ccdcdafccd2$export$4e5822deeb8fdf95 extends (0, $ce267c790a189d7e$export$e176487c05830cc5) {
    constructor(gl, { geometry: geometry, wireColor: wireColor = new (0, $b48d3797a6f93803$export$892596cec99bc70e)(0, 0.75, 0.5), ...meshProps } = {}){
        const wireProgram = new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(gl, {
            vertex: $3bee7ccdcdafccd2$var$vertex,
            fragment: $3bee7ccdcdafccd2$var$fragment,
            uniforms: {
                wireColor: {
                    value: wireColor
                }
            }
        });
        const positionArray = geometry.attributes.position.data;
        const indices = [];
        const hashSet = new Set();
        function addUniqueIndices(idx) {
            for(let i = 0; i < idx.length; i += 2)if ($3bee7ccdcdafccd2$var$isUniqueEdgePosition(idx[i] * 3, idx[i + 1] * 3, positionArray, hashSet)) indices.push(idx[i], idx[i + 1]);
        }
        if (geometry.attributes.index) {
            const idata = geometry.attributes.index.data;
            for(let i = 0; i < idata.length; i += 3)// For every triangle, make three line pairs (start, end)
            // prettier-ignore
            addUniqueIndices([
                idata[i],
                idata[i + 1],
                idata[i + 1],
                idata[i + 2],
                idata[i + 2],
                idata[i]
            ]);
        } else {
            const numVertices = Math.floor(positionArray.length / 3);
            for(let i = 0; i < numVertices; i += 3)addUniqueIndices([
                i,
                i + 1,
                i + 1,
                i + 2,
                i + 2,
                i
            ]);
        }
        const indicesTyped = indices.length > 65536 ? new Uint32Array(indices) : new Uint16Array(indices);
        const wireGeometry = new (0, $38f0c9db74b3b35f$export$2db6c17465f94a2)(gl, {
            position: {
                ...geometry.attributes.position
            },
            index: {
                data: indicesTyped
            }
        });
        super(gl, {
            ...meshProps,
            mode: gl.LINES,
            geometry: wireGeometry,
            program: wireProgram
        });
    }
}
// from https://github.com/mrdoob/three.js/blob/0c26bb4bb8220126447c8373154ac045588441de/src/geometries/WireframeGeometry.js#L116
function $3bee7ccdcdafccd2$var$isUniqueEdgePosition(start, end, pos, hashSet) {
    // prettier-ignore
    const hash1 = [
        pos[start],
        pos[start + 1],
        pos[start + 2],
        pos[end],
        pos[end + 1],
        pos[end + 2]
    ].join("#");
    // coincident edge
    // prettier-ignore
    const hash2 = [
        pos[end],
        pos[end + 1],
        pos[end + 2],
        pos[start],
        pos[start + 1],
        pos[start + 2]
    ].join("#");
    const oldSize = hashSet.size;
    hashSet.add(hash1);
    hashSet.add(hash2);
    return hashSet.size - oldSize === 2;
}
const $3bee7ccdcdafccd2$var$vertex = /* glsl */ `
attribute vec3 position;
uniform mat4 modelViewMatrix;
uniform mat4 projectionMatrix;

void main() {    
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
`;
const $3bee7ccdcdafccd2$var$fragment = /* glsl */ `
precision highp float;
uniform vec3 wireColor;

void main() {    
    gl_FragColor = vec4(wireColor, 1.0);
}
`;






class $e560421979a7a2d5$export$6c8303f35b8578fd extends (0, $ce267c790a189d7e$export$e176487c05830cc5) {
    constructor(gl, { size: size = 1, symmetric: symmetric = false, xColor: xColor = new (0, $77acc528c45f5d37$export$838423f3adec30fa)(0.96, 0.21, 0.32), yColor: yColor = new (0, $77acc528c45f5d37$export$838423f3adec30fa)(0.44, 0.64, 0.11), zColor: zColor = new (0, $77acc528c45f5d37$export$838423f3adec30fa)(0.18, 0.52, 0.89), ...meshProps } = {}){
        const a = symmetric ? -size : 0;
        const b = size;
        // prettier-ignore
        const vertices = new Float32Array([
            a,
            0,
            0,
            b,
            0,
            0,
            0,
            a,
            0,
            0,
            b,
            0,
            0,
            0,
            a,
            0,
            0,
            b
        ]);
        // prettier-ignore
        const colors = new Float32Array([
            ...xColor,
            ...xColor,
            ...yColor,
            ...yColor,
            ...zColor,
            ...zColor
        ]);
        const geometry = new (0, $38f0c9db74b3b35f$export$2db6c17465f94a2)(gl, {
            position: {
                size: 3,
                data: vertices
            },
            color: {
                size: 3,
                data: colors
            }
        });
        const program = new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(gl, {
            vertex: $e560421979a7a2d5$var$vertex,
            fragment: $e560421979a7a2d5$var$fragment
        });
        super(gl, {
            ...meshProps,
            mode: gl.LINES,
            geometry: geometry,
            program: program
        });
    }
}
const $e560421979a7a2d5$var$vertex = /* glsl */ `
attribute vec3 position;
attribute vec3 color;
uniform mat4 modelViewMatrix;
uniform mat4 projectionMatrix;

varying vec3 vColor;

void main() {    
    vColor = color;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
`;
const $e560421979a7a2d5$var$fragment = /* glsl */ `
precision highp float;
varying vec3 vColor;

void main() {    
    gl_FragColor = vec4(vColor, 1.0);
}
`;






class $fd9277a66b15c5d9$export$3875d39926561055 extends (0, $ce267c790a189d7e$export$e176487c05830cc5) {
    constructor(gl, { size: size = 10, divisions: divisions = 10, color: color = new (0, $77acc528c45f5d37$export$838423f3adec30fa)(0.75, 0.75, 0.75), ...meshProps } = {}){
        const numVertices = (size + 1) * 4;
        const vertices = new Float32Array(numVertices * 3);
        const hs = size / 2;
        for(let i = 0; i <= divisions; i++){
            const t = i / divisions;
            const o = t * size - hs;
            vertices.set([
                o,
                0,
                -hs,
                o,
                0,
                hs
            ], i * 12);
            vertices.set([
                -hs,
                0,
                o,
                hs,
                0,
                o
            ], i * 12 + 6);
        }
        const geometry = new (0, $38f0c9db74b3b35f$export$2db6c17465f94a2)(gl, {
            position: {
                size: 3,
                data: vertices
            }
        });
        const program = new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(gl, {
            vertex: $fd9277a66b15c5d9$var$vertex,
            fragment: $fd9277a66b15c5d9$var$fragment,
            uniforms: {
                color: {
                    value: color
                }
            }
        });
        super(gl, {
            ...meshProps,
            mode: gl.LINES,
            geometry: geometry,
            program: program
        });
    }
}
const $fd9277a66b15c5d9$var$vertex = /* glsl */ `
attribute vec3 position;
uniform mat4 modelViewMatrix;
uniform mat4 projectionMatrix;

void main() {    
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
`;
const $fd9277a66b15c5d9$var$fragment = /* glsl */ `
precision highp float;
uniform vec3 color;

void main() {    
    gl_FragColor = vec4(color, 1.0);
}
`;







class $1bd765bb7ea25b9c$export$f867298178fd05ef extends (0, $ce267c790a189d7e$export$e176487c05830cc5) {
    constructor(object, { size: size = 0.1, color: color = new (0, $77acc528c45f5d37$export$838423f3adec30fa)(0.86, 0.16, 0.86), ...meshProps } = {}){
        const gl = object.gl;
        const nNormals = object.geometry.attributes.normal.count;
        const positionsArray = new Float32Array(nNormals * 6);
        const normalsArray = new Float32Array(nNormals * 6);
        const sizeArray = new Float32Array(nNormals * 2);
        const normalData = object.geometry.attributes.normal.data;
        const positionData = object.geometry.attributes.position.data;
        const sizeData = new Float32Array([
            0,
            size
        ]);
        for(let i = 0; i < nNormals; i++){
            const i6 = i * 6;
            const i3 = i * 3;
            // duplicate position and normal for line start and end point
            const pSub = positionData.subarray(i3, i3 + 3);
            positionsArray.set(pSub, i6);
            positionsArray.set(pSub, i6 + 3);
            const nSub = normalData.subarray(i3, i3 + 3);
            normalsArray.set(nSub, i6);
            normalsArray.set(nSub, i6 + 3);
            sizeArray.set(sizeData, i * 2);
        }
        const geometry = new (0, $38f0c9db74b3b35f$export$2db6c17465f94a2)(gl, {
            position: {
                size: 3,
                data: positionsArray
            },
            normal: {
                size: 3,
                data: normalsArray
            },
            size: {
                size: 1,
                data: sizeArray
            }
        });
        const program = new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(gl, {
            vertex: $1bd765bb7ea25b9c$var$vertex,
            fragment: $1bd765bb7ea25b9c$var$fragment,
            uniforms: {
                color: {
                    value: color
                },
                worldNormalMatrix: {
                    value: new (0, $bf9227dcdf73dea9$export$83f4edd572c84121)()
                },
                objectWorldMatrix: {
                    value: object.worldMatrix
                }
            }
        });
        super(gl, {
            ...meshProps,
            mode: gl.LINES,
            geometry: geometry,
            program: program
        });
        this.object = object;
    }
    draw(arg) {
        this.program.uniforms.worldNormalMatrix.value.getNormalMatrix(this.object.worldMatrix);
        super.draw(arg);
    }
}
const $1bd765bb7ea25b9c$var$vertex = /* glsl */ `
attribute vec3 position;
attribute vec3 normal;
attribute float size;

uniform mat4 viewMatrix;
uniform mat4 projectionMatrix;
uniform mat4 objectWorldMatrix;
uniform mat3 worldNormalMatrix;

void main() {
    vec3 n = normalize(worldNormalMatrix * normal) * size;
    vec3 p = (objectWorldMatrix * vec4(position, 1.0)).xyz;
    gl_Position = projectionMatrix * viewMatrix * vec4(p + n, 1.0);
}
`;
const $1bd765bb7ea25b9c$var$fragment = /* glsl */ `
precision highp float;
uniform vec3 color;

void main() {    
    gl_FragColor = vec4(color, 1.0);
}
`;







const $b8e5acd92ff35bb4$var$vA = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $b8e5acd92ff35bb4$var$vB = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $b8e5acd92ff35bb4$var$vC = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $b8e5acd92ff35bb4$var$vCenter = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
const $b8e5acd92ff35bb4$var$vNormal = /* @__PURE__ */ new (0, $77acc528c45f5d37$export$838423f3adec30fa)();
class $b8e5acd92ff35bb4$export$55d6e45f87fd74a0 extends (0, $ce267c790a189d7e$export$e176487c05830cc5) {
    constructor(object, { size: size = 0.1, color: color = new (0, $77acc528c45f5d37$export$838423f3adec30fa)(0.15, 0.86, 0.86), ...meshProps } = {}){
        const gl = object.gl;
        const positionData = object.geometry.attributes.position.data;
        const sizeData = new Float32Array([
            0,
            size
        ]);
        const indexAttr = object.geometry.attributes.index;
        const getIndex = indexAttr ? (i)=>indexAttr.data[i] : (i)=>i;
        const numVertices = indexAttr ? indexAttr.data.length : Math.floor(positionData.length / 3);
        const nNormals = Math.floor(numVertices / 3);
        const positionsArray = new Float32Array(nNormals * 6);
        const normalsArray = new Float32Array(nNormals * 6);
        const sizeArray = new Float32Array(nNormals * 2);
        for(let i = 0; i < numVertices; i += 3){
            $b8e5acd92ff35bb4$var$vA.fromArray(positionData, getIndex(i + 0) * 3);
            $b8e5acd92ff35bb4$var$vB.fromArray(positionData, getIndex(i + 1) * 3);
            $b8e5acd92ff35bb4$var$vC.fromArray(positionData, getIndex(i + 2) * 3);
            $b8e5acd92ff35bb4$var$vCenter.add($b8e5acd92ff35bb4$var$vA, $b8e5acd92ff35bb4$var$vB).add($b8e5acd92ff35bb4$var$vC).multiply(1 / 3);
            $b8e5acd92ff35bb4$var$vA.sub($b8e5acd92ff35bb4$var$vA, $b8e5acd92ff35bb4$var$vB);
            $b8e5acd92ff35bb4$var$vC.sub($b8e5acd92ff35bb4$var$vC, $b8e5acd92ff35bb4$var$vB);
            $b8e5acd92ff35bb4$var$vNormal.cross($b8e5acd92ff35bb4$var$vC, $b8e5acd92ff35bb4$var$vA).normalize();
            // duplicate position and normal for line start and end point
            const i2 = i * 2;
            positionsArray.set($b8e5acd92ff35bb4$var$vCenter, i2);
            positionsArray.set($b8e5acd92ff35bb4$var$vCenter, i2 + 3);
            normalsArray.set($b8e5acd92ff35bb4$var$vNormal, i2);
            normalsArray.set($b8e5acd92ff35bb4$var$vNormal, i2 + 3);
            sizeArray.set(sizeData, i / 3 * 2);
        }
        const geometry = new (0, $38f0c9db74b3b35f$export$2db6c17465f94a2)(gl, {
            position: {
                size: 3,
                data: positionsArray
            },
            normal: {
                size: 3,
                data: normalsArray
            },
            size: {
                size: 1,
                data: sizeArray
            }
        });
        const program = new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(gl, {
            vertex: $b8e5acd92ff35bb4$var$vertex,
            fragment: $b8e5acd92ff35bb4$var$fragment,
            uniforms: {
                color: {
                    value: color
                },
                worldNormalMatrix: {
                    value: new (0, $bf9227dcdf73dea9$export$83f4edd572c84121)()
                },
                objectWorldMatrix: {
                    value: object.worldMatrix
                }
            }
        });
        super(gl, {
            ...meshProps,
            mode: gl.LINES,
            geometry: geometry,
            program: program
        });
        this.object = object;
    }
    draw(arg) {
        this.program.uniforms.worldNormalMatrix.value.getNormalMatrix(this.object.worldMatrix);
        super.draw(arg);
    }
}
const $b8e5acd92ff35bb4$var$vertex = /* glsl */ `
attribute vec3 position;
attribute vec3 normal;
attribute float size;

uniform mat4 viewMatrix;
uniform mat4 projectionMatrix;
uniform mat4 objectWorldMatrix;
uniform mat3 worldNormalMatrix;

void main() {
    vec3 n = normalize(worldNormalMatrix * normal) * size;
    vec3 p = (objectWorldMatrix * vec4(position, 1.0)).xyz;
    gl_Position = projectionMatrix * viewMatrix * vec4(p + n, 1.0);
}
`;
const $b8e5acd92ff35bb4$var$fragment = /* glsl */ `
precision highp float;
uniform vec3 color;

void main() {    
    gl_FragColor = vec4(color, 1.0);
}
`;





class $203f3ff12466df40$export$2e2bcd8739ae039 {
    constructor(){
        this.isMobile = (0, $d6dfe69d5b5dbd82$exports.isMobile);
        this.fragment = /* glsl */ `
                precision highp float;

                uniform sampler2D tMap;
                uniform sampler2D tFluid;
                uniform float uTime;
                varying vec2 vUv;

                void main() {
                    vec3 fluid = texture2D(tFluid, vUv).rgb;
                    vec2 uv = vUv - fluid.rg * 0.0002;

                    gl_FragColor = mix( texture2D(tMap, uv), vec4(fluid * 0.1 + 0.0, 1), step(0.0, vUv.x) ) ;

                    // Oscillate between fluid values and the distorted scene
                    //  gl_FragColor = mix(texture2D(tMap, uv), vec4(fluid * 0.1 + 0.5, 1), smoothstep(0.0, 0.7, sin(uTime)));
                }
            `;
        this.baseVertex = /* glsl */ `
                precision highp float;
                attribute vec2 position;
                attribute vec2 uv;
                varying vec2 vUv;
                varying vec2 vL;
                varying vec2 vR;
                varying vec2 vT;
                varying vec2 vB;
                uniform vec2 texelSize;
                void main () {
                    vUv = uv;
                    vL = vUv - vec2(texelSize.x, 0.0);
                    vR = vUv + vec2(texelSize.x, 0.0);
                    vT = vUv + vec2(0.0, texelSize.y);
                    vB = vUv - vec2(0.0, texelSize.y);
                    gl_Position = vec4(position, 0, 1);
                }
            `;
        this.clearShader = /* glsl */ `
                precision mediump float;
                precision mediump sampler2D;
                varying highp vec2 vUv;
                uniform sampler2D uTexture;
                uniform float value;
                void main () {
                    gl_FragColor = value * texture2D(uTexture, vUv);
                }
            `;
        this.splatShader = /* glsl */ `
                precision highp float;
                precision highp sampler2D;
                varying vec2 vUv;
                uniform sampler2D uTarget;
                uniform float aspectRatio;
                uniform vec3 color;
                uniform vec2 point;
                uniform float radius;
                void main () {
                    vec2 p = vUv - point.xy;
                    p.x *= aspectRatio;
                    vec3 splat = exp(-dot(p, p) / radius) * color;
                    vec3 base = texture2D(uTarget, vUv).xyz;
                    gl_FragColor = vec4(base + splat, 1.0);
                }
            `;
        this.advectionManualFilteringShader = /* glsl */ `
                precision highp float;
                precision highp sampler2D;
                varying vec2 vUv;
                uniform sampler2D uVelocity;
                uniform sampler2D uSource;
                uniform vec2 texelSize;
                uniform vec2 dyeTexelSize;
                uniform float dt;
                uniform float dissipation;
                vec4 bilerp (sampler2D sam, vec2 uv, vec2 tsize) {
                    vec2 st = uv / tsize - 0.5;
                    vec2 iuv = floor(st);
                    vec2 fuv = fract(st);
                    vec4 a = texture2D(sam, (iuv + vec2(0.5, 0.5)) * tsize);
                    vec4 b = texture2D(sam, (iuv + vec2(1.5, 0.5)) * tsize);
                    vec4 c = texture2D(sam, (iuv + vec2(0.5, 1.5)) * tsize);
                    vec4 d = texture2D(sam, (iuv + vec2(1.5, 1.5)) * tsize);
                    return mix(mix(a, b, fuv.x), mix(c, d, fuv.x), fuv.y);
                }
                void main () {
                    vec2 coord = vUv - dt * bilerp(uVelocity, vUv, texelSize).xy * texelSize;
                    gl_FragColor = dissipation * bilerp(uSource, coord, dyeTexelSize);
                    gl_FragColor.a = 1.0;
                }
            `;
        this.advectionShader = /* glsl */ `
                precision highp float;
                precision highp sampler2D;
                varying vec2 vUv;
                uniform sampler2D uVelocity;
                uniform sampler2D uSource;
                uniform vec2 texelSize;
                uniform float dt;
                uniform float dissipation;
                void main () {
                    vec2 coord = vUv - dt * texture2D(uVelocity, vUv).xy * texelSize;
                    gl_FragColor = dissipation * texture2D(uSource, coord);
                    gl_FragColor.a = 1.0;
                }
            `;
        this.divergenceShader = /* glsl */ `
                precision mediump float;
                precision mediump sampler2D;
                varying highp vec2 vUv;
                varying highp vec2 vL;
                varying highp vec2 vR;
                varying highp vec2 vT;
                varying highp vec2 vB;
                uniform sampler2D uVelocity;
                void main () {
                    float L = texture2D(uVelocity, vL).x;
                    float R = texture2D(uVelocity, vR).x;
                    float T = texture2D(uVelocity, vT).y;
                    float B = texture2D(uVelocity, vB).y;
                    vec2 C = texture2D(uVelocity, vUv).xy;
                    if (vL.x < 0.0) { L = -C.x; }
                    if (vR.x > 1.0) { R = -C.x; }
                    if (vT.y > 1.0) { T = -C.y; }
                    if (vB.y < 0.0) { B = -C.y; }
                    float div = 0.5 * (R - L + T - B);
                    gl_FragColor = vec4(div, 0.0, 0.0, 1.0);
                }
            `;
        this.curlShader = /* glsl */ `
                precision mediump float;
                precision mediump sampler2D;
                varying highp vec2 vUv;
                varying highp vec2 vL;
                varying highp vec2 vR;
                varying highp vec2 vT;
                varying highp vec2 vB;
                uniform sampler2D uVelocity;
                void main () {
                    float L = texture2D(uVelocity, vL).y;
                    float R = texture2D(uVelocity, vR).y;
                    float T = texture2D(uVelocity, vT).x;
                    float B = texture2D(uVelocity, vB).x;
                    float vorticity = R - L - T + B;
                    gl_FragColor = vec4(0.5 * vorticity, 0.0, 0.0, 1.0);
                }
            `;
        this.vorticityShader = /* glsl */ `
                precision highp float;
                precision highp sampler2D;
                varying vec2 vUv;
                varying vec2 vL;
                varying vec2 vR;
                varying vec2 vT;
                varying vec2 vB;
                uniform sampler2D uVelocity;
                uniform sampler2D uCurl;
                uniform float curl;
                uniform float dt;
                void main () {
                    float L = texture2D(uCurl, vL).x;
                    float R = texture2D(uCurl, vR).x;
                    float T = texture2D(uCurl, vT).x;
                    float B = texture2D(uCurl, vB).x;
                    float C = texture2D(uCurl, vUv).x;
                    vec2 force = 0.5 * vec2(abs(T) - abs(B), abs(R) - abs(L));
                    force /= length(force) + 0.0001;
                    force *= curl * C;
                    force.y *= -1.0;
                    vec2 vel = texture2D(uVelocity, vUv).xy;
                    gl_FragColor = vec4(vel + force * dt, 0.0, 1.0);
                }
            `;
        this.pressureShader = /* glsl */ `
                precision mediump float;
                precision mediump sampler2D;
                varying highp vec2 vUv;
                varying highp vec2 vL;
                varying highp vec2 vR;
                varying highp vec2 vT;
                varying highp vec2 vB;
                uniform sampler2D uPressure;
                uniform sampler2D uDivergence;
                void main () {
                    float L = texture2D(uPressure, vL).x;
                    float R = texture2D(uPressure, vR).x;
                    float T = texture2D(uPressure, vT).x;
                    float B = texture2D(uPressure, vB).x;
                    float C = texture2D(uPressure, vUv).x;
                    float divergence = texture2D(uDivergence, vUv).x;
                    float pressure = (L + R + B + T - divergence) * 0.25;
                    gl_FragColor = vec4(pressure, 0.0, 0.0, 1.0);
                }
            `;
        this.gradientSubtractShader = /* glsl */ `
                precision mediump float;
                precision mediump sampler2D;
                varying highp vec2 vUv;
                varying highp vec2 vL;
                varying highp vec2 vR;
                varying highp vec2 vT;
                varying highp vec2 vB;
                uniform sampler2D uPressure;
                uniform sampler2D uVelocity;
                void main () {
                    float L = texture2D(uPressure, vL).x;
                    float R = texture2D(uPressure, vR).x;
                    float T = texture2D(uPressure, vT).x;
                    float B = texture2D(uPressure, vB).x;
                    vec2 velocity = texture2D(uVelocity, vUv).xy;
                    velocity.xy -= vec2(R - L, T - B);
                    gl_FragColor = vec4(velocity, 0.0, 1.0);
                }
            `;
        // Create a new renderer
        this.renderer = new (0, $9be90720ae75e4ee$export$88530751e3977073)({
            dpr: 2
        });
        this.gl = this.renderer.gl;
        // document.body.appendChild(gl.canvas);
        this.canvas = document.createElement("canvas");
        // set pixel ratio
        this.canvas.width = window.innerWidth * 2;
        this.canvas.height = window.innerHeight * 2;
        this.canvas.style.width = window.innerWidth + "px";
        this.canvas.style.height = window.innerHeight + "px";
        this.ctx = this.canvas.getContext("2d");
        // set context pixel ratio
        // canvas.width = window.innerWidth;
        // canvas.height = window.innerHeight;
        document.body.appendChild(this.canvas);
        this.img = new Image();
        this.newWidth = 0;
        this.newHeight = 0;
        this.topleft = {
            x: 0,
            y: 0
        };
        this.img.onload = ()=>{
            // change the dimension but keep the aspect ratio
            this.newWidth = window.innerWidth * 2;
            this.newHeight = this.newWidth * this.img.height / this.img.width;
            //   calculate the top left position for the image to be centered vertically
            this.topleft.x = 0;
            this.topleft.y = this.canvas.height / 2 - this.newHeight / 2;
        };
        this.img.src = this.isMobile ? window.innerWidth > window.innerHeight ? "./images/mask_green_desk.svg" : "./images/mask_green_mobile.svg" : "./images/mask_green_desk.svg";
        this.gl.clearColor(1, 1, 1, 1);
        this.camera = new (0, $6a03d990fd9755d9$export$79f141de891a5fed)(this.gl, {
            fov: 35
        });
        this.camera.position.set(0, 1, 5);
        this.camera.lookAt([
            0,
            0,
            0
        ]);
        this.post = new (0, $bd1a4acd529d85cb$export$e3cb9ef4a0c00f93)(this.gl);
        window.addEventListener("resize", this.resize.bind(this), false);
        window.addEventListener("orientationchange", this.changeOrientation.bind(this), false);
        this.resize();
        this.lastMouse = new (0, $fee929fe6b903205$export$ac4bca90992eed1)();
        this.lastOrientation = new (0, $fee929fe6b903205$export$ac4bca90992eed1)();
        this.splats = [];
        // Create handlers to get mouse position and velocity
        const isTouchCapable = "ontouchstart" in window;
        if (isTouchCapable) {
            window.addEventListener("touchstart", this.updateMouse.bind(this), false);
            window.addEventListener("touchmove", this.updateMouse.bind(this), false);
            window.addEventListener("deviceorientation", this.updateDeviceOrientation.bind(this));
        } else window.addEventListener("mousemove", this.updateMouse.bind(this), false);
        this.init();
    }
    init() {
        const gl = this.gl;
        // Resolution of simulation
        this.simRes = 128;
        this.dyeRes = 512;
        // Main inputs to control look and feel of fluid
        this.iterations = 3;
        this.densityDissipation = 0.995;
        this.velocityDissipation = 0.98;
        this.pressureDissipation = 0.8;
        this.curlStrength = 20;
        this.radius = 0.2;
        // Common uniform
        const texelSize = {
            value: new (0, $fee929fe6b903205$export$ac4bca90992eed1)(1 / this.simRes)
        };
        // Get supported formats and types for FBOs
        let supportLinearFiltering = gl.renderer.extensions[`OES_texture_${gl.renderer.isWebgl2 ? `` : `half_`}float_linear`];
        const halfFloat = gl.renderer.isWebgl2 ? gl.HALF_FLOAT : gl.renderer.extensions["OES_texture_half_float"].HALF_FLOAT_OES;
        const filtering = supportLinearFiltering ? gl.LINEAR : gl.NEAREST;
        let rgba, rg, r;
        if (gl.renderer.isWebgl2) {
            rgba = this.getSupportedFormat(gl, gl.RGBA16F, gl.RGBA, halfFloat);
            rg = this.getSupportedFormat(gl, gl.RG16F, gl.RG, halfFloat);
            r = this.getSupportedFormat(gl, gl.R16F, gl.RED, halfFloat);
        } else {
            rgba = this.getSupportedFormat(gl, gl.RGBA, gl.RGBA, halfFloat);
            rg = rgba;
            r = rgba;
        }
        // Create fluid simulation FBOs
        this.density = this.createDoubleFBO(gl, {
            width: this.dyeRes,
            height: this.dyeRes,
            type: halfFloat,
            format: rgba?.format,
            internalFormat: rgba?.internalFormat,
            minFilter: filtering,
            depth: false
        });
        this.velocity = this.createDoubleFBO(gl, {
            width: this.simRes,
            height: this.simRes,
            type: halfFloat,
            format: rg?.format,
            internalFormat: rg?.internalFormat,
            minFilter: filtering,
            depth: false
        });
        this.pressure = this.createDoubleFBO(gl, {
            width: this.simRes,
            height: this.simRes,
            type: halfFloat,
            format: r?.format,
            internalFormat: r?.internalFormat,
            minFilter: gl.NEAREST,
            depth: false
        });
        this.divergence = new (0, $4f246b9cc5d577eb$export$efcb1f8bf367cbfb)(gl, {
            width: this.simRes,
            height: this.simRes,
            type: halfFloat,
            format: r?.format,
            internalFormat: r?.internalFormat,
            minFilter: gl.NEAREST,
            depth: false
        });
        this.curl = new (0, $4f246b9cc5d577eb$export$efcb1f8bf367cbfb)(gl, {
            width: this.simRes,
            height: this.simRes,
            type: halfFloat,
            format: r?.format,
            internalFormat: r?.internalFormat,
            minFilter: gl.NEAREST,
            depth: false
        });
        // Geometry to be used for the simulation programs
        const triangle = new (0, $38f0c9db74b3b35f$export$2db6c17465f94a2)(gl, {
            position: {
                size: 2,
                data: new Float32Array([
                    -1,
                    -1,
                    3,
                    -1,
                    -1,
                    3
                ])
            },
            uv: {
                size: 2,
                data: new Float32Array([
                    0,
                    0,
                    2,
                    0,
                    0,
                    2
                ])
            }
        });
        // Create fluid simulation programs
        this.clearProgram = new (0, $ce267c790a189d7e$export$e176487c05830cc5)(gl, {
            geometry: triangle,
            program: new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(gl, {
                vertex: this.baseVertex,
                fragment: this.clearShader,
                uniforms: {
                    texelSize: texelSize,
                    uTexture: {
                        value: null
                    },
                    value: {
                        value: this.pressureDissipation
                    }
                },
                depthTest: false,
                depthWrite: false
            })
        });
        this.splatProgram = new (0, $ce267c790a189d7e$export$e176487c05830cc5)(gl, {
            geometry: triangle,
            program: new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(gl, {
                vertex: this.baseVertex,
                fragment: this.splatShader,
                uniforms: {
                    texelSize: texelSize,
                    uTarget: {
                        value: null
                    },
                    aspectRatio: {
                        value: 1
                    },
                    color: {
                        value: new (0, $b48d3797a6f93803$export$892596cec99bc70e)()
                    },
                    point: {
                        value: new (0, $fee929fe6b903205$export$ac4bca90992eed1)()
                    },
                    radius: {
                        value: 1
                    }
                },
                depthTest: false,
                depthWrite: false
            })
        });
        this.advectionProgram = new (0, $ce267c790a189d7e$export$e176487c05830cc5)(gl, {
            geometry: triangle,
            program: new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(gl, {
                vertex: this.baseVertex,
                fragment: this.supportLinearFiltering ? this.advectionShader : this.advectionManualFilteringShader,
                uniforms: {
                    texelSize: texelSize,
                    dyeTexelSize: {
                        value: new (0, $fee929fe6b903205$export$ac4bca90992eed1)(1 / this.dyeRes, 1 / this.dyeRes)
                    },
                    uVelocity: {
                        value: null
                    },
                    uSource: {
                        value: null
                    },
                    dt: {
                        value: 0.016
                    },
                    dissipation: {
                        value: 1.0
                    }
                },
                depthTest: false,
                depthWrite: false
            })
        });
        this.divergenceProgram = new (0, $ce267c790a189d7e$export$e176487c05830cc5)(gl, {
            geometry: triangle,
            program: new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(gl, {
                vertex: this.baseVertex,
                fragment: this.divergenceShader,
                uniforms: {
                    texelSize: texelSize,
                    uVelocity: {
                        value: null
                    }
                },
                depthTest: false,
                depthWrite: false
            })
        });
        this.curlProgram = new (0, $ce267c790a189d7e$export$e176487c05830cc5)(gl, {
            geometry: triangle,
            program: new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(gl, {
                vertex: this.baseVertex,
                fragment: this.curlShader,
                uniforms: {
                    texelSize: texelSize,
                    uVelocity: {
                        value: null
                    }
                },
                depthTest: false,
                depthWrite: false
            })
        });
        this.vorticityProgram = new (0, $ce267c790a189d7e$export$e176487c05830cc5)(gl, {
            geometry: triangle,
            program: new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(gl, {
                vertex: this.baseVertex,
                fragment: this.vorticityShader,
                uniforms: {
                    texelSize: texelSize,
                    uVelocity: {
                        value: null
                    },
                    uCurl: {
                        value: null
                    },
                    curl: {
                        value: this.curlStrength
                    },
                    dt: {
                        value: 0.016
                    }
                },
                depthTest: false,
                depthWrite: false
            })
        });
        this.pressureProgram = new (0, $ce267c790a189d7e$export$e176487c05830cc5)(gl, {
            geometry: triangle,
            program: new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(gl, {
                vertex: this.baseVertex,
                fragment: this.pressureShader,
                uniforms: {
                    texelSize: texelSize,
                    uPressure: {
                        value: null
                    },
                    uDivergence: {
                        value: null
                    }
                },
                depthTest: false,
                depthWrite: false
            })
        });
        this.gradienSubtractProgram = new (0, $ce267c790a189d7e$export$e176487c05830cc5)(gl, {
            geometry: triangle,
            program: new (0, $5d5fa8f7218537a7$export$b6c59b989905b650)(gl, {
                vertex: this.baseVertex,
                fragment: this.gradientSubtractShader,
                uniforms: {
                    texelSize: texelSize,
                    uPressure: {
                        value: null
                    },
                    uVelocity: {
                        value: null
                    }
                },
                depthTest: false,
                depthWrite: false
            })
        });
        const geometry = new (0, $cdf84c44dd96d576$export$e71c4d32a2263218)(gl);
        this.mesh = new (0, $ce267c790a189d7e$export$e176487c05830cc5)(gl, {
            geometry: geometry,
            program: new (0, $494112e16127e8b6$export$2135f87dba422f95)(gl)
        });
        const fragment = this.fragment;
        this.pass = this.post.addPass({
            fragment: fragment,
            uniforms: {
                tFluid: {
                    value: null
                },
                uTime: {
                    value: 0
                }
            }
        });
        requestAnimationFrame(this.update.bind(this));
    }
    resize() {
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.camera.perspective({
            aspect: this.gl.canvas.width / this.gl.canvas.height
        });
        this.post.resize();
        this.canvas.width = window.innerWidth * 2;
        this.canvas.height = window.innerHeight * 2;
        this.canvas.style.width = window.innerWidth + "px";
        this.canvas.style.height = window.innerHeight + "px";
        this.topleft.y = this.canvas.height / 2 - this.newHeight / 2;
        // change the dimension but keep the aspect ratio
        this.newWidth = window.innerWidth * 2;
        this.newHeight = this.newWidth * this.img.height / this.img.width;
    }
    changeOrientation(e) {
        setTimeout(()=>{
            if (window.innerWidth > window.innerHeight && this.isMobile) this.img.src = "./images/mask_green_desk.svg";
            else this.img.src = "./images/mask_green_mobile.svg";
        }, 100);
    }
    getSupportedFormat(gl, internalFormat, format, type) {
        if (!this.supportRenderTextureFormat(gl, internalFormat, format, type)) switch(internalFormat){
            case gl.R16F:
                return this.getSupportedFormat(gl, gl.RG16F, gl.RG, type);
            case gl.RG16F:
                return this.getSupportedFormat(gl, gl.RGBA16F, gl.RGBA, type);
            default:
                return null;
        }
        return {
            internalFormat: internalFormat,
            format: format
        };
    }
    supportRenderTextureFormat(gl, internalFormat, format, type) {
        let texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texImage2D(gl.TEXTURE_2D, 0, internalFormat, 4, 4, 0, format, type, null);
        let fbo = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, fbo);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
        const status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
        if (status != gl.FRAMEBUFFER_COMPLETE) return false;
        return true;
    }
    createDoubleFBO(gl, { width: width, height: height, wrapS: wrapS, wrapT: wrapT, minFilter: minFilter = gl.LINEAR, magFilter: magFilter = minFilter, type: type, format: format, internalFormat: internalFormat, depth: depth } = {}) {
        const options = {
            width: width,
            height: height,
            wrapS: wrapS,
            wrapT: wrapT,
            minFilter: minFilter,
            magFilter: magFilter,
            type: type,
            format: format,
            internalFormat: internalFormat,
            depth: depth
        };
        const fbo = {
            read: new (0, $4f246b9cc5d577eb$export$efcb1f8bf367cbfb)(gl, options),
            write: new (0, $4f246b9cc5d577eb$export$efcb1f8bf367cbfb)(gl, options),
            swap: ()=>{
                let temp = fbo.read;
                fbo.read = fbo.write;
                fbo.write = temp;
            }
        };
        return fbo;
    }
    updateMouse(e) {
        e.preventDefault();
        if (e.changedTouches && e.changedTouches.length) {
            e.x = e.changedTouches[0].pageX;
            e.y = e.changedTouches[0].pageY;
        }
        if (e.x === undefined) {
            e.x = e.pageX;
            e.y = e.pageY;
        }
        if (!this.lastMouse.isInit) {
            this.lastMouse.isInit = true;
            // First input
            this.lastMouse.set(e.x, e.y);
        }
        const deltaX = e.x - this.lastMouse.x;
        const deltaY = e.y - this.lastMouse.y;
        this.lastMouse.set(e.x, e.y);
        // Add if the mouse is moving
        if (Math.abs(deltaX) || Math.abs(deltaY)) this.splats.push({
            // Get mouse value in 0 to 1 range, with y flipped
            x: e.x / this.gl.renderer.width,
            y: 1.0 - e.y / this.gl.renderer.height,
            dx: deltaX * 5.0,
            dy: deltaY * -5
        });
    }
    updateDeviceOrientation(e) {
        e.preventDefault();
        let gamma = e.gamma || 0; // horizontal tilt, left to right
        let beta = -e.beta * 2 || 0; // vertical tilt, front to back
        if (window.innerWidth > window.innerHeight) {
            gamma = e.beta || 0;
            beta = e.gamma * 2 || 0;
        }
        if (!this.lastOrientation.isInit) {
            this.lastOrientation.isInit = true;
            // First input
            this.lastOrientation.set(gamma, beta);
        }
        const deltaGamma = gamma - this.lastOrientation.x;
        const deltaBeta = beta - this.lastOrientation.y;
        this.lastOrientation.set(gamma, beta);
        // console.log(this.lastOrientation.x, this.lastOrientation.y);
        // Add if the device is moving
        if (Math.abs(deltaGamma) || Math.abs(deltaBeta)) this.splats.push({
            // Get device orientation values in 0 to 1 range
            x: (gamma + 90) / 180,
            y: (beta + 180) / 360,
            dx: deltaGamma * 5.0,
            dy: deltaBeta * -5
        });
    }
    splat({ x: x, y: y, dx: dx, dy: dy }) {
        const gl = this.gl;
        this.splatProgram.program.uniforms.uTarget.value = this.velocity.read.texture;
        this.splatProgram.program.uniforms.aspectRatio.value = gl.renderer.width / gl.renderer.height;
        this.splatProgram.program.uniforms.point.value.set(x, y);
        this.splatProgram.program.uniforms.color.value.set(dx, dx, 1.0);
        this.splatProgram.program.uniforms.radius.value = this.radius / 100.0;
        gl.renderer.render({
            scene: this.splatProgram,
            target: this.velocity.write,
            sort: false,
            update: false
        });
        this.velocity.swap();
        this.splatProgram.program.uniforms.uTarget.value = this.density.read.texture;
        gl.renderer.render({
            scene: this.splatProgram,
            target: this.density.write,
            sort: false,
            update: false
        });
        this.density.swap();
    }
    update(t) {
        requestAnimationFrame(this.update.bind(this));
        const gl = this.gl;
        this.topleft.y = this.canvas.height / 2 - this.newHeight / 2;
        // Perform all of the fluid simulation renders
        // No need to clear during sim, saving a number of GL calls.
        gl.renderer.autoClear = false;
        // Render all of the inputs since last frame
        for(let i = this.splats.length - 1; i >= 0; i--)this.splat(this.splats.splice(i, 1)[0]);
        this.curlProgram.program.uniforms.uVelocity.value = this.velocity.read.texture;
        gl.renderer.render({
            scene: this.curlProgram,
            target: this.curl,
            sort: false,
            update: false
        });
        this.vorticityProgram.program.uniforms.uVelocity.value = this.velocity.read.texture;
        this.vorticityProgram.program.uniforms.uCurl.value = this.curl.texture;
        gl.renderer.render({
            scene: this.vorticityProgram,
            target: this.velocity.write,
            sort: false,
            update: false
        });
        this.velocity.swap();
        this.divergenceProgram.program.uniforms.uVelocity.value = this.velocity.read.texture;
        gl.renderer.render({
            scene: this.divergenceProgram,
            target: this.divergence,
            sort: false,
            update: false
        });
        this.clearProgram.program.uniforms.uTexture.value = this.pressure.read.texture;
        this.clearProgram.program.uniforms.value.value = this.pressureDissipation;
        gl.renderer.render({
            scene: this.clearProgram,
            target: this.pressure.write,
            sort: false,
            update: false
        });
        this.pressure.swap();
        this.pressureProgram.program.uniforms.uDivergence.value = this.divergence.texture;
        for(let i = 0; i < this.iterations; i++){
            this.pressureProgram.program.uniforms.uPressure.value = this.pressure.read.texture;
            gl.renderer.render({
                scene: this.pressureProgram,
                target: this.pressure.write,
                sort: false,
                update: false
            });
            this.pressure.swap();
        }
        this.gradienSubtractProgram.program.uniforms.uPressure.value = this.pressure.read.texture;
        this.gradienSubtractProgram.program.uniforms.uVelocity.value = this.velocity.read.texture;
        gl.renderer.render({
            scene: this.gradienSubtractProgram,
            target: this.velocity.write,
            sort: false,
            update: false
        });
        this.velocity.swap();
        this.advectionProgram.program.uniforms.dyeTexelSize.value.set(1 / this.simRes);
        this.advectionProgram.program.uniforms.uVelocity.value = this.velocity.read.texture;
        this.advectionProgram.program.uniforms.uSource.value = this.velocity.read.texture;
        this.advectionProgram.program.uniforms.dissipation.value = this.velocityDissipation;
        gl.renderer.render({
            scene: this.advectionProgram,
            target: this.velocity.write,
            sort: false,
            update: false
        });
        this.velocity.swap();
        this.advectionProgram.program.uniforms.dyeTexelSize.value.set(1 / this.dyeRes);
        this.advectionProgram.program.uniforms.uVelocity.value = this.velocity.read.texture;
        this.advectionProgram.program.uniforms.uSource.value = this.density.read.texture;
        this.advectionProgram.program.uniforms.dissipation.value = this.densityDissipation;
        gl.renderer.render({
            scene: this.advectionProgram,
            target: this.density.write,
            sort: false,
            update: false
        });
        this.density.swap();
        // Set clear back to default
        gl.renderer.autoClear = true;
        // Update post pass uniform with the simulation output
        this.pass.uniforms.tFluid.value = this.density.read.texture;
        // mesh.rotation.y -= 0.0025;
        // mesh.rotation.x -= 0.005;
        this.pass.uniforms.uTime.value = t * 0.0001;
        const camera = this.camera;
        // console.log(this.mesh);
        // Replace Renderer.render with post.render. Use the same arguments.
        this.post.render({
            scene: this.mesh,
            camera: camera
        });
        // Draw the canvas on top of the post processing
        this.ctx.drawImage(gl.canvas, 0, 0, this.canvas.width, this.canvas.height);
        //   add blend mode to make all white pixels transparent
        //   ctx.globalCompositeOperation = "difference";
        this.ctx.drawImage(this.img, this.topleft.x, this.topleft.y, this.newWidth, this.newHeight);
        //   create mask if needed
        if (this.topleft.y > 0) {
            this.ctx.fillStyle = "#3D4445";
            this.ctx.fillRect(0, 0, this.canvas.width, this.topleft.y + 4);
            this.ctx.fillRect(0, this.topleft.y + this.newHeight - 4, this.canvas.width, this.topleft.y + 8);
        }
    }
}


class $6d2451f9c4d5f362$export$2e2bcd8739ae039 {
    constructor(){
        new (0, $203f3ff12466df40$export$2e2bcd8739ae039)();
        // get link
        document.querySelector(".mail").addEventListener("click", ()=>{
            // open mail
            window.open("mailto:gael.hugo@onemore-studio.com?subject=one%20more%20inquiery&body=one%20more%20hello");
        });
    }
}


window.onload = ()=>{
    new (0, $6d2451f9c4d5f362$export$2e2bcd8739ae039)();
};


//# sourceMappingURL=index.a038e6ea.js.map
